
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("j4cgb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $rECdA = parcelRequire("rECdA");


var $a1L5E = parcelRequire("a1L5E");


var $33LwY = parcelRequire("33LwY");


var $3ePvn = parcelRequire("3ePvn");

var $iBJls = parcelRequire("iBJls");


var $iuuxi = parcelRequire("iuuxi");


var $iZ8sH = parcelRequire("iZ8sH");





var $eq1BO = parcelRequire("eq1BO");


var $3d3WW = parcelRequire("3d3WW");


var $8z22l = parcelRequire("8z22l");

const $fdfccce353823a41$export$3f072f06b90c3985 = 'navigation';
const $fdfccce353823a41$export$fc44104665f4d1e5 = 'GlobalSideNavigation';
const $fdfccce353823a41$export$3b03fceec8e67395 = 'atlaskit';


function $fa495778d00d6098$export$6d30b5ca07993d23(WrappedComponent) {
    return (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.NavigationAnalyticsContext), {
            data: {
                ...$fa495778d00d6098$var$contextData,
                attributes: {
                    screen: props.app || 'unknown'
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, props));
    };
}
const $fa495778d00d6098$export$b46bb3dcfcaed790 = (children, cb)=>{
    const handleOnEvent = (event)=>{
        // Make sure we only listen to click events and fires our event inside the callback function
        event._isUIAnalyticsEvent && event.payload?.action === 'clicked' && cb?.();
    };
    return(// Only listen to events from the ATLASKIT_CHANNEL to narrow down the payloads we receive
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: (0, $fdfccce353823a41$export$3b03fceec8e67395),
        onEvent: handleOnEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8z22l.ElementEventListener), {
        handler: cb
    }, children)));
};
const $fa495778d00d6098$var$packageMetadata = {
    source: 'topNav',
    componentName: (0, $fdfccce353823a41$export$fc44104665f4d1e5),
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $fa495778d00d6098$var$sourceMetadata = {
    navLayer: 'global',
    navContainer: 'top',
    navVersion: '4'
};
const $fa495778d00d6098$var$sideNavMetadata = {
    screen: 'unknown'
};
const $fa495778d00d6098$var$contextData = {
    ...$fa495778d00d6098$var$packageMetadata,
    attributes: {
        ...$fa495778d00d6098$var$sideNavMetadata,
        ...$fa495778d00d6098$var$sourceMetadata
    }
};



var $aibb0 = parcelRequire("aibb0");


var $7RpV7 = parcelRequire("7RpV7");

// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)





























const $644b999b442c4c59$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("7Z7k5")),
    da: ()=>(parcelRequire("69CuO")),
    de: ()=>(parcelRequire("ajKj1")),
    en: ()=>Promise.resolve((parcelRequire("7RpV7"))),
    'en-GB': ()=>(parcelRequire("ayPd0")),
    'en-ZZ': ()=>(parcelRequire("63GWl")),
    es: ()=>(parcelRequire("541WP")),
    fi: ()=>(parcelRequire("9WGpY")),
    fr: ()=>(parcelRequire("v95ts")),
    hr: ()=>(parcelRequire("iYi5G")),
    hu: ()=>(parcelRequire("4dYNh")),
    it: ()=>(parcelRequire("7fQTc")),
    ja: ()=>(parcelRequire("vVwWG")),
    ko: ()=>(parcelRequire("jp0z7")),
    nb: ()=>(parcelRequire("kaPew")),
    nl: ()=>(parcelRequire("jpJaH")),
    pl: ()=>(parcelRequire("kCQFw")),
    'pt-BR': ()=>(parcelRequire("i6Xwr")),
    ru: ()=>(parcelRequire("5PcFo")),
    sl: ()=>(parcelRequire("l8tyG")),
    'sr-RS': ()=>(parcelRequire("ctTTt")),
    'sr-YR': ()=>(parcelRequire("gb0OB")),
    sv: ()=>(parcelRequire("dYI8D")),
    th: ()=>(parcelRequire("dAVB5")),
    tr: ()=>(parcelRequire("g8YNc")),
    uk: ()=>(parcelRequire("gLwiW")),
    vi: ()=>(parcelRequire("bKJwb")),
    zh: ()=>(parcelRequire("7OEgn")),
    'zh-TW': ()=>(parcelRequire("bvtsH"))
};


const $1aad1f3f43cac6ae$export$2f688dfcc031530a = (0, $aibb0.createAsyncIntlProvider)({
    defaultMessages: (0, $7RpV7.default),
    asyncLanguages: $644b999b442c4c59$export$3770c7a7737d463c
});












var $bB0i2 = parcelRequire("bB0i2");





var $cV7Sf = parcelRequire("cV7Sf");


var $9kVQp = parcelRequire("9kVQp");


var $cN3xQ = parcelRequire("cN3xQ");













const $e121db91b5381e5a$export$b709306b005c3ef = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e121db91b5381e5a$export$1238f6fc6d9e005a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function OptionsProvider(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { app: app, appLabel: appLabel, children: children, cloudId: cloudId, customizationStore: customizationStore, defaultMenuVisibility: defaultMenuVisibility, disableMenuCustomization: disableMenuCustomization, hasBottomElement: t1, intlMode: t2, isShortcutsStatic: isShortcutsStatic, l1DragAndDropEnabled: l1DragAndDropEnabled, networkStorageParams: networkStorageParams, userId: userId } = t0;
    const hasBottomElement = t1 === undefined ? false : t1;
    const intlMode = t2 === undefined ? "async" : t2;
    let t3;
    if ($[0] !== app || $[1] !== appLabel || $[2] !== cloudId || $[3] !== customizationStore || $[4] !== defaultMenuVisibility || $[5] !== disableMenuCustomization || $[6] !== hasBottomElement || $[7] !== intlMode || $[8] !== isShortcutsStatic || $[9] !== l1DragAndDropEnabled || $[10] !== networkStorageParams || $[11] !== userId) {
        t3 = {
            app: app,
            appLabel: appLabel,
            cloudId: cloudId,
            customizationStore: customizationStore,
            defaultMenuVisibility: defaultMenuVisibility,
            disableMenuCustomization: disableMenuCustomization,
            hasBottomElement: hasBottomElement,
            intlMode: intlMode,
            isShortcutsStatic: isShortcutsStatic,
            l1DragAndDropEnabled: l1DragAndDropEnabled,
            networkStorageParams: networkStorageParams,
            userId: userId
        };
        $[0] = app;
        $[1] = appLabel;
        $[2] = cloudId;
        $[3] = customizationStore;
        $[4] = defaultMenuVisibility;
        $[5] = disableMenuCustomization;
        $[6] = hasBottomElement;
        $[7] = intlMode;
        $[8] = isShortcutsStatic;
        $[9] = l1DragAndDropEnabled;
        $[10] = networkStorageParams;
        $[11] = userId;
        $[12] = t3;
    } else t3 = $[12];
    const options = t3;
    let t4;
    if ($[13] !== children || $[14] !== options) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e121db91b5381e5a$export$b709306b005c3ef.Provider, {
            value: options
        }, children);
        $[13] = children;
        $[14] = options;
        $[15] = t4;
    } else t4 = $[15];
    return t4;
} : function OptionsProvider({ app: app, appLabel: appLabel, children: children, cloudId: cloudId, customizationStore: customizationStore, defaultMenuVisibility: defaultMenuVisibility, disableMenuCustomization: disableMenuCustomization, hasBottomElement: hasBottomElement = false, intlMode: intlMode = 'async', isShortcutsStatic: isShortcutsStatic, l1DragAndDropEnabled: l1DragAndDropEnabled, networkStorageParams: networkStorageParams, userId: userId }) {
    const options = (0, $cozmU.useMemo)(()=>({
            app: app,
            appLabel: appLabel,
            cloudId: cloudId,
            customizationStore: customizationStore,
            defaultMenuVisibility: defaultMenuVisibility,
            disableMenuCustomization: disableMenuCustomization,
            hasBottomElement: hasBottomElement,
            intlMode: intlMode,
            isShortcutsStatic: isShortcutsStatic,
            l1DragAndDropEnabled: l1DragAndDropEnabled,
            networkStorageParams: networkStorageParams,
            userId: userId
        }), [
        app,
        appLabel,
        cloudId,
        customizationStore,
        defaultMenuVisibility,
        disableMenuCustomization,
        hasBottomElement,
        intlMode,
        isShortcutsStatic,
        l1DragAndDropEnabled,
        networkStorageParams,
        userId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e121db91b5381e5a$export$b709306b005c3ef.Provider, {
        value: options
    }, children);
};
const $e121db91b5381e5a$export$b8ae39f344200a7d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const options = (0, $cozmU.useContext)($e121db91b5381e5a$export$b709306b005c3ef);
    (0, $bB0i2.default)(options, "useOptions must be used inside an initialized OptionsProvider");
    return options;
} : ()=>{
    const options = (0, $cozmU.useContext)($e121db91b5381e5a$export$b709306b005c3ef);
    (0, $bB0i2.default)(options, 'useOptions must be used inside an initialized OptionsProvider');
    return options;
};












var $kSwu1 = parcelRequire("kSwu1");


var $iITVA = parcelRequire("iITVA");

const $f067098bb27d016a$export$f47cf802fb7ac2e6 = 'gsn-for-you';





const $a06c8469dc5f1ffb$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    label: {
        id: "navigation.global-side-navigation.for-you.label",
        defaultMessage: "For you"
    }
});


const $c6c56839cacf10d4$var$elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iITVA))), {
    label: "",
    spacing: "spacious"
});
const $c6c56839cacf10d4$var$NO_FOR_YOU_ITEM = [];
const $c6c56839cacf10d4$export$a2a6512e1bd9d273 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useForYouNavItem(forYou) {
    const $ = (0, $bDgLe.c)(13);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const forYouItem = forYou?.forYouItem;
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $a06c8469dc5f1ffb$export$defe85febe8b728c).label);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    const label = t0;
    let t1;
    if (!forYouItem) t1 = $c6c56839cacf10d4$var$NO_FOR_YOU_ITEM;
    else {
        const t2 = forYouItem?.ItemWrapper;
        let t3;
        if ($[2] !== forYouItem.isSelected || $[3] !== label || $[4] !== t2) {
            t3 = {
                elemBefore: $c6c56839cacf10d4$var$elemBefore,
                isHideable: false,
                isReorderable: false,
                isSelected: forYouItem.isSelected,
                label: label,
                testId: (0, $f067098bb27d016a$export$f47cf802fb7ac2e6),
                ItemWrapper: t2
            };
            $[2] = forYouItem.isSelected;
            $[3] = label;
            $[4] = t2;
            $[5] = t3;
        } else t3 = $[5];
        const common = t3;
        let t4;
        if ($[6] !== common || $[7] !== forYouItem.onClick || $[8] !== forYouItem.url) {
            t4 = forYouItem.url ? {
                type: "link",
                href: forYouItem.url,
                onClick: forYouItem.onClick,
                ...common
            } : {
                type: "button",
                onClick: forYouItem.onClick,
                ...common
            };
            $[6] = common;
            $[7] = forYouItem.onClick;
            $[8] = forYouItem.url;
            $[9] = t4;
        } else t4 = $[9];
        const value = t4;
        const t5 = forYouItem.menuItemId ?? "global.sidebar.forYou";
        let t6;
        if ($[10] !== t5 || $[11] !== value) {
            t6 = [
                [
                    t5,
                    value
                ]
            ];
            $[10] = t5;
            $[11] = value;
            $[12] = t6;
        } else t6 = $[12];
        t1 = t6;
    }
    return t1;
} : function useForYouNavItem(forYou) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // formatMessage() is not a stable function
    // Some type magic so we can get the dependencies right for the memo and keep TypeScript happy.
    const forYouItem = forYou?.forYouItem;
    const label = formatMessage((0, $a06c8469dc5f1ffb$export$defe85febe8b728c).label);
    return (0, $cozmU.useMemo)(()=>{
        if (!forYouItem) return $c6c56839cacf10d4$var$NO_FOR_YOU_ITEM;
        else {
            // Business rule: The forYouItem is not reorderable or hideable.
            const common = {
                elemBefore: $c6c56839cacf10d4$var$elemBefore,
                isHideable: false,
                isReorderable: false,
                isSelected: forYouItem.isSelected,
                label: label,
                testId: (0, $f067098bb27d016a$export$f47cf802fb7ac2e6),
                ItemWrapper: forYouItem?.ItemWrapper
            };
            const value = forYouItem.url ? {
                type: 'link',
                href: forYouItem.url,
                onClick: forYouItem.onClick,
                ...common
            } : {
                type: 'button',
                onClick: forYouItem.onClick,
                ...common
            };
            return [
                [
                    forYouItem.menuItemId ?? 'global.sidebar.forYou',
                    value
                ]
            ];
        }
    }, [
        forYouItem,
        label
    ]);
};









var $gOXu0 = parcelRequire("gOXu0");





const $f218b86c42c7a745$export$f6a46bddb8e1f8d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHydratedShortcuts(rawShortcuts) {
    const $ = (0, $bDgLe.c)(8);
    const { cloudId: cloudId, isShortcutsStatic: isShortcutsStatic, app: app } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    let t0;
    if ($[0] !== app) {
        t0 = {
            location: "use-hydrated-shortcuts",
            sentryConfig: {
                product: app
            },
            disableAnalytics: true
        };
        $[0] = app;
        $[1] = t0;
    } else t0 = $[1];
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)(t0);
    let t1;
    if ($[2] !== app || $[3] !== cloudId || $[4] !== handleError || $[5] !== isShortcutsStatic || $[6] !== rawShortcuts) {
        t1 = {
            shortcutsConfig: rawShortcuts,
            cloudId: cloudId,
            isShortcutsStatic: isShortcutsStatic,
            onError: handleError,
            product: app
        };
        $[2] = app;
        $[3] = cloudId;
        $[4] = handleError;
        $[5] = isShortcutsStatic;
        $[6] = rawShortcuts;
        $[7] = t1;
    } else t1 = $[7];
    return (0, $gOXu0.useGlobalShortcutsDataBFF)(t1);
} : function useHydratedShortcuts(rawShortcuts) {
    const { cloudId: cloudId, isShortcutsStatic: isShortcutsStatic, app: app } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)({
        location: 'use-hydrated-shortcuts',
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: app
        },
        disableAnalytics: true
    });
    return (0, $gOXu0.useGlobalShortcutsDataBFF)({
        shortcutsConfig: rawShortcuts,
        cloudId: cloudId,
        isShortcutsStatic: isShortcutsStatic,
        onError: handleError,
        product: app
    });
};















var $f922E = parcelRequire("f922E");


var $5ZtfK = parcelRequire("5ZtfK");


var $3AVOh = parcelRequire("3AVOh");

const $beafcbdcfa7a52a6$export$d6eadbd047ebd460 = (item, ...properties)=>(0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))(item, ...properties);


const $fb7d272cca940d88$export$cfead128731b1701 = 'gsn-recent';





const $5f32005c5ecf1480$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    label: {
        id: "navigation.global-side-navigation.recents.label",
        defaultMessage: "Recent"
    },
    searchPlaceholder: {
        id: "navigation.global-side-navigation.recentsSearchPlaceholder",
        defaultMessage: "Search recent items"
    },
    viewAllRecentItemsLabel: {
        id: "navigation.global-side-navigation.recents.viewAllRecentsLabel",
        defaultMessage: "View all recent items"
    }
});


const $1cf44396fa0d65ee$var$elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
    label: "",
    spacing: "spacious"
});
const $1cf44396fa0d65ee$export$df1ef6bc89e1ae21 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRecentNavItem(forYou) {
    const $ = (0, $bDgLe.c)(21);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const recentConfig = forYou?.recent;
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $5f32005c5ecf1480$export$defe85febe8b728c).viewAllRecentItemsLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    const viewAllRecentItemsLabel = t0;
    let t1;
    if ($[2] !== formatMessage) {
        t1 = formatMessage((0, $5f32005c5ecf1480$export$defe85febe8b728c).label);
        $[2] = formatMessage;
        $[3] = t1;
    } else t1 = $[3];
    const label = t1;
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage((0, $5f32005c5ecf1480$export$defe85febe8b728c).searchPlaceholder);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    const searchPlaceholder = t2;
    let t3;
    if (!recentConfig) {
        let t4;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = [];
            $[6] = t4;
        } else t4 = $[6];
        t3 = t4;
    } else {
        let t4;
        if ($[7] !== recentConfig.viewAllOnClick || $[8] !== recentConfig.viewAllUrl || $[9] !== viewAllRecentItemsLabel) {
            t4 = recentConfig.viewAllUrl ? [
                {
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                        label: ""
                    }),
                    label: viewAllRecentItemsLabel,
                    href: recentConfig.viewAllUrl,
                    onClick: recentConfig.viewAllOnClick
                }
            ] : recentConfig.viewAllOnClick && [
                {
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                        label: ""
                    }),
                    label: viewAllRecentItemsLabel,
                    onClick: recentConfig.viewAllOnClick
                }
            ];
            $[7] = recentConfig.viewAllOnClick;
            $[8] = recentConfig.viewAllUrl;
            $[9] = viewAllRecentItemsLabel;
            $[10] = t4;
        } else t4 = $[10];
        const actions = t4;
        let t5;
        if ($[11] !== recentConfig) {
            t5 = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(recentConfig, "menuItemId", "viewAllOnClick", "viewAllUrl");
            $[11] = recentConfig;
            $[12] = t5;
        } else t5 = $[12];
        const safeConfig = t5;
        let t6;
        if ($[13] !== actions || $[14] !== label || $[15] !== safeConfig || $[16] !== searchPlaceholder) {
            t6 = {
                ...safeConfig,
                actions: actions,
                elemBefore: $1cf44396fa0d65ee$var$elemBefore,
                label: label,
                searchPlaceholder: searchPlaceholder,
                testId: (0, $fb7d272cca940d88$export$cfead128731b1701),
                type: "object-list-flyout"
            };
            $[13] = actions;
            $[14] = label;
            $[15] = safeConfig;
            $[16] = searchPlaceholder;
            $[17] = t6;
        } else t6 = $[17];
        const value = t6;
        const t7 = recentConfig.menuItemId ?? "global.sidebar.recent";
        let t8;
        if ($[18] !== t7 || $[19] !== value) {
            t8 = [
                [
                    t7,
                    value
                ]
            ];
            $[18] = t7;
            $[19] = value;
            $[20] = t8;
        } else t8 = $[20];
        t3 = t8;
    }
    return t3;
} : function useRecentNavItem(forYou) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // formatMessage() is not a stable function
    const recentConfig = forYou?.recent;
    const viewAllRecentItemsLabel = formatMessage((0, $5f32005c5ecf1480$export$defe85febe8b728c).viewAllRecentItemsLabel);
    const label = formatMessage((0, $5f32005c5ecf1480$export$defe85febe8b728c).label);
    const searchPlaceholder = formatMessage((0, $5f32005c5ecf1480$export$defe85febe8b728c).searchPlaceholder);
    return (0, $cozmU.useMemo)(()=>{
        if (!recentConfig) return [];
        else {
            // This is where we map the forYou config to the ObjectListFlyout config.
            const actions = recentConfig.viewAllUrl ? [
                {
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                        label: ''
                    }),
                    label: viewAllRecentItemsLabel,
                    href: recentConfig.viewAllUrl,
                    onClick: recentConfig.viewAllOnClick
                }
            ] : recentConfig.viewAllOnClick && [
                {
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                        label: ''
                    }),
                    label: viewAllRecentItemsLabel,
                    onClick: recentConfig.viewAllOnClick
                }
            ];
            // Omit the type-props from FlyoutProps that are not used by ObjectListFlyout
            const safeConfig = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(recentConfig, 'menuItemId', 'viewAllOnClick', 'viewAllUrl');
            const value = {
                ...safeConfig,
                actions: actions,
                elemBefore: $1cf44396fa0d65ee$var$elemBefore,
                label: label,
                searchPlaceholder: searchPlaceholder,
                testId: (0, $fb7d272cca940d88$export$cfead128731b1701),
                type: 'object-list-flyout'
            };
            return [
                [
                    recentConfig.menuItemId ?? 'global.sidebar.recent',
                    value
                ]
            ];
        }
    }, [
        label,
        searchPlaceholder,
        viewAllRecentItemsLabel,
        recentConfig
    ]);
};


















var $lbT4j = parcelRequire("lbT4j");


const $78fc01b9f6d45b45$export$d8547b5f8547ae9a = 'gsn-starred';





const $aa4ce361709d4431$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    label: {
        id: "navigation.global-side-navigation.starred.label",
        defaultMessage: "Starred"
    },
    searchPlaceholder: {
        id: "navigation.global-side-navigation.starredSearchPlaceholder",
        defaultMessage: "Search starred items"
    },
    viewAllStarredItemsLabel: {
        id: "navigation.global-side-navigation.starred.viewAllStarredLabel",
        defaultMessage: "View all starred items"
    }
});


const $7a41c5c3831cb40c$var$elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
    label: "",
    spacing: "spacious"
});
const $7a41c5c3831cb40c$export$80b87278b6bf3ebc = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useStarredNavItem(forYou) {
    const $ = (0, $bDgLe.c)(21);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const starredConfig = forYou?.starred;
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $aa4ce361709d4431$export$defe85febe8b728c).viewAllStarredItemsLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    const viewAllStarredItemsLabel = t0;
    let t1;
    if ($[2] !== formatMessage) {
        t1 = formatMessage((0, $aa4ce361709d4431$export$defe85febe8b728c).label);
        $[2] = formatMessage;
        $[3] = t1;
    } else t1 = $[3];
    const label = t1;
    let t2;
    if ($[4] !== formatMessage) {
        t2 = formatMessage((0, $aa4ce361709d4431$export$defe85febe8b728c).searchPlaceholder);
        $[4] = formatMessage;
        $[5] = t2;
    } else t2 = $[5];
    const searchPlaceholder = t2;
    let t3;
    if (!starredConfig) {
        let t4;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = [];
            $[6] = t4;
        } else t4 = $[6];
        t3 = t4;
    } else {
        let t4;
        if ($[7] !== starredConfig.viewAllOnClick || $[8] !== starredConfig.viewAllUrl || $[9] !== viewAllStarredItemsLabel) {
            t4 = starredConfig.viewAllUrl ? [
                {
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                        label: ""
                    }),
                    label: viewAllStarredItemsLabel,
                    href: starredConfig.viewAllUrl,
                    onClick: starredConfig.viewAllOnClick
                }
            ] : starredConfig.viewAllOnClick && [
                {
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                        label: ""
                    }),
                    label: viewAllStarredItemsLabel,
                    onClick: starredConfig.viewAllOnClick
                }
            ];
            $[7] = starredConfig.viewAllOnClick;
            $[8] = starredConfig.viewAllUrl;
            $[9] = viewAllStarredItemsLabel;
            $[10] = t4;
        } else t4 = $[10];
        const actions = t4;
        let t5;
        if ($[11] !== starredConfig) {
            t5 = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(starredConfig, "menuItemId", "viewAllOnClick", "viewAllUrl");
            $[11] = starredConfig;
            $[12] = t5;
        } else t5 = $[12];
        const safeConfig = t5;
        let t6;
        if ($[13] !== actions || $[14] !== label || $[15] !== safeConfig || $[16] !== searchPlaceholder) {
            t6 = {
                ...safeConfig,
                actions: actions,
                elemBefore: $7a41c5c3831cb40c$var$elemBefore,
                label: label,
                searchPlaceholder: searchPlaceholder,
                testId: (0, $78fc01b9f6d45b45$export$d8547b5f8547ae9a),
                type: "object-list-flyout"
            };
            $[13] = actions;
            $[14] = label;
            $[15] = safeConfig;
            $[16] = searchPlaceholder;
            $[17] = t6;
        } else t6 = $[17];
        const value = t6;
        const t7 = starredConfig.menuItemId ?? "global.sidebar.starred";
        let t8;
        if ($[18] !== t7 || $[19] !== value) {
            t8 = [
                [
                    t7,
                    value
                ]
            ];
            $[18] = t7;
            $[19] = value;
            $[20] = t8;
        } else t8 = $[20];
        t3 = t8;
    }
    return t3;
} : function useStarredNavItem(forYou) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // formatMessage() is not a stable function
    const starredConfig = forYou?.starred;
    const viewAllStarredItemsLabel = formatMessage((0, $aa4ce361709d4431$export$defe85febe8b728c).viewAllStarredItemsLabel);
    const label = formatMessage((0, $aa4ce361709d4431$export$defe85febe8b728c).label);
    const searchPlaceholder = formatMessage((0, $aa4ce361709d4431$export$defe85febe8b728c).searchPlaceholder);
    return (0, $cozmU.useMemo)(()=>{
        if (!starredConfig) return [];
        else {
            const actions = starredConfig.viewAllUrl ? [
                {
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                        label: ''
                    }),
                    label: viewAllStarredItemsLabel,
                    href: starredConfig.viewAllUrl,
                    onClick: starredConfig.viewAllOnClick
                }
            ] : starredConfig.viewAllOnClick && [
                {
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                        label: ''
                    }),
                    label: viewAllStarredItemsLabel,
                    onClick: starredConfig.viewAllOnClick
                }
            ];
            // Omit the type-props from FlyoutProps that are not used by ObjectListFlyout
            const safeConfig = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(starredConfig, 'menuItemId', 'viewAllOnClick', 'viewAllUrl');
            const value = {
                ...safeConfig,
                actions: actions,
                elemBefore: $7a41c5c3831cb40c$var$elemBefore,
                label: label,
                searchPlaceholder: searchPlaceholder,
                testId: (0, $78fc01b9f6d45b45$export$d8547b5f8547ae9a),
                type: 'object-list-flyout'
            };
            return [
                [
                    starredConfig.menuItemId ?? 'global.sidebar.starred',
                    value
                ]
            ];
        }
    }, [
        label,
        searchPlaceholder,
        viewAllStarredItemsLabel,
        starredConfig
    ]);
};


const $296fb2d582379b95$export$190be01ed07ba845 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
// Provides all items and shortcuts.
// If these items are truly static, they could be folded into `OptionsProvider` instead.
// If any items are not static, they may need their own context to avoid impacting the consumers of the other items.
const $296fb2d582379b95$var$ItemsAndShortcutsProviderHydrated = (0, $rECdA.componentWithFG)('navx-4606-gas-in-gsn-agg-hydration', $296fb2d582379b95$var$ItemsAndShortcutsProviderAGGHydrated, $296fb2d582379b95$var$ItemsAndShortcutsProviderBFFHydrated);
const $296fb2d582379b95$export$47df1b932a29bc63 = (0, $rECdA.componentWithFG)('navx-4515-jira-gsn-gas-ssr', $296fb2d582379b95$var$ItemsAndShortcutsProviderSSR, $296fb2d582379b95$var$ItemsAndShortcutsProviderHydrated);
const $296fb2d582379b95$var$isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $296fb2d582379b95$var$ItemsAndShortcutsProviderAGGHydrated_optimized(t0) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, forYou: forYou, growthItemShortcuts: growthItemShortcuts, items: items, rawShortcuts: rawShortcuts } = t0;
    const { app: app, cloudId: cloudId, isShortcutsStatic: isShortcutsStatic } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    let t1;
    if ($[0] !== app) {
        t1 = {
            location: "items-and-shortcuts-provider-agg-hydrated",
            sentryConfig: {
                product: app
            },
            disableAnalytics: true
        };
        $[0] = app;
        $[1] = t1;
    } else t1 = $[1];
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)(t1);
    const forYouNavItem = (0, $c6c56839cacf10d4$export$a2a6512e1bd9d273)(forYou);
    const forYouMenuId = forYouNavItem.length ? forYouNavItem[0][0] : "";
    const recentNavItem = (0, $1cf44396fa0d65ee$export$df1ef6bc89e1ae21)(forYou);
    const starredNavItem = (0, $7a41c5c3831cb40c$export$80b87278b6bf3ebc)(forYou);
    let t2;
    if ($[2] !== children || $[3] !== forYouMenuId || $[4] !== forYouNavItem || $[5] !== growthItemShortcuts || $[6] !== items || $[7] !== recentNavItem || $[8] !== starredNavItem) {
        t2 = (shortcuts)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($296fb2d582379b95$var$ItemsAndShortcutsProviderInner, {
                forYouMenuId: forYouMenuId,
                forYouNavItem: forYouNavItem,
                growthItemShortcuts: growthItemShortcuts,
                items: items,
                recentNavItem: recentNavItem,
                shortcuts: shortcuts,
                starredNavItem: starredNavItem
            }, children);
        $[2] = children;
        $[3] = forYouMenuId;
        $[4] = forYouNavItem;
        $[5] = growthItemShortcuts;
        $[6] = items;
        $[7] = recentNavItem;
        $[8] = starredNavItem;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== app || $[11] !== cloudId || $[12] !== handleError || $[13] !== isShortcutsStatic || $[14] !== rawShortcuts || $[15] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9kVQp.default), {
            shortcutsConfig: rawShortcuts,
            cloudId: cloudId,
            isShortcutsStatic: isShortcutsStatic,
            onError: handleError,
            product: app
        }, t2);
        $[10] = app;
        $[11] = cloudId;
        $[12] = handleError;
        $[13] = isShortcutsStatic;
        $[14] = rawShortcuts;
        $[15] = t2;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $296fb2d582379b95$var$ItemsAndShortcutsProviderAGGHydrated_unoptimized({ children: children, forYou: forYou, growthItemShortcuts: growthItemShortcuts, items: items, rawShortcuts: rawShortcuts }) {
    const { app: app, cloudId: cloudId, isShortcutsStatic: isShortcutsStatic } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)({
        location: 'items-and-shortcuts-provider-agg-hydrated',
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: app
        },
        disableAnalytics: true
    });
    const forYouNavItem = (0, $c6c56839cacf10d4$export$a2a6512e1bd9d273)(forYou);
    const forYouMenuId = forYouNavItem.length ? forYouNavItem[0][0] : '';
    const recentNavItem = (0, $1cf44396fa0d65ee$export$df1ef6bc89e1ae21)(forYou);
    const starredNavItem = (0, $7a41c5c3831cb40c$export$80b87278b6bf3ebc)(forYou);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9kVQp.default), {
        shortcutsConfig: rawShortcuts,
        cloudId: cloudId,
        isShortcutsStatic: isShortcutsStatic,
        onError: handleError,
        product: app
    }, (shortcuts)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($296fb2d582379b95$var$ItemsAndShortcutsProviderInner, {
            forYouMenuId: forYouMenuId,
            forYouNavItem: forYouNavItem,
            growthItemShortcuts: growthItemShortcuts,
            items: items,
            recentNavItem: recentNavItem,
            shortcuts: shortcuts,
            starredNavItem: starredNavItem
        }, children));
}
function $296fb2d582379b95$var$ItemsAndShortcutsProviderAGGHydrated(arg0) {
    if ($296fb2d582379b95$var$isReactCompilerActivePlatform_result) return $296fb2d582379b95$var$ItemsAndShortcutsProviderAGGHydrated_optimized(arg0);
    else return $296fb2d582379b95$var$ItemsAndShortcutsProviderAGGHydrated_unoptimized(arg0);
}
const $296fb2d582379b95$var$_isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $296fb2d582379b95$var$ItemsAndShortcutsProviderBFFHydrated_optimized(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { children: children, forYou: forYou, growthItemShortcuts: growthItemShortcuts, items: items, rawShortcuts: rawShortcuts } = t0;
    const forYouNavItem = (0, $c6c56839cacf10d4$export$a2a6512e1bd9d273)(forYou);
    const forYouMenuId = forYouNavItem.length ? forYouNavItem[0][0] : "";
    const recentNavItem = (0, $1cf44396fa0d65ee$export$df1ef6bc89e1ae21)(forYou);
    const starredNavItem = (0, $7a41c5c3831cb40c$export$80b87278b6bf3ebc)(forYou);
    const shortcuts = (0, $f218b86c42c7a745$export$f6a46bddb8e1f8d0)(rawShortcuts);
    let t1;
    if ($[0] !== children || $[1] !== forYouMenuId || $[2] !== forYouNavItem || $[3] !== growthItemShortcuts || $[4] !== items || $[5] !== recentNavItem || $[6] !== shortcuts || $[7] !== starredNavItem) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($296fb2d582379b95$var$ItemsAndShortcutsProviderInner, {
            forYouMenuId: forYouMenuId,
            forYouNavItem: forYouNavItem,
            growthItemShortcuts: growthItemShortcuts,
            items: items,
            recentNavItem: recentNavItem,
            shortcuts: shortcuts,
            starredNavItem: starredNavItem
        }, children);
        $[0] = children;
        $[1] = forYouMenuId;
        $[2] = forYouNavItem;
        $[3] = growthItemShortcuts;
        $[4] = items;
        $[5] = recentNavItem;
        $[6] = shortcuts;
        $[7] = starredNavItem;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
}
function $296fb2d582379b95$var$ItemsAndShortcutsProviderBFFHydrated_unoptimized({ children: children, forYou: forYou, growthItemShortcuts: growthItemShortcuts, items: items, rawShortcuts: rawShortcuts }) {
    const forYouNavItem = (0, $c6c56839cacf10d4$export$a2a6512e1bd9d273)(forYou);
    const forYouMenuId = forYouNavItem.length ? forYouNavItem[0][0] : '';
    const recentNavItem = (0, $1cf44396fa0d65ee$export$df1ef6bc89e1ae21)(forYou);
    const starredNavItem = (0, $7a41c5c3831cb40c$export$80b87278b6bf3ebc)(forYou);
    const shortcuts = (0, $f218b86c42c7a745$export$f6a46bddb8e1f8d0)(rawShortcuts);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($296fb2d582379b95$var$ItemsAndShortcutsProviderInner, {
        forYouMenuId: forYouMenuId,
        forYouNavItem: forYouNavItem,
        growthItemShortcuts: growthItemShortcuts,
        items: items,
        recentNavItem: recentNavItem,
        shortcuts: shortcuts,
        starredNavItem: starredNavItem
    }, children);
}
function $296fb2d582379b95$var$ItemsAndShortcutsProviderBFFHydrated(arg0) {
    if ($296fb2d582379b95$var$_isReactCompilerActivePlatform_result) return $296fb2d582379b95$var$ItemsAndShortcutsProviderBFFHydrated_optimized(arg0);
    else return $296fb2d582379b95$var$ItemsAndShortcutsProviderBFFHydrated_unoptimized(arg0);
}
const $296fb2d582379b95$export$68ff8f5dbbf3b8af = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useItemsAndShortcuts() {
    const itemsAndShortcuts = (0, $cozmU.useContext)($296fb2d582379b95$export$190be01ed07ba845);
    (0, $bB0i2.default)(itemsAndShortcuts, "useItemsAndShortcuts must be used inside an initialized ItemsAndShortcutsProvider");
    return itemsAndShortcuts;
} : function useItemsAndShortcuts() {
    const itemsAndShortcuts = (0, $cozmU.useContext)($296fb2d582379b95$export$190be01ed07ba845);
    (0, $bB0i2.default)(itemsAndShortcuts, 'useItemsAndShortcuts must be used inside an initialized ItemsAndShortcutsProvider');
    return itemsAndShortcuts;
};
const $296fb2d582379b95$var$_isReactCompilerActivePlatform_result2 = (0, $gtMdU.isReactCompilerActivePlatform)();
function $296fb2d582379b95$var$ItemsAndShortcutsProviderSSR_optimized(props) {
    const $ = (0, $bDgLe.c)(5);
    const { networkStorageParams: networkStorageParams } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const queryRef = networkStorageParams?.queryRef;
    if (queryRef) {
        let t0;
        if ($[0] !== props || $[1] !== queryRef) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($296fb2d582379b95$var$ItemsAndShortcutsProviderWithQueryRef, {
                ...props,
                queryRef: queryRef
            });
            $[0] = props;
            $[1] = queryRef;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    let t0;
    if ($[3] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($296fb2d582379b95$var$ItemsAndShortcutsProviderHydrated, props);
        $[3] = props;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
}
function $296fb2d582379b95$var$ItemsAndShortcutsProviderSSR_unoptimized(props) {
    const { networkStorageParams: networkStorageParams } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const queryRef = networkStorageParams?.queryRef;
    if (queryRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($296fb2d582379b95$var$ItemsAndShortcutsProviderWithQueryRef, {
        ...props,
        queryRef: queryRef
    });
    // if no queryRef provided, fallback to the hydrated version for GAS data
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($296fb2d582379b95$var$ItemsAndShortcutsProviderHydrated, props);
}
function $296fb2d582379b95$var$ItemsAndShortcutsProviderSSR(arg0) {
    if ($296fb2d582379b95$var$_isReactCompilerActivePlatform_result2) return $296fb2d582379b95$var$ItemsAndShortcutsProviderSSR_optimized(arg0);
    else return $296fb2d582379b95$var$ItemsAndShortcutsProviderSSR_unoptimized(arg0);
}
const $296fb2d582379b95$var$ItemsAndShortcutsProviderWithQueryRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ItemsAndShortcutsProviderWithQueryRef(t0) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, forYou: forYou, growthItemShortcuts: growthItemShortcuts, items: items, rawShortcuts: rawShortcuts, queryRef: queryRef } = t0;
    const { app: app, cloudId: cloudId, isShortcutsStatic: isShortcutsStatic } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const forYouNavItem = (0, $c6c56839cacf10d4$export$a2a6512e1bd9d273)(forYou);
    const forYouMenuId = forYouNavItem.length ? forYouNavItem[0][0] : "";
    const recentNavItem = (0, $1cf44396fa0d65ee$export$df1ef6bc89e1ae21)(forYou);
    const starredNavItem = (0, $7a41c5c3831cb40c$export$80b87278b6bf3ebc)(forYou);
    let t1;
    if ($[0] !== app) {
        t1 = {
            location: "use-ssr-shortcuts",
            sentryConfig: {
                product: app
            },
            disableAnalytics: true
        };
        $[0] = app;
        $[1] = t1;
    } else t1 = $[1];
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)(t1);
    let t2;
    if ($[2] !== cloudId || $[3] !== handleError || $[4] !== isShortcutsStatic || $[5] !== queryRef || $[6] !== rawShortcuts) {
        t2 = {
            cloudId: cloudId,
            onError: handleError,
            queryRef: queryRef,
            isShortcutsStatic: isShortcutsStatic,
            shortcutsConfig: rawShortcuts
        };
        $[2] = cloudId;
        $[3] = handleError;
        $[4] = isShortcutsStatic;
        $[5] = queryRef;
        $[6] = rawShortcuts;
        $[7] = t2;
    } else t2 = $[7];
    const shortcuts = (0, $cV7Sf.useGlobalShortcutsDataRelay)(t2);
    let t3;
    if ($[8] !== children || $[9] !== forYouMenuId || $[10] !== forYouNavItem || $[11] !== growthItemShortcuts || $[12] !== items || $[13] !== recentNavItem || $[14] !== shortcuts || $[15] !== starredNavItem) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($296fb2d582379b95$var$ItemsAndShortcutsProviderInner, {
            forYouMenuId: forYouMenuId,
            forYouNavItem: forYouNavItem,
            growthItemShortcuts: growthItemShortcuts,
            items: items,
            recentNavItem: recentNavItem,
            shortcuts: shortcuts,
            starredNavItem: starredNavItem
        }, children);
        $[8] = children;
        $[9] = forYouMenuId;
        $[10] = forYouNavItem;
        $[11] = growthItemShortcuts;
        $[12] = items;
        $[13] = recentNavItem;
        $[14] = shortcuts;
        $[15] = starredNavItem;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : function ItemsAndShortcutsProviderWithQueryRef({ children: children, forYou: forYou, growthItemShortcuts: growthItemShortcuts, items: items, rawShortcuts: rawShortcuts, queryRef: queryRef }) {
    const { app: app, cloudId: cloudId, isShortcutsStatic: isShortcutsStatic } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const forYouNavItem = (0, $c6c56839cacf10d4$export$a2a6512e1bd9d273)(forYou);
    const forYouMenuId = forYouNavItem.length ? forYouNavItem[0][0] : '';
    const recentNavItem = (0, $1cf44396fa0d65ee$export$df1ef6bc89e1ae21)(forYou);
    const starredNavItem = (0, $7a41c5c3831cb40c$export$80b87278b6bf3ebc)(forYou);
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)({
        location: 'use-ssr-shortcuts',
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: app
        },
        disableAnalytics: true
    });
    const shortcuts = (0, $cV7Sf.useGlobalShortcutsDataRelay)({
        cloudId: cloudId,
        onError: handleError,
        queryRef: queryRef,
        isShortcutsStatic: isShortcutsStatic,
        shortcutsConfig: rawShortcuts
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($296fb2d582379b95$var$ItemsAndShortcutsProviderInner, {
        forYouMenuId: forYouMenuId,
        forYouNavItem: forYouNavItem,
        growthItemShortcuts: growthItemShortcuts,
        items: items,
        recentNavItem: recentNavItem,
        shortcuts: shortcuts,
        starredNavItem: starredNavItem
    }, children);
};
const $296fb2d582379b95$var$ItemsAndShortcutsProviderInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ItemsAndShortcutsProviderInner(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { children: children, forYouMenuId: forYouMenuId, forYouNavItem: forYouNavItem, growthItemShortcuts: growthItemShortcuts, items: items, recentNavItem: recentNavItem, shortcuts: shortcuts, starredNavItem: starredNavItem } = t0;
    let globalItems;
    let t1;
    if ($[0] !== forYouNavItem || $[1] !== recentNavItem || $[2] !== starredNavItem) {
        globalItems = new Map([
            ...forYouNavItem,
            ...recentNavItem,
            ...starredNavItem
        ]);
        t1 = Object.fromEntries(globalItems);
        $[0] = forYouNavItem;
        $[1] = recentNavItem;
        $[2] = starredNavItem;
        $[3] = globalItems;
        $[4] = t1;
    } else {
        globalItems = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== items || $[6] !== t1) {
        t2 = {
            ...t1,
            ...items
        };
        $[5] = items;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    const allItems = t2;
    let t3;
    if ($[8] !== allItems || $[9] !== forYouMenuId || $[10] !== globalItems || $[11] !== growthItemShortcuts || $[12] !== items || $[13] !== shortcuts) {
        t3 = {
            allItems: allItems,
            forYouMenuId: forYouMenuId,
            globalItems: globalItems,
            growthItemShortcuts: growthItemShortcuts,
            items: items,
            shortcuts: shortcuts
        };
        $[8] = allItems;
        $[9] = forYouMenuId;
        $[10] = globalItems;
        $[11] = growthItemShortcuts;
        $[12] = items;
        $[13] = shortcuts;
        $[14] = t3;
    } else t3 = $[14];
    const itemsAndShortcuts = t3;
    let t4;
    if ($[15] !== children || $[16] !== itemsAndShortcuts) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($296fb2d582379b95$export$190be01ed07ba845.Provider, {
            value: itemsAndShortcuts
        }, children);
        $[15] = children;
        $[16] = itemsAndShortcuts;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
} : function ItemsAndShortcutsProviderInner({ children: children, forYouMenuId: forYouMenuId, forYouNavItem: forYouNavItem, growthItemShortcuts: growthItemShortcuts, items: items, recentNavItem: recentNavItem, shortcuts: shortcuts, starredNavItem: starredNavItem }) {
    const itemsAndShortcuts = (0, $cozmU.useMemo)(()=>{
        const globalItems = new Map([
            ...forYouNavItem,
            ...recentNavItem,
            ...starredNavItem
        ]);
        const allItems = {
            ...Object.fromEntries(globalItems),
            ...items
        };
        return {
            allItems: allItems,
            forYouMenuId: forYouMenuId,
            globalItems: globalItems,
            growthItemShortcuts: growthItemShortcuts,
            items: items,
            shortcuts: shortcuts
        };
    }, [
        forYouNavItem,
        forYouMenuId,
        recentNavItem,
        starredNavItem,
        items,
        growthItemShortcuts,
        shortcuts
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($296fb2d582379b95$export$190be01ed07ba845.Provider, {
        value: itemsAndShortcuts
    }, children);
};













var $jEK83 = parcelRequire("jEK83");

const $e462797418f11995$export$390c771b9e3f4124 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e462797418f11995$export$4146a0b5f40d20d7 = /*#__PURE__*/ (0, $cozmU.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($jEK83))));
const $e462797418f11995$export$5d097184c0f78e68 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e462797418f11995$export$390c771b9e3f4124);
} : ()=>(0, $cozmU.useContext)($e462797418f11995$export$390c771b9e3f4124);
const $e462797418f11995$export$a90578dce3c14324 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e462797418f11995$export$4146a0b5f40d20d7);
} : ()=>(0, $cozmU.useContext)($e462797418f11995$export$4146a0b5f40d20d7);
const $e462797418f11995$export$781f6b5709acd16f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, value: value } = t0;
    const [peekMenuId, setPeekMenuId] = (0, $cozmU.useState)(value);
    let t1;
    if ($[0] !== value) {
        t1 = {
            setPeekMenuId: setPeekMenuId,
            value: value
        };
        $[0] = value;
        $[1] = t1;
    } else t1 = $[1];
    $e462797418f11995$var$useCustomSyncState(t1);
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e462797418f11995$export$4146a0b5f40d20d7.Provider, {
            value: setPeekMenuId
        }, children);
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== peekMenuId || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e462797418f11995$export$390c771b9e3f4124.Provider, {
            value: peekMenuId
        }, t2);
        $[4] = peekMenuId;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, value: value })=>{
    // There are two ways for `peekMenuId` to change.
    // One is if the `peekMenuId` prop (i.e. `value`) changes, likely due to a route change.
    // The other is internally via `setPeekMenuId`, e.g. the more menu.
    // Each will override the other, the last one to change/call will be the current state.
    const [peekMenuId, setPeekMenuId] = (0, $cozmU.useState)(value);
    // Once FG is cleaned up, inline this hook
    $e462797418f11995$var$useCustomSyncState({
        setPeekMenuId: setPeekMenuId,
        value: value
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e462797418f11995$export$390c771b9e3f4124.Provider, {
        value: peekMenuId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e462797418f11995$export$4146a0b5f40d20d7.Provider, {
        value: setPeekMenuId
    }, children));
};
// Sync peekMenuId with the prop during render instead of in a layout effect.
// This avoids hydration mismatches and the useLayoutEffect SSR warning.
// See: https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
function $e462797418f11995$var$useCustomSyncState({ setPeekMenuId: setPeekMenuId, value: value }) {
    const prevValue = (0, $cozmU.useRef)(value);
    if (value !== prevValue.current) {
        prevValue.current = value;
        (0, $cozmU.startTransition)(()=>{
            setPeekMenuId(value);
        });
    }
}


const $2d74423a888dfe57$export$5678faf50a8e9276 = 'global-side-nav-test-id';
const $2d74423a888dfe57$export$88dd4a9e4ffa4ec2 = 'gsn-peek';
const $2d74423a888dfe57$export$ee2a9579670b9420 = 'gsn-global-shortcuts';
const $2d74423a888dfe57$export$7a48056dfdcb252d = 'globalSideNavigationLoad';
const $2d74423a888dfe57$export$74a97a85614272ea = 'global-side-navigation-load';









var $hekY6 = parcelRequire("hekY6");








var $jsuJ9 = parcelRequire("jsuJ9");

var $eCqXP = parcelRequire("eCqXP");

var $4oUV5 = parcelRequire("4oUV5");

var $jHtN7 = parcelRequire("jHtN7");

var $kynDG = parcelRequire("kynDG");


var $1fHIr = parcelRequire("1fHIr");


var $jYwSK = parcelRequire("jYwSK");


var $ixfCV = parcelRequire("ixfCV");


var $1PREo = parcelRequire("1PREo");




const $30471b5642640511$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    panelSplitterLabel: {
        id: "navigation.global-side-navigation.panel-splitter.label",
        defaultMessage: "Resize panel"
    },
    panelSplitterTooltipContent: {
        id: "navigation.global-side-navigation.panel-splitter.tooltip-content",
        defaultMessage: "Double click to collapse"
    }
});


const $409e78b28aeb95f3$var$footerStyles = {
    hideWhenEmpty: "_196xglyw"
}; /**
    * SideNavigationLayout - A layout component that provides a side navigation structure.
    *
    * This component is designed to be used as a wrapper for the side navigation system,
    * providing a consistent layout with header, content, and footer sections.
    * This is a controlled and will not manage any state internally.
    *
    * If you need state management, analytics, or supporting Drag and Drop
    * please consider using the `GlobalSideNavigation` component instead.
    *
    * Props:
    * - bottomElem: Element to render at the bottom of the side navigation.
    * - children: Main content of the side navigation layout.
    * - defaultCollapsed: Whether the side nav is collapsed by default.
    * - defaultWidth: Default width of the side nav.
    * - onCollapse: Callback when the side nav is collapsed.
    * - onExpand: Callback when the side nav is expanded.
    * - onResizeEnd: Callback when the resize of the side nav ends.
    * - onResizeStart: Callback when the resize of the side nav starts.
    * - postMainElem: Element to render after the main content.
    * - preMainElem: Element to render before the main content.
    * - sideNavContentRef: Ref for the SideNavBody component.
    * - testId: Optional test identifier for testing purposes.
    *
    */ 
const $409e78b28aeb95f3$export$610d5f09b69fac71 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SideNavigationLayout(t0) {
    const $ = (0, $bDgLe.c)(29);
    const { preMainElem: preMainElem, postMainElem: postMainElem, bottomElem: bottomElem, children: children, testId: testId, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, defaultWidth: defaultWidth, defaultCollapsed: defaultCollapsed, sideNavContentRef: sideNavContentRef } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const shouldRenderTopLevelSpacer = Boolean(children && postMainElem);
    let t1;
    if ($[0] !== preMainElem) {
        t1 = preMainElem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kynDG.SideNavHeader), null, preMainElem);
        $[0] = preMainElem;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== shouldRenderTopLevelSpacer) {
        t2 = shouldRenderTopLevelSpacer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PREo.TopLevelSpacer), null) : null;
        $[2] = shouldRenderTopLevelSpacer;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== children || $[5] !== postMainElem || $[6] !== sideNavContentRef || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4oUV5.SideNavBody), {
            ref: sideNavContentRef
        }, children, t2, postMainElem);
        $[4] = children;
        $[5] = postMainElem;
        $[6] = sideNavContentRef;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== formatMessage) {
        t4 = formatMessage((0, $30471b5642640511$export$defe85febe8b728c).panelSplitterLabel);
        $[9] = formatMessage;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== onResizeEnd || $[12] !== onResizeStart || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($409e78b28aeb95f3$var$PanelSplitterWithFG, {
            onResizeEnd: onResizeEnd,
            onResizeStart: onResizeStart,
            label: t4
        });
        $[11] = onResizeEnd;
        $[12] = onResizeStart;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== bottomElem) {
        t6 = bottomElem && ((0, $ixfCV.fg)("ui-sidenav-footer-underline-fix") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $409e78b28aeb95f3$var$footerStyles.hideWhenEmpty
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jHtN7.SideNavFooter), null, bottomElem)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jHtN7.SideNavFooter), null, bottomElem));
        $[15] = bottomElem;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== defaultCollapsed || $[18] !== defaultWidth || $[19] !== onCollapse || $[20] !== onExpand || $[21] !== onPeekEnd || $[22] !== onPeekStart || $[23] !== t1 || $[24] !== t3 || $[25] !== t5 || $[26] !== t6 || $[27] !== testId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCqXP.SideNav), {
            testId: testId,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            defaultWidth: defaultWidth,
            defaultCollapsed: defaultCollapsed
        }, t1, t3, t5, t6);
        $[17] = defaultCollapsed;
        $[18] = defaultWidth;
        $[19] = onCollapse;
        $[20] = onExpand;
        $[21] = onPeekEnd;
        $[22] = onPeekStart;
        $[23] = t1;
        $[24] = t3;
        $[25] = t5;
        $[26] = t6;
        $[27] = testId;
        $[28] = t7;
    } else t7 = $[28];
    return t7;
} : function SideNavigationLayout({ preMainElem: preMainElem, postMainElem: postMainElem, bottomElem: bottomElem, children: children, testId: testId, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, defaultWidth: defaultWidth, defaultCollapsed: defaultCollapsed, sideNavContentRef: sideNavContentRef }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // only render the top level spacer if the there is content in the children and postMainElem
    const shouldRenderTopLevelSpacer = Boolean(children && postMainElem);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCqXP.SideNav), {
        testId: testId,
        onExpand: onExpand,
        onCollapse: onCollapse,
        onPeekStart: onPeekStart,
        onPeekEnd: onPeekEnd,
        defaultWidth: defaultWidth,
        defaultCollapsed: defaultCollapsed
    }, preMainElem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kynDG.SideNavHeader), null, preMainElem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4oUV5.SideNavBody), {
        ref: sideNavContentRef
    }, children, shouldRenderTopLevelSpacer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1PREo.TopLevelSpacer), null) : null, postMainElem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($409e78b28aeb95f3$var$PanelSplitterWithFG, {
        onResizeEnd: onResizeEnd,
        onResizeStart: onResizeStart,
        label: formatMessage((0, $30471b5642640511$export$defe85febe8b728c).panelSplitterLabel)
    }), bottomElem && ((0, $ixfCV.fg)('ui-sidenav-footer-underline-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $409e78b28aeb95f3$var$footerStyles.hideWhenEmpty
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jHtN7.SideNavFooter), null, bottomElem)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jHtN7.SideNavFooter), null, bottomElem)));
};
const $409e78b28aeb95f3$var$PanelSplitterWithFG = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelSplitterWithFG(props) {
    const $ = (0, $bDgLe.c)(7);
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (isFhsEnabled) {
        let t0;
        if ($[0] !== formatMessage) {
            t0 = formatMessage((0, $30471b5642640511$export$defe85febe8b728c).panelSplitterTooltipContent);
            $[0] = formatMessage;
            $[1] = t0;
        } else t0 = $[1];
        let t1;
        if ($[2] !== props || $[3] !== t0) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNavPanelSplitter), {
                ...props,
                tooltipContent: t0
            });
            $[2] = props;
            $[3] = t0;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    let t0;
    if ($[5] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsuJ9.PanelSplitter), props);
        $[5] = props;
        $[6] = t0;
    } else t0 = $[6];
    return t0;
} : function PanelSplitterWithFG(props) {
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (isFhsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNavPanelSplitter), {
        ...props,
        tooltipContent: formatMessage((0, $30471b5642640511$export$defe85febe8b728c).panelSplitterTooltipContent)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jsuJ9.PanelSplitter), props);
};





const $cab7c374856f434c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    header: {
        id: "navigation.global-side-navigation.error.header",
        defaultMessage: "We couldn\u2019t load the sidebar"
    },
    description: {
        id: "navigation.global-side-navigation.error.description",
        defaultMessage: "Refresh the page and try again"
    }
});































var $9DHhW = parcelRequire("9DHhW");


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::104fd57c141a6ef812e2ef73c24c1bba>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen global-side-navigation
 */ const $7f53529130fb16e5$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $7f53529130fb16e5$export$2e2bcd8739ae039 = $7f53529130fb16e5$var$createEventPayload;


const $19ead867f45fce96$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $7f53529130fb16e5$export$2e2bcd8739ae039)(...params));
            event.fire((0, $fdfccce353823a41$export$3f072f06b90c3985));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $7f53529130fb16e5$export$2e2bcd8739ae039)(...params));
        event.fire((0, $fdfccce353823a41$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};


const $ca52779d04788c52$export$42cf6fc952b8bebd = 'nav-platform-sidebar-state';
const $ca52779d04788c52$export$f1259eef323ff984 = 'defaultCollapsed';
const $ca52779d04788c52$export$5ec229a880d48b06 = 'defaultWidth';
const $ca52779d04788c52$export$5716e8bcb003888d = 100;


const $52bd86db4e06f18b$var$nullState = {
    userSideNavData: {
        defaultWidth: undefined,
        defaultCollapsed: undefined
    },
    userMenuData: []
};
// Allow the key to be extended (by adding a prefix or suffix)
let $52bd86db4e06f18b$var$LS_KEY = (0, $ca52779d04788c52$export$42cf6fc952b8bebd);
const $52bd86db4e06f18b$export$4714a0d7e8941053 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useLocalSideNavUserData(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { app: app } = t0;
    $52bd86db4e06f18b$var$setLocalStorageKey(app);
    const { fireEvent: fireEvent } = (0, $19ead867f45fce96$export$5bf35293e545f20c)();
    let t1;
    if ($[0] !== fireEvent) {
        t1 = $52bd86db4e06f18b$var$reducerWithAnalytics(fireEvent);
        $[0] = fireEvent;
        $[1] = t1;
    } else t1 = $[1];
    const reducer = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = $52bd86db4e06f18b$var$getInitialState();
        $[2] = t2;
    } else t2 = $[2];
    const [sideNavState, setSideNavState] = (0, $cozmU.useReducer)(reducer, t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (userMenuData)=>{
            setSideNavState({
                userMenuData: userMenuData
            });
        };
        $[3] = t3;
    } else t3 = $[3];
    const setUserMenuData = t3;
    let t4;
    if ($[4] !== sideNavState) {
        t4 = (userSideNavData)=>{
            setSideNavState({
                userSideNavData: {
                    ...sideNavState.userSideNavData,
                    ...userSideNavData
                }
            });
        };
        $[4] = sideNavState;
        $[5] = t4;
    } else t4 = $[5];
    const setUserSideNavData = t4;
    let t5;
    if ($[6] !== setUserSideNavData || $[7] !== sideNavState) {
        t5 = {
            ...sideNavState,
            setUserMenuData: setUserMenuData,
            setUserSideNavData: setUserSideNavData
        };
        $[6] = setUserSideNavData;
        $[7] = sideNavState;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : function useLocalSideNavUserData({ app: app }) {
    $52bd86db4e06f18b$var$setLocalStorageKey(app);
    const { fireEvent: fireEvent } = (0, $19ead867f45fce96$export$5bf35293e545f20c)();
    const reducer = $52bd86db4e06f18b$var$reducerWithAnalytics(fireEvent);
    const [sideNavState, setSideNavState] = (0, $cozmU.useReducer)(reducer, $52bd86db4e06f18b$var$getInitialState());
    const setUserMenuData = (0, $cozmU.useCallback)((userMenuData)=>{
        setSideNavState({
            userMenuData: userMenuData
        });
    }, []);
    const setUserSideNavData = (0, $cozmU.useCallback)((userSideNavData)=>{
        setSideNavState({
            userSideNavData: {
                ...sideNavState.userSideNavData,
                ...userSideNavData
            }
        });
    }, [
        sideNavState
    ]);
    return {
        ...sideNavState,
        setUserMenuData: setUserMenuData,
        setUserSideNavData: setUserSideNavData
    };
};
function $52bd86db4e06f18b$var$setLocalStorageKey(suffix) {
    $52bd86db4e06f18b$var$LS_KEY = [
        (0, $ca52779d04788c52$export$42cf6fc952b8bebd),
        suffix
    ].join('-');
}
function $52bd86db4e06f18b$var$getInitialState() {
    // Guard against SSR — localStorage is not available on the server.
    if (typeof window === 'undefined') return $52bd86db4e06f18b$var$nullState;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const storedState = $52bd86db4e06f18b$var$parseLocalStorageState(localStorage.getItem($52bd86db4e06f18b$var$LS_KEY));
    if (storedState) return storedState;
    try {
        $52bd86db4e06f18b$var$setLocalStorageState($52bd86db4e06f18b$var$nullState);
    } catch (error) {
        // If localStorage fails during initialization, just continue with nullState
        // eslint-disable-next-line no-console
        console.warn('Failed to initialize localStorage state:', error);
    }
    return $52bd86db4e06f18b$var$nullState;
}
function $52bd86db4e06f18b$var$reducerWithAnalytics(fireEvent) {
    return (state, payload)=>{
        try {
            const newState = {
                ...state,
                ...payload
            };
            // Update localStorage with the new state
            $52bd86db4e06f18b$var$setLocalStorageState(newState);
            fireEvent('operational.executeMutation.succeeded', {
                storage: 'local'
            });
            return newState;
        } catch (error) {
            fireEvent('operational.executeMutation.failed', {
                storage: 'local',
                error: error instanceof Error ? error.message : String(error) ?? 'Unknown error'
            });
            // Return the previous state if the update failed
            return state;
        }
    };
}
function $52bd86db4e06f18b$var$setLocalStorageState(state) {
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem($52bd86db4e06f18b$var$LS_KEY, JSON.stringify(state));
}
function $52bd86db4e06f18b$var$parseLocalStorageState(state) {
    if (!state) return;
    try {
        const parsedState = JSON.parse(state);
        // This check should return true for the nullState
        if (parsedState?.userSideNavData && Array.isArray(parsedState.userMenuData) && typeof parsedState.userSideNavData === 'object') return parsedState;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    // something went wrong with parsing, return undefined
    }
}























const $9ec0c80383cc18b0$export$df4a614c56950314 = (items)=>items.map((item)=>item.menuId);


var $93055780db3226ac$exports = {};

var $aYr7p = parcelRequire("aYr7p");

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $93055780db3226ac$var$partition = $aYr7p(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
$93055780db3226ac$exports = $93055780db3226ac$var$partition;


const $b9a4eb7933e9dc22$export$98e5c4110cac6c24 = (items)=>(0, (/*@__PURE__*/$parcel$interopDefault($93055780db3226ac$exports)))(items, (item)=>item.visible);


const $b8d9cabd4ade8880$export$ac81be4e21f7c439 = (items)=>(0, $b9a4eb7933e9dc22$export$98e5c4110cac6c24)(items).map((0, $9ec0c80383cc18b0$export$df4a614c56950314));



var $9ZFdw = parcelRequire("9ZFdw");

function $62a738d04bc0cb36$export$a5bdc0a85c6880c5(params) {
    const { forYouMenuId: forYouMenuId, globalItems: globalItems, rawUserMenuData: rawUserMenuData } = params;
    // Sort the globalMenuIds so that the forYouItem is at the start, if it exists.
    const globalMenuIds = Array.from(globalItems.keys()).sort((a, b)=>Number(b === forYouMenuId) - Number(a === forYouMenuId));
    const rawUserMenuDataArrMaybeWithForYou = rawUserMenuData ?? [];
    // If the userdata contains the forYou item, remove it so that it can be re-added into first position.
    const rawUserMenuDataArr = forYouMenuId ? rawUserMenuDataArrMaybeWithForYou.filter((i)=>i.menuId !== forYouMenuId) : rawUserMenuDataArrMaybeWithForYou;
    // Add the globalMenuIds to the user data, if they're not already there.
    const globalItemsNotInUserData = (0, (/*@__PURE__*/$parcel$interopDefault($9ZFdw)))(globalMenuIds, rawUserMenuDataArr.map((i)=>i.menuId));
    return $62a738d04bc0cb36$var$createDefaultItems(globalItemsNotInUserData).concat(rawUserMenuDataArr);
}
const $62a738d04bc0cb36$var$createDefaultItems = (menuIds)=>menuIds.map((menuId)=>({
            menuId: menuId,
            visible: true
        }));


var $039501d97dc49448$exports = {};

var $79D42 = parcelRequire("79D42");

var $ac7c58e03467b27b$exports = {};

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");





var $gGzL7 = parcelRequire("gGzL7");


var $jG16D = parcelRequire("jG16D");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $ac7c58e03467b27b$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $ac7c58e03467b27b$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $3wyDU : $gqaVn, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $79D42(array, $gGzL7(iteratee));
        maxLength = $ac7c58e03467b27b$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $dLza3(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $jG16D(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $jG16D(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$ac7c58e03467b27b$exports = $ac7c58e03467b27b$var$baseIntersection;



var $j6gAQ = parcelRequire("j6gAQ");


var $kxLmQ = parcelRequire("kxLmQ");

var $75fd72eea1598879$exports = {};

var $5RsFr = parcelRequire("5RsFr");

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $75fd72eea1598879$var$castArrayLikeObject(value) {
    return $5RsFr(value) ? value : [];
}
$75fd72eea1598879$exports = $75fd72eea1598879$var$castArrayLikeObject;



var $gO1os = parcelRequire("gO1os");

/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */ var $039501d97dc49448$var$intersectionBy = $kxLmQ(function(arrays) {
    var iteratee = $gO1os(arrays), mapped = $79D42(arrays, $75fd72eea1598879$exports);
    if (iteratee === $gO1os(mapped)) iteratee = undefined;
    else mapped.pop();
    return mapped.length && mapped[0] === arrays[0] ? $ac7c58e03467b27b$exports(mapped, $j6gAQ(iteratee, 2)) : [];
});
$039501d97dc49448$exports = $039501d97dc49448$var$intersectionBy;


const $cc0b74e4bb5288e0$export$ce0466efa278e488 = (items, defaultItems)=>(0, (/*@__PURE__*/$parcel$interopDefault($039501d97dc49448$exports)))(items.concat(defaultItems), defaultItems, (item)=>item.menuId);


function $7b33741bc9e24248$export$e98db1320ac4ff55(params) {
    const { allItemMenuIds: allItemMenuIds, allShortcutMenuIds: allShortcutMenuIds, forYouMenuId: forYouMenuId, globalItems: globalItems, rawUserMenuData: rawUserMenuData, setUserMenuData: setUserMenuData, defaultMenuVisibility: defaultMenuVisibility } = params;
    // Check whether customisation data is empty
    const userDataIsEmpty = !$7b33741bc9e24248$var$hasUserData(rawUserMenuData);
    // Remove any menu ids that overlap with shortcuts using Set for O(1) lookups
    const shortcutMenuIdsSet = new Set(allShortcutMenuIds);
    const distinctDefaultItemMenuIds = allItemMenuIds.filter((id)=>!shortcutMenuIdsSet.has(id));
    const repairedUserMenuData = (0, $62a738d04bc0cb36$export$a5bdc0a85c6880c5)({
        forYouMenuId: forYouMenuId,
        globalItems: globalItems,
        rawUserMenuData: rawUserMenuData
    });
    // Add missing items and remove obsolete or duplicate items
    const itemUserMenuData = userDataIsEmpty ? $7b33741bc9e24248$var$repairWithDefaults(rawUserMenuData, defaultMenuVisibility, distinctDefaultItemMenuIds) : $7b33741bc9e24248$var$repair(repairedUserMenuData, distinctDefaultItemMenuIds);
    // Add missing shortcuts and remove obsolete or duplicate shortcuts
    const shortcutUserMenuData = userDataIsEmpty ? $7b33741bc9e24248$var$repairWithDefaults(rawUserMenuData, defaultMenuVisibility, allShortcutMenuIds) : $7b33741bc9e24248$var$repair(repairedUserMenuData, allShortcutMenuIds);
    // This repaired user menu data should always be used instead of the raw user menu data
    const userMenuData = itemUserMenuData.concat(shortcutUserMenuData);
    // Split the user menu data into visible and hidden menu ids, taking into account any visibility overrides from props
    const itemUserMenuDataWithMaybeDefaultsApplied = userDataIsEmpty ? $7b33741bc9e24248$var$setDefaultItemVisibility(itemUserMenuData, defaultMenuVisibility) : itemUserMenuData;
    const shortcutUserMenuDataWithMaybeDefaultsApplied = userDataIsEmpty ? $7b33741bc9e24248$var$setDefaultItemVisibility(shortcutUserMenuData, defaultMenuVisibility) : shortcutUserMenuData;
    const [visibleItemMenuIds, hiddenItemMenuIds] = (0, $b8d9cabd4ade8880$export$ac81be4e21f7c439)(itemUserMenuDataWithMaybeDefaultsApplied);
    const [visibleShortcutMenuIds, hiddenShortcutMenuIds] = (0, $b8d9cabd4ade8880$export$ac81be4e21f7c439)(shortcutUserMenuDataWithMaybeDefaultsApplied);
    const visibleMenuIds = visibleItemMenuIds.concat(visibleShortcutMenuIds);
    const hiddenMenuIds = hiddenItemMenuIds.concat(hiddenShortcutMenuIds);
    return {
        hiddenItemMenuIds: hiddenItemMenuIds,
        hiddenMenuIds: hiddenMenuIds,
        hiddenShortcutMenuIds: hiddenShortcutMenuIds,
        itemUserMenuData: itemUserMenuDataWithMaybeDefaultsApplied,
        shortcutUserMenuData: shortcutUserMenuDataWithMaybeDefaultsApplied,
        setUserMenuData: setUserMenuData,
        userMenuData: userMenuData,
        visibleItemMenuIds: visibleItemMenuIds,
        visibleMenuIds: visibleMenuIds,
        visibleShortcutMenuIds: visibleShortcutMenuIds
    };
}
const $7b33741bc9e24248$var$repair = (rawUserMenuData, defaultMenuIds)=>(0, $cc0b74e4bb5288e0$export$ce0466efa278e488)(rawUserMenuData ?? [], $7b33741bc9e24248$var$createDefaultItems(defaultMenuIds));
const $7b33741bc9e24248$var$repairWithDefaults = (rawUserMenuData, defaultVisibilityOverride, defaultMenuIds)=>$7b33741bc9e24248$var$setDefaultItemVisibility($7b33741bc9e24248$var$repair(rawUserMenuData, defaultMenuIds), defaultVisibilityOverride);
const $7b33741bc9e24248$var$createDefaultItems = (menuIds)=>menuIds.map((menuId)=>({
            menuId: menuId,
            visible: true
        }));
const $7b33741bc9e24248$var$setDefaultItemVisibility = (userMenuData, defaultMenuVisibility)=>{
    if (!defaultMenuVisibility) return userMenuData;
    const overrideMap = new Map(defaultMenuVisibility.map((item)=>[
            item.menuId,
            item.visible
        ]));
    return userMenuData.map((item)=>{
        const overrideVisible = overrideMap.get(item.menuId);
        return overrideVisible !== undefined ? {
            ...item,
            visible: overrideVisible
        } : item;
    });
};
const $7b33741bc9e24248$var$hasUserData = (rawUserMenuData)=>Array.isArray(rawUserMenuData) && rawUserMenuData.length > 0;




const $b7c49387c5e9ce27$export$91fb8643e8c59f90 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $b7c49387c5e9ce27$export$5063e15f61416e3b = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UserMenuDataShapesProvider(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { children: children, rawUserMenuData: rawUserMenuData, setUserMenuData: setUserMenuData } = t0;
    const { disableMenuCustomization: disableMenuCustomization, defaultMenuVisibility: defaultMenuVisibility } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { allItems: allItems, forYouMenuId: forYouMenuId, globalItems: globalItems, shortcuts: shortcuts } = (0, $296fb2d582379b95$export$68ff8f5dbbf3b8af)();
    let t1;
    if ($[0] !== allItems || $[1] !== defaultMenuVisibility || $[2] !== disableMenuCustomization || $[3] !== forYouMenuId || $[4] !== globalItems || $[5] !== rawUserMenuData || $[6] !== setUserMenuData || $[7] !== shortcuts) {
        let t2;
        if ($[9] !== shortcuts) {
            t2 = shortcuts ?? {};
            $[9] = shortcuts;
            $[10] = t2;
        } else t2 = $[10];
        t1 = (0, $7b33741bc9e24248$export$e98db1320ac4ff55)({
            allItemMenuIds: Object.keys(allItems),
            allShortcutMenuIds: Object.keys(t2),
            forYouMenuId: forYouMenuId,
            globalItems: globalItems,
            rawUserMenuData: disableMenuCustomization ? [] : rawUserMenuData,
            setUserMenuData: setUserMenuData,
            defaultMenuVisibility: defaultMenuVisibility
        });
        $[0] = allItems;
        $[1] = defaultMenuVisibility;
        $[2] = disableMenuCustomization;
        $[3] = forYouMenuId;
        $[4] = globalItems;
        $[5] = rawUserMenuData;
        $[6] = setUserMenuData;
        $[7] = shortcuts;
        $[8] = t1;
    } else t1 = $[8];
    const userMenuDataShapes = t1;
    let t2;
    if ($[11] !== children || $[12] !== userMenuDataShapes) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7c49387c5e9ce27$export$91fb8643e8c59f90.Provider, {
            value: userMenuDataShapes
        }, children);
        $[11] = children;
        $[12] = userMenuDataShapes;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
} : function UserMenuDataShapesProvider({ children: children, rawUserMenuData: rawUserMenuData, setUserMenuData: setUserMenuData }) {
    const { disableMenuCustomization: disableMenuCustomization, defaultMenuVisibility: defaultMenuVisibility } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { allItems: allItems, forYouMenuId: forYouMenuId, globalItems: globalItems, shortcuts: shortcuts } = (0, $296fb2d582379b95$export$68ff8f5dbbf3b8af)();
    const userMenuDataShapes = (0, $cozmU.useMemo)(()=>(0, $7b33741bc9e24248$export$e98db1320ac4ff55)({
            allItemMenuIds: Object.keys(allItems),
            allShortcutMenuIds: Object.keys(shortcuts ?? {}),
            forYouMenuId: forYouMenuId,
            globalItems: globalItems,
            // All menu items are visible when there is no user menu data
            rawUserMenuData: disableMenuCustomization ? [] : rawUserMenuData,
            setUserMenuData: setUserMenuData,
            defaultMenuVisibility: defaultMenuVisibility
        }), [
        allItems,
        disableMenuCustomization,
        forYouMenuId,
        globalItems,
        rawUserMenuData,
        setUserMenuData,
        shortcuts,
        defaultMenuVisibility
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7c49387c5e9ce27$export$91fb8643e8c59f90.Provider, {
        value: userMenuDataShapes
    }, children);
};
const $b7c49387c5e9ce27$export$f340ebbec0629d31 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUserMenuDataShapes() {
    const context = (0, $cozmU.useContext)($b7c49387c5e9ce27$export$91fb8643e8c59f90);
    (0, $bB0i2.default)(context, "useUserMenuDataShapes must be used inside an initialized UserMenuDataShapesProvider");
    return context;
} : function useUserMenuDataShapes() {
    const context = (0, $cozmU.useContext)($b7c49387c5e9ce27$export$91fb8643e8c59f90);
    (0, $bB0i2.default)(context, 'useUserMenuDataShapes must be used inside an initialized UserMenuDataShapesProvider');
    return context;
};














const $102e17007742dcab$export$b892481aefb34336 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $102e17007742dcab$export$81208cef03561ef9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UserSideNavDataStoreProvider(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children, setUserSideNavData: setUserSideNavData, userSideNavData: userSideNavData } = t0;
    let t1;
    if ($[0] !== setUserSideNavData || $[1] !== userSideNavData) {
        t1 = {
            setUserSideNavData: setUserSideNavData,
            userSideNavData: userSideNavData
        };
        $[0] = setUserSideNavData;
        $[1] = userSideNavData;
        $[2] = t1;
    } else t1 = $[2];
    const userSideNavDataStore = t1;
    let t2;
    if ($[3] !== children || $[4] !== userSideNavDataStore) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($102e17007742dcab$export$b892481aefb34336.Provider, {
            value: userSideNavDataStore
        }, children);
        $[3] = children;
        $[4] = userSideNavDataStore;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function UserSideNavDataStoreProvider({ children: children, setUserSideNavData: setUserSideNavData, userSideNavData: userSideNavData }) {
    const userSideNavDataStore = (0, $cozmU.useMemo)(()=>({
            setUserSideNavData: setUserSideNavData,
            userSideNavData: userSideNavData
        }), [
        setUserSideNavData,
        userSideNavData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($102e17007742dcab$export$b892481aefb34336.Provider, {
        value: userSideNavDataStore
    }, children);
};
const $102e17007742dcab$export$af1627270f7f3b2c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUserSideNavDataStore() {
    const context = (0, $cozmU.useContext)($102e17007742dcab$export$b892481aefb34336);
    (0, $bB0i2.default)(context, "useUserSideNavDataStore must be used inside a UserSideNavDataStoreProvider");
    return context;
} : function useUserSideNavDataStore() {
    const context = (0, $cozmU.useContext)($102e17007742dcab$export$b892481aefb34336);
    (0, $bB0i2.default)(context, 'useUserSideNavDataStore must be used inside a UserSideNavDataStoreProvider');
    return context;
};


const $bb0cae74c3a96c49$export$54ef25ae025e12ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoreProviders(props) {
    const $ = (0, $bDgLe.c)(8);
    const { children: children, userMenuData: userMenuData, userSideNavData: userSideNavData, setUserMenuData: setUserMenuData, setUserSideNavData: setUserSideNavData } = props;
    let t0;
    if ($[0] !== children || $[1] !== setUserSideNavData || $[2] !== userSideNavData) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $102e17007742dcab$export$81208cef03561ef9), {
            setUserSideNavData: setUserSideNavData,
            userSideNavData: userSideNavData
        }, children);
        $[0] = children;
        $[1] = setUserSideNavData;
        $[2] = userSideNavData;
        $[3] = t0;
    } else t0 = $[3];
    let t1;
    if ($[4] !== setUserMenuData || $[5] !== t0 || $[6] !== userMenuData) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7c49387c5e9ce27$export$5063e15f61416e3b), {
            rawUserMenuData: userMenuData,
            setUserMenuData: setUserMenuData
        }, t0);
        $[4] = setUserMenuData;
        $[5] = t0;
        $[6] = userMenuData;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : function StoreProviders(props) {
    const { children: children, userMenuData: userMenuData, userSideNavData: userSideNavData, setUserMenuData: setUserMenuData, setUserSideNavData: setUserSideNavData } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7c49387c5e9ce27$export$5063e15f61416e3b), {
        rawUserMenuData: userMenuData,
        setUserMenuData: setUserMenuData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $102e17007742dcab$export$81208cef03561ef9), {
        setUserSideNavData: setUserSideNavData,
        userSideNavData: userSideNavData
    }, children));
};


const $e033176a4aad0701$export$9adaf932dcd02b00 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LocalStore(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const { app: app } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    let t1;
    if ($[0] !== app) {
        t1 = {
            app: app
        };
        $[0] = app;
        $[1] = t1;
    } else t1 = $[1];
    const userStoreProps = (0, $52bd86db4e06f18b$export$4714a0d7e8941053)(t1);
    let t2;
    if ($[2] !== children || $[3] !== userStoreProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bb0cae74c3a96c49$export$54ef25ae025e12ab), userStoreProps, children);
        $[2] = children;
        $[3] = userStoreProps;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function LocalStore({ children: children }) {
    const { app: app } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $52bd86db4e06f18b$export$4714a0d7e8941053)({
        app: app
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bb0cae74c3a96c49$export$54ef25ae025e12ab), userStoreProps, children);
};





















/**
 * @generated SignedSource<<0ffa5c8a5f68bc4537f010427d5ce4ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $601e95c9910a4c20$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "entityAriUserSideNavSettings"
        },
        {
            "kind": "RootArgument",
            "name": "ownerAri"
        }
    ],
    "kind": "Fragment",
    "name": "useNetworkSideNavUserData",
    "selections": [
        {
            "alias": "userSideNavSettings",
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriUserSideNavSettings"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItemConnection",
                    "kind": "LinkedField",
                    "name": "sidebar",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "menuId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "visible"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SettingsDisplayPropertyConnection",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsDisplayProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$601e95c9910a4c20$var$node.hash = "48a417a1d2876624970df89dfa84bb10";
var $601e95c9910a4c20$export$2e2bcd8739ae039 = $601e95c9910a4c20$var$node;






var $6SsN4 = parcelRequire("6SsN4");



var $2VcXd = parcelRequire("2VcXd");







/**
 * @generated SignedSource<<562465ef8265d5d23e2424c599193d33>>
 * @relayHash b2d7e70e45866cb05b2662c2d7cfed78
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22faaff69843483ef60d4de279304a4f15d34d081305f2df728cf86333831fa7
const $3e2ecd74df4ff3cc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageSizeValue"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "properties"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sidebar"
    }, v5 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                },
                {
                    "kind": "Variable",
                    "name": "properties",
                    "variableName": "properties"
                },
                {
                    "kind": "Variable",
                    "name": "sidebar",
                    "variableName": "sidebar"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v6 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "pageSizeValue"
        }
    ], v7 = {
        "args": v6 /*: any*/ ,
        "concreteType": "SettingsMenuItemConnection",
        "kind": "LinkedField",
        "name": "sidebar",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsMenuItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "menuId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "visible"
                    }
                ]
            }
        ]
    }, v8 = {
        "args": v6 /*: any*/ ,
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsDisplayProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useNavSettingsServiceMutation",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_updateNavigationCustomisation",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useNavSettingsServiceMutation",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_updateNavigationCustomisation",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "22faaff69843483ef60d4de279304a4f15d34d081305f2df728cf86333831fa7",
            "metadata": {},
            "name": "useNavSettingsServiceMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3e2ecd74df4ff3cc$var$node.hash = "33eadcae8875ac6ec53a5b1340297431";
var $3e2ecd74df4ff3cc$export$2e2bcd8739ae039 = $3e2ecd74df4ff3cc$var$node;


/**
 * @generated SignedSource<<04adf71d881d96495a7a3f6a6a067951>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $56f649bf43cfcdab$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "__relay_internal__pv__getpagesizevaluerelayproviderts"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__getpagesizevaluerelayproviderts"
            }
        ],
        "kind": "Fragment",
        "name": "useNavSettingsService",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "concreteType": "SettingsMenuItemConnection",
                "kind": "LinkedField",
                "name": "sidebar",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SettingsMenuItem",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "menuId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "visible"
                            }
                        ]
                    }
                ]
            },
            {
                "args": v0 /*: any*/ ,
                "concreteType": "SettingsDisplayPropertyConnection",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SettingsDisplayProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "SettingsNavigationCustomisation"
    };
}();
$56f649bf43cfcdab$var$node.hash = "3eeb846e40561ac05736d40d381db293";
var $56f649bf43cfcdab$export$2e2bcd8739ae039 = $56f649bf43cfcdab$var$node;











const $44457bca74ddf52c$export$29d13058c876d5c5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useNavSettingsService(params) {
    const $ = (0, $bDgLe.c)(11);
    const { mutationEntityAri: entityAri, ownerAri: ownerAri, queryRef: queryRef } = params;
    const queryData = $44457bca74ddf52c$var$useLocalFragment(queryRef);
    const mutation = $44457bca74ddf52c$var$useLocalMutation();
    const { fireEvent: fireEvent } = (0, $19ead867f45fce96$export$5bf35293e545f20c)();
    const { customizationStore: customizationStore } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    let t0;
    if ($[0] !== customizationStore || $[1] !== fireEvent) {
        t0 = (success, error)=>{
            bb2: switch(success){
                case true:
                    fireEvent("operational.executeMutation.succeeded", {
                        storage: customizationStore ?? "network"
                    });
                    break bb2;
                case false:
                    fireEvent("operational.executeMutation.failed", {
                        storage: customizationStore ?? "network",
                        error: error ?? "Unknown error"
                    });
            }
        };
        $[0] = customizationStore;
        $[1] = fireEvent;
        $[2] = t0;
    } else t0 = $[2];
    const fireMutationEvent = t0;
    let t1;
    if ($[3] !== entityAri || $[4] !== fireMutationEvent || $[5] !== mutation || $[6] !== ownerAri) {
        t1 = (t2)=>{
            const { sidebar: sidebar, properties: properties } = t2;
            $44457bca74ddf52c$var$executeMutation({
                mutation: mutation,
                variables: {
                    entityAri: entityAri,
                    ownerAri: ownerAri,
                    properties: properties,
                    sidebar: sidebar,
                    pageSizeValue: (0, $ca52779d04788c52$export$5716e8bcb003888d)
                },
                fireEvent: fireMutationEvent
            });
        };
        $[3] = entityAri;
        $[4] = fireMutationEvent;
        $[5] = mutation;
        $[6] = ownerAri;
        $[7] = t1;
    } else t1 = $[7];
    const setNavData = t1;
    let t2;
    if ($[8] !== queryData || $[9] !== setNavData) {
        t2 = {
            queryData: queryData,
            setNavData: setNavData
        };
        $[8] = queryData;
        $[9] = setNavData;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : function useNavSettingsService(params) {
    const { mutationEntityAri: entityAri, ownerAri: ownerAri, queryRef: queryRef } = params;
    const queryData = $44457bca74ddf52c$var$useLocalFragment(queryRef);
    const mutation = $44457bca74ddf52c$var$useLocalMutation();
    const { fireEvent: fireEvent } = (0, $19ead867f45fce96$export$5bf35293e545f20c)();
    const { customizationStore: customizationStore } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const fireMutationEvent = (0, $cozmU.useCallback)((success, error)=>{
        switch(success){
            case true:
                fireEvent('operational.executeMutation.succeeded', {
                    storage: customizationStore ?? 'network'
                });
                break;
            case false:
                fireEvent('operational.executeMutation.failed', {
                    storage: customizationStore ?? 'network',
                    error: error ?? 'Unknown error'
                });
                break;
        }
    }, [
        customizationStore,
        fireEvent
    ]);
    const setNavData = (0, $cozmU.useCallback)(({ sidebar: sidebar, properties: properties })=>{
        $44457bca74ddf52c$var$executeMutation({
            mutation: mutation,
            variables: {
                entityAri: entityAri,
                ownerAri: ownerAri,
                properties: properties,
                sidebar: sidebar,
                pageSizeValue: (0, $ca52779d04788c52$export$5716e8bcb003888d)
            },
            fireEvent: fireMutationEvent
        });
    }, [
        entityAri,
        fireMutationEvent,
        mutation,
        ownerAri
    ]);
    return {
        queryData: queryData,
        setNavData: setNavData
    };
};
const $44457bca74ddf52c$var$useLocalFragment = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useLocalFragment(queryRef) {
    return (0, $6SsN4.useFragment)((0, $56f649bf43cfcdab$export$2e2bcd8739ae039), queryRef);
} : function useLocalFragment(queryRef) {
    /* eslint-disable @atlassian/relay/no-wrapping-hooks */ /* eslint-disable @atlassian/relay/unused-fields */ /* eslint-disable @atlassian/relay/graphql-naming */ return (0, $6SsN4.useFragment)((0, $56f649bf43cfcdab$export$2e2bcd8739ae039), queryRef);
/* eslint-enable @atlassian/relay/unused-fields */ };
const $44457bca74ddf52c$var$useLocalMutation = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useLocalMutation() {
    return (0, $6SsN4.useMutation)((0, $3e2ecd74df4ff3cc$export$2e2bcd8739ae039))[0];
} : function useLocalMutation() {
    return (0, $6SsN4.useMutation)((0, $3e2ecd74df4ff3cc$export$2e2bcd8739ae039))[0];
};
function $44457bca74ddf52c$var$executeMutation({ mutation: mutation, variables: variables, fireEvent: fireEvent }) {
    try {
        return mutation({
            variables: variables,
            onCompleted: ()=>{
                fireEvent(true);
            },
            onError: (error)=>{
                fireEvent(false, error.message || 'Unknown error');
            }
        });
    } catch (error) {
        fireEvent(false, `Unhandled error: ${error.message || 'Unknown error'}`);
    }
}


// Pure function to handle user side nav data updates - moved outside component for stability
const $307d5749da700441$var$setUserSideNavDataFixed = (userSideNavData, currentDefaultWidth, currentDefaultCollapsed, setSideNavPropertiesCallback, setSidebarNavDataCallback)=>{
    const newState = {
        defaultWidth: String(userSideNavData.defaultWidth ?? currentDefaultWidth) || '',
        defaultCollapsed: String(userSideNavData.defaultCollapsed ?? currentDefaultCollapsed) || 'false'
    };
    setSideNavPropertiesCallback(newState);
    const properties = [
        {
            key: (0, $ca52779d04788c52$export$5ec229a880d48b06),
            value: newState.defaultWidth
        },
        {
            key: (0, $ca52779d04788c52$export$f1259eef323ff984),
            value: newState.defaultCollapsed
        }
    ];
    setSidebarNavDataCallback({
        properties: properties
    });
};
const $307d5749da700441$export$caed0b91aaed2955 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useNetworkSideNavUserData(params) {
    const $ = (0, $bDgLe.c)(40);
    const { firstPartyApp: firstPartyApp, activationId: t0, ownerAri: ownerAri, queryRef: queryRef, siteId: t1 } = params;
    const activationId = t0 === undefined ? "" : t0;
    const siteId = t1 === undefined ? "" : t1;
    let t2;
    if ($[0] !== activationId || $[1] !== firstPartyApp || $[2] !== siteId) {
        t2 = (0, $2VcXd.buildNavigationAriForMenuData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        });
        $[0] = activationId;
        $[1] = firstPartyApp;
        $[2] = siteId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== ownerAri || $[5] !== queryRef.navPlatL1MenuData || $[6] !== t2) {
        t3 = {
            mutationEntityAri: t2,
            ownerAri: ownerAri,
            queryRef: queryRef.navPlatL1MenuData
        };
        $[4] = ownerAri;
        $[5] = queryRef.navPlatL1MenuData;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const { queryData: menuQueryData, setNavData: setMenuNavData } = (0, $44457bca74ddf52c$export$29d13058c876d5c5)(t3);
    let t4;
    if ($[8] !== activationId || $[9] !== firstPartyApp || $[10] !== siteId) {
        t4 = (0, $2VcXd.buildNavigationAriForSidebarData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        });
        $[8] = activationId;
        $[9] = firstPartyApp;
        $[10] = siteId;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== ownerAri || $[13] !== queryRef.navPlatSidebarData || $[14] !== t4) {
        t5 = {
            mutationEntityAri: t4,
            ownerAri: ownerAri,
            queryRef: queryRef.navPlatSidebarData
        };
        $[12] = ownerAri;
        $[13] = queryRef.navPlatSidebarData;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    const { queryData: sidebarQueryData, setNavData: setSidebarNavData } = (0, $44457bca74ddf52c$export$29d13058c876d5c5)(t5);
    let t6;
    if ($[16] !== sidebarQueryData?.properties?.nodes) {
        t6 = (sidebarQueryData?.properties?.nodes ?? [
            {
                key: (0, $ca52779d04788c52$export$5ec229a880d48b06),
                value: undefined
            }
        ]).find($307d5749da700441$var$_temp)?.value ?? "";
        $[16] = sidebarQueryData?.properties?.nodes;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== sidebarQueryData?.properties?.nodes) {
        t7 = (sidebarQueryData?.properties?.nodes ?? [
            {
                key: (0, $ca52779d04788c52$export$f1259eef323ff984),
                value: undefined
            }
        ]).find($307d5749da700441$var$_temp2)?.value ?? "";
        $[18] = sidebarQueryData?.properties?.nodes;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== t6 || $[21] !== t7) {
        t8 = {
            defaultWidth: t6,
            defaultCollapsed: t7
        };
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
    } else t8 = $[22];
    const [sideNavProperties, setSideNavProperties] = (0, $cozmU.useState)(t8);
    let t9;
    if ($[23] !== menuQueryData?.sidebar?.nodes) {
        t9 = menuQueryData?.sidebar?.nodes || [];
        $[23] = menuQueryData?.sidebar?.nodes;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== t9) {
        t10 = $307d5749da700441$var$repairCustomizationItems(t9);
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    const [customizationItems, setCustomizationItems] = (0, $cozmU.useState)(t10);
    let t11;
    if ($[27] !== setMenuNavData) {
        t11 = (rawSidebarData)=>{
            setCustomizationItems(rawSidebarData);
            setMenuNavData({
                sidebar: $307d5749da700441$var$sanitizeUserMenuData(rawSidebarData)
            });
        };
        $[27] = setMenuNavData;
        $[28] = t11;
    } else t11 = $[28];
    const setUserMenuData = t11;
    let t12;
    if ($[29] !== setSidebarNavData || $[30] !== sideNavProperties.defaultCollapsed || $[31] !== sideNavProperties.defaultWidth) {
        t12 = (userSideNavData)=>$307d5749da700441$var$setUserSideNavDataFixed(userSideNavData, sideNavProperties.defaultWidth, sideNavProperties.defaultCollapsed, setSideNavProperties, setSidebarNavData);
        $[29] = setSidebarNavData;
        $[30] = sideNavProperties.defaultCollapsed;
        $[31] = sideNavProperties.defaultWidth;
        $[32] = t12;
    } else t12 = $[32];
    const setUserSideNavData = t12;
    let t13;
    if ($[33] !== sideNavProperties) {
        t13 = $307d5749da700441$var$toUserSideNavData(sideNavProperties);
        $[33] = sideNavProperties;
        $[34] = t13;
    } else t13 = $[34];
    let t14;
    if ($[35] !== customizationItems || $[36] !== setUserMenuData || $[37] !== setUserSideNavData || $[38] !== t13) {
        t14 = {
            userMenuData: customizationItems,
            userSideNavData: t13,
            setUserMenuData: setUserMenuData,
            setUserSideNavData: setUserSideNavData
        };
        $[35] = customizationItems;
        $[36] = setUserMenuData;
        $[37] = setUserSideNavData;
        $[38] = t13;
        $[39] = t14;
    } else t14 = $[39];
    const stableUserData = t14;
    return stableUserData;
} : function useNetworkSideNavUserData(params) {
    const { firstPartyApp: firstPartyApp, activationId: activationId = '', ownerAri: ownerAri, queryRef: queryRef, siteId: siteId = '' } = params;
    const { queryData: menuQueryData, setNavData: setMenuNavData } = (0, $44457bca74ddf52c$export$29d13058c876d5c5)({
        mutationEntityAri: (0, $2VcXd.buildNavigationAriForMenuData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        }),
        ownerAri: ownerAri,
        queryRef: queryRef.navPlatL1MenuData
    });
    const { queryData: sidebarQueryData, setNavData: setSidebarNavData } = (0, $44457bca74ddf52c$export$29d13058c876d5c5)({
        mutationEntityAri: (0, $2VcXd.buildNavigationAriForSidebarData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        }),
        ownerAri: ownerAri,
        queryRef: queryRef.navPlatSidebarData
    });
    // We store the state of the properties & customizationItems, as the sidebar state can change without any
    // new calls to the local queryRef (to read the value back). So we persist it in this component.
    const [sideNavProperties, setSideNavProperties] = (0, $cozmU.useState)({
        defaultWidth: (sidebarQueryData?.properties?.nodes ?? [
            {
                key: (0, $ca52779d04788c52$export$5ec229a880d48b06),
                value: undefined
            }
        ]).find((item)=>item?.key === (0, $ca52779d04788c52$export$5ec229a880d48b06))?.value ?? '',
        defaultCollapsed: (sidebarQueryData?.properties?.nodes ?? [
            {
                key: (0, $ca52779d04788c52$export$f1259eef323ff984),
                value: undefined
            }
        ]).find((item_0)=>item_0?.key === (0, $ca52779d04788c52$export$f1259eef323ff984))?.value ?? ''
    });
    const [customizationItems, setCustomizationItems] = (0, $cozmU.useState)(// Business rule:  The user-customization-data (menu data):
    // 	- uses the new-record nodes (if they exist), or...
    //  - is an empty array (no user customization).
    // This means that if the settings service fails, we return empty user-customization data,
    // which causes GSN to render everything the *app* wants in the app-default order.
    $307d5749da700441$var$repairCustomizationItems(menuQueryData?.sidebar?.nodes || []));
    // Create two callback functions - one for each user data-prop.
    // Not sure how performant this is, but it simplifies updates (because the caller doesn't need to know about the other half of the data)
    const setUserMenuData = (0, $cozmU.useCallback)((rawSidebarData)=>{
        setCustomizationItems(rawSidebarData);
        setMenuNavData({
            sidebar: $307d5749da700441$var$sanitizeUserMenuData(rawSidebarData)
        });
    }, [
        setMenuNavData
    ]);
    // A non-memoized version was created as part of https://hello.jira.atlassian.cloud/browse/NAVX-2972
    // Memoize to keep a stable setter reference when state is unchanged.
    const setUserSideNavData = (0, $cozmU.useCallback)((userSideNavData)=>$307d5749da700441$var$setUserSideNavDataFixed(userSideNavData, sideNavProperties.defaultWidth, sideNavProperties.defaultCollapsed, setSideNavProperties, setSidebarNavData), [
        sideNavProperties.defaultWidth,
        sideNavProperties.defaultCollapsed,
        setSideNavProperties,
        setSidebarNavData
    ]);
    // Create a nicer shape for the data.
    // For the userSideNavData, it is ok for the values to be undefined,
    // as the ADS component will know what to do.
    const stableUserData = (0, $cozmU.useMemo)(()=>({
            userMenuData: customizationItems,
            userSideNavData: $307d5749da700441$var$toUserSideNavData(sideNavProperties),
            setUserMenuData: setUserMenuData,
            setUserSideNavData: setUserSideNavData
        }), [
        customizationItems,
        sideNavProperties,
        setUserMenuData,
        setUserSideNavData
    ]);
    return stableUserData;
};
/**
 * useNetworkMigrationSideNavUserData - the data-migration version of useNetworkSideNavUserData()
 */ function $307d5749da700441$var$_temp2(item_0) {
    return item_0?.key === (0, $ca52779d04788c52$export$f1259eef323ff984);
}
function $307d5749da700441$var$_temp(item) {
    return item?.key === (0, $ca52779d04788c52$export$5ec229a880d48b06);
}
function $307d5749da700441$export$156415ede1cb8a79(params) {
    const { firstPartyApp: firstPartyApp, activationId: activationId = '', ownerAri: ownerAri, queryRef: queryRef, siteId: siteId = '' } = params;
    const queryDataOLD = $307d5749da700441$var$useLocalFragmentToGetOldEntityAri(queryRef); // Read from the existing entityAri record
    const { queryData: l1menuQueryData, setNavData: setL1MenuData } = (0, $44457bca74ddf52c$export$29d13058c876d5c5)({
        mutationEntityAri: (0, $2VcXd.buildNavigationAriForMenuData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        }),
        ownerAri: ownerAri,
        queryRef: queryRef.navPlatL1MenuData
    });
    const { queryData: sidebarSizeQueryData, setNavData: setSidebarSizeData } = (0, $44457bca74ddf52c$export$29d13058c876d5c5)({
        mutationEntityAri: (0, $2VcXd.buildNavigationAriForSidebarData)({
            activationId: activationId,
            firstPartyApp: firstPartyApp,
            siteId: siteId
        }),
        ownerAri: ownerAri,
        queryRef: queryRef.navPlatSidebarData
    });
    // We store the state of the properties & customizationItems, as the sidebar state can change without any
    // new calls to the local queryRef (to read the value back). So we persist it in this component.
    const [sideNavProperties, setSideNavProperties] = (0, $cozmU.useState)({
        defaultWidth: ((sidebarSizeQueryData?.properties?.nodes || queryDataOLD?.userSideNavSettings?.properties?.nodes) ?? [
            {
                key: (0, $ca52779d04788c52$export$5ec229a880d48b06),
                value: undefined
            }
        ]).find((item)=>item?.key === (0, $ca52779d04788c52$export$5ec229a880d48b06))?.value ?? '',
        defaultCollapsed: ((sidebarSizeQueryData?.properties?.nodes || queryDataOLD?.userSideNavSettings?.properties?.nodes) ?? [
            {
                key: (0, $ca52779d04788c52$export$f1259eef323ff984),
                value: undefined
            }
        ]).find((item)=>item?.key === (0, $ca52779d04788c52$export$f1259eef323ff984))?.value ?? ''
    });
    const [sideNavMenuData, setSideNavMenuData] = (0, $cozmU.useState)($307d5749da700441$var$repairCustomizationItems(// Business rule:  The user-customization-data (menu data):
    // 	- uses the new-record nodes (if they exist), or...
    //	- uses the old-record nodes (if they exist), or...
    //  - is an empty array (no user customization).
    // This means that if the settings service fails, we return empty user-customization data,
    // which causes GSN to render everything the *app* wants in the app-default order.
    l1menuQueryData?.sidebar?.nodes || queryDataOLD?.userSideNavSettings?.sidebar?.nodes || []));
    // Create two callback functions - one for each user data-prop.
    const setUserMenuData = (0, $cozmU.useCallback)((rawSidebarData)=>{
        setSideNavMenuData(rawSidebarData);
        setL1MenuData({
            properties: [],
            sidebar: $307d5749da700441$var$sanitizeUserMenuData(rawSidebarData)
        });
    }, [
        setL1MenuData
    ]);
    // A non-memoized version was created as part of https://hello.jira.atlassian.cloud/browse/NAVX-2972
    // Memoize to keep a stable setter reference when state is unchanged.
    const setUserSideNavData = (0, $cozmU.useCallback)((userSideNavData)=>{
        const newState = {
            defaultWidth: String(userSideNavData.defaultWidth ?? sideNavProperties.defaultWidth) || '',
            defaultCollapsed: String(userSideNavData.defaultCollapsed ?? sideNavProperties.defaultCollapsed) || 'false'
        };
        setSideNavProperties(newState);
        const properties = [
            {
                key: (0, $ca52779d04788c52$export$5ec229a880d48b06),
                value: newState.defaultWidth
            },
            {
                key: (0, $ca52779d04788c52$export$f1259eef323ff984),
                value: newState.defaultCollapsed
            }
        ];
        setSidebarSizeData({
            properties: properties,
            sidebar: []
        });
    }, [
        sideNavProperties.defaultWidth,
        sideNavProperties.defaultCollapsed,
        setSideNavProperties,
        setSidebarSizeData
    ]);
    // Migration behaviour runs ONCE after the browser (we don't want to do this on the server) becomes idle for 2 seconds.
    // If there is data in the old record but no data in the new record, fix this up after idle
    (0, $cozmU.useEffect)(()=>{
        const handleMigration = ()=>{
            // MENU data migration
            const oldMenuData = sideNavMenuData;
            const newMenuData = l1menuQueryData?.sidebar?.nodes || [];
            if (oldMenuData.length > 0 && newMenuData.length === 0) setUserMenuData(oldMenuData);
            // SIDEBAR data migration
            const oldSidebarData = queryDataOLD?.userSideNavSettings?.properties?.nodes || [];
            const newSidebarData = sidebarSizeQueryData?.properties?.nodes || [];
            if (oldSidebarData.length > 0 && newSidebarData.length === 0) setUserSideNavData($307d5749da700441$var$toUserSideNavData(sideNavProperties));
        };
        const searchParams = new URLSearchParams(location.search);
        // Add a way to reset the data in the NEW records, to allow us to re-test the migration process on an ad-hoc basis
        if (searchParams.has('reset-migration')) // Bypass the data formatters and reset the data. These values will be treated as 'empty' by the code.
        return $307d5749da700441$var$callWhenIdle(()=>{
            setL1MenuData({
                properties: [],
                sidebar: []
            });
            setSidebarSizeData({
                properties: [],
                sidebar: []
            });
        });
        else return $307d5749da700441$var$callWhenIdle(handleMigration);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Create a nicer shape for the data.
    // For the userSideNavData, it is ok for the values to be undefined,
    // as the ADS component will know what to do.
    const stableUserData = (0, $cozmU.useMemo)(()=>({
            userMenuData: sideNavMenuData,
            userSideNavData: $307d5749da700441$var$toUserSideNavData(sideNavProperties),
            setUserMenuData: setUserMenuData,
            setUserSideNavData: setUserSideNavData
        }), [
        sideNavMenuData,
        sideNavProperties,
        setUserMenuData,
        setUserSideNavData
    ]);
    return stableUserData;
}
/**
 * Make the Relay data look "normal" to the outside world.
 */ function $307d5749da700441$var$repairCustomizationItems(value) {
    return value;
}
function $307d5749da700441$var$toUserSideNavData(sideNavProperties) {
    return {
        defaultWidth: sideNavProperties.defaultWidth === '' ? undefined : Number(sideNavProperties.defaultWidth),
        defaultCollapsed: sideNavProperties.defaultCollapsed === '' ? undefined : sideNavProperties.defaultCollapsed === 'true'
    };
}
const $307d5749da700441$var$useLocalFragmentToGetOldEntityAri = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useLocalFragmentToGetOldEntityAri(queryRef) {
    return (0, $6SsN4.useFragment)((0, $601e95c9910a4c20$export$2e2bcd8739ae039), queryRef);
} : function useLocalFragmentToGetOldEntityAri(queryRef) {
    /* eslint-disable @atlassian/relay/no-wrapping-hooks */ /* eslint-disable @atlassian/relay/unused-fields */ /* eslint-disable @atlassian/relay/graphql-naming */ return (0, $6SsN4.useFragment)((0, $601e95c9910a4c20$export$2e2bcd8739ae039), queryRef);
/* eslint-enable @atlassian/relay/unused-fields */ };
/**
 * Creates a new UserMenuData (array) that is supported by the Settings Service.
 */ function $307d5749da700441$var$sanitizeUserMenuData(data) {
    return data.map((item)=>({
            menuId: item.menuId,
            visible: item.visible
        }));
}
function $307d5749da700441$var$callWhenIdle(callback) {
    if (typeof requestIdleCallback !== 'undefined') {
        const id = requestIdleCallback(callback);
        return ()=>cancelIdleCallback(id);
    }
    const id = requestAnimationFrame(callback);
    return ()=>cancelAnimationFrame(id);
}



const $cb000ff6e07567c3$export$c723d37fdda6e941 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function NetworkMigrationStore(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const { networkStorageParams: networkStorageParams, app: app } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    (0, $bB0i2.default)(networkStorageParams?.activationId && networkStorageParams?.entityAri && networkStorageParams?.siteId && networkStorageParams?.ownerAri && networkStorageParams?.queryRef, "Please provide networkStorageParams when using customization");
    let t1;
    if ($[0] !== app || $[1] !== networkStorageParams) {
        t1 = {
            ...networkStorageParams,
            firstPartyApp: app
        };
        $[0] = app;
        $[1] = networkStorageParams;
        $[2] = t1;
    } else t1 = $[2];
    const userStoreProps = (0, $307d5749da700441$export$156415ede1cb8a79)(t1);
    let t2;
    if ($[3] !== children || $[4] !== userStoreProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bb0cae74c3a96c49$export$54ef25ae025e12ab), userStoreProps, children);
        $[3] = children;
        $[4] = userStoreProps;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function NetworkMigrationStore({ children: children }) {
    const { networkStorageParams: networkStorageParams, app: app } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    (0, $bB0i2.default)(networkStorageParams?.activationId && networkStorageParams?.entityAri && networkStorageParams?.siteId && networkStorageParams?.ownerAri && networkStorageParams?.queryRef, 'Please provide networkStorageParams when using customization');
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $307d5749da700441$export$156415ede1cb8a79)({
        ...networkStorageParams,
        firstPartyApp: app
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bb0cae74c3a96c49$export$54ef25ae025e12ab), userStoreProps, children);
};

















const $a498df91df862359$export$711a2621397f25fc = (0, $gtMdU.isReactCompilerActivePlatform)() ? function NetworkStore(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const { networkStorageParams: networkStorageParams, app: app } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    (0, $bB0i2.default)(networkStorageParams?.activationId && networkStorageParams?.ownerAri && networkStorageParams?.queryRef && networkStorageParams?.siteId, "Please provide networkStorageParams when using customization");
    let t1;
    if ($[0] !== app || $[1] !== networkStorageParams) {
        t1 = {
            ...networkStorageParams,
            firstPartyApp: app
        };
        $[0] = app;
        $[1] = networkStorageParams;
        $[2] = t1;
    } else t1 = $[2];
    const userStoreProps = (0, $307d5749da700441$export$caed0b91aaed2955)(t1);
    let t2;
    if ($[3] !== children || $[4] !== userStoreProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bb0cae74c3a96c49$export$54ef25ae025e12ab), userStoreProps, children);
        $[3] = children;
        $[4] = userStoreProps;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function NetworkStore({ children: children }) {
    const { networkStorageParams: networkStorageParams, app: app } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    (0, $bB0i2.default)(networkStorageParams?.activationId && networkStorageParams?.ownerAri && networkStorageParams?.queryRef && networkStorageParams?.siteId, 'Please provide networkStorageParams when using customization');
    // This is user data for the menu and the sidebar
    const userStoreProps = (0, $307d5749da700441$export$caed0b91aaed2955)({
        ...networkStorageParams,
        firstPartyApp: app
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bb0cae74c3a96c49$export$54ef25ae025e12ab), userStoreProps, children);
};


















var $iDdJP = parcelRequire("iDdJP");


var $gq8Du = parcelRequire("gq8Du");


var $pl8ng = parcelRequire("pl8ng");












/**
 * Delay until the text content of the live region is updated.
 *
 * This value was reached through some experimentation, and may need tweaking in the future.
 */ const $714f0bc45b620f55$export$a88f30567ea7367a = 1000;


let $2b230915474122a8$var$node = null;
const $2b230915474122a8$var$size = '1px';
const $2b230915474122a8$var$visuallyHiddenStyles = {
    // Standard visually hidden styles.
    // Copied from our VisuallyHidden (react) package.
    width: $2b230915474122a8$var$size,
    height: $2b230915474122a8$var$size,
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: `rect(${$2b230915474122a8$var$size}, ${$2b230915474122a8$var$size}, ${$2b230915474122a8$var$size}, ${$2b230915474122a8$var$size})`,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    // Pulling upwards slightly to prevent the page
    // from growing when appended to a body that contains
    // an element with height:100%
    marginTop: `-${$2b230915474122a8$var$size}`,
    // Just being safe and letting this element not interfere with hitboxes
    pointerEvents: 'none'
};
/**
 * Creates a live region node, appends it to the body, and returns it.
 */ function $2b230915474122a8$var$createNode() {
    const node = document.createElement('div');
    /**
   * Using `role="status"` instead of `role="alert"` so that the message
   * can be queued and read when able.
   *
   * We found with `role="alert"` the message was not reliably read when
   * focus changed.
   */ node.setAttribute('role', 'status');
    Object.assign(node.style, $2b230915474122a8$var$visuallyHiddenStyles);
    document.body.append(node);
    return node;
}
/**
 * Returns the live region node, creating one if necessary.
 */ function $2b230915474122a8$var$getNode() {
    if ($2b230915474122a8$var$node === null) $2b230915474122a8$var$node = $2b230915474122a8$var$createNode();
    return $2b230915474122a8$var$node;
}
let $2b230915474122a8$var$timerId = null;
function $2b230915474122a8$var$tryClearTimer() {
    if ($2b230915474122a8$var$timerId !== null) clearTimeout($2b230915474122a8$var$timerId);
    $2b230915474122a8$var$timerId = null;
}
function $2b230915474122a8$export$a9b970dcc4ae71a9(message) {
    /**
   * Calling this immediately to ensure a node exists and has time to be parsed
   * and exposed in the accessibility tree.
   */ $2b230915474122a8$var$getNode();
    /**
   * Updating the message in a timeout so that it's less likely to be interrupted.
   *
   * This function is often called right before focus changes,
   * because the user has just taken an action.
   * This focus change would often cause the message to be skipped / interrupted.
   */ $2b230915474122a8$var$tryClearTimer();
    $2b230915474122a8$var$timerId = setTimeout(()=>{
        $2b230915474122a8$var$timerId = null;
        const node = $2b230915474122a8$var$getNode();
        node.textContent = message;
    }, (0, $714f0bc45b620f55$export$a88f30567ea7367a));
    return;
}
function $2b230915474122a8$export$de863c629cb9919d() {
    $2b230915474122a8$var$tryClearTimer();
    $2b230915474122a8$var$node?.remove();
    $2b230915474122a8$var$node = null;
}


const $c62cc7a3e277239c$var$activeStyle = null;
const $c62cc7a3e277239c$var$enteredStyle = null;
const $c62cc7a3e277239c$export$bd7361bd33ae3eff = /*#__PURE__*/ (0, $cozmU.forwardRef)($c62cc7a3e277239c$var$GroupDropIndicatorWithDragOverInner);
const $c62cc7a3e277239c$var$isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $c62cc7a3e277239c$var$GroupDropIndicatorWithDragOverInner_optimized(t0, forwardedRef) {
    const $ = (0, $bDgLe.c)(23);
    const { children: children, isActive: isActive, testId: testId, disableEntered: disableEntered, ariaLabel: ariaLabel } = t0;
    const [isEntered, setIsEntered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const ref = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== ariaLabel || $[1] !== disableEntered || $[2] !== isActive || $[3] !== isEntered) {
        t1 = ()=>{
            if (!isActive || Boolean(disableEntered) || isEntered) return;
            setIsEntered(true);
            if (ariaLabel) (0, $2b230915474122a8$export$a9b970dcc4ae71a9)(ariaLabel);
        };
        $[0] = ariaLabel;
        $[1] = disableEntered;
        $[2] = isActive;
        $[3] = isEntered;
        $[4] = t1;
    } else t1 = $[4];
    const handleDragEnter = t1;
    let t2;
    if ($[5] !== disableEntered || $[6] !== isActive || $[7] !== isEntered) {
        t2 = (event)=>{
            if (!isActive || Boolean(disableEntered) || !isEntered) return;
            const relatedTarget = event.relatedTarget;
            if (ref.current && relatedTarget && ref.current.contains(relatedTarget)) return;
            setIsEntered(false);
        };
        $[5] = disableEntered;
        $[6] = isActive;
        $[7] = isEntered;
        $[8] = t2;
    } else t2 = $[8];
    const handleDragLeave = t2;
    const effectiveIsEntered = isActive && isEntered;
    const t3 = isActive ? "region" : undefined;
    const t4 = isActive && ariaLabel ? ariaLabel : undefined;
    const t5 = isActive && "_2rkolb4i _bfhk19ip";
    const t6 = effectiveIsEntered && "_1cwg12x7 _12y31dm9 _1qu2nqa1 _12jiq98m";
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
        t7 = (0, $hekY6.default)([
            t5,
            t6
        ]);
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== children || $[13] !== effectiveIsEntered || $[14] !== forwardedRef || $[15] !== handleDragEnter || $[16] !== handleDragLeave || $[17] !== isActive || $[18] !== t3 || $[19] !== t4 || $[20] !== t7 || $[21] !== testId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onDragEnter: handleDragEnter,
            onDragLeave: handleDragLeave,
            ref: forwardedRef,
            "data-testid": testId,
            "data-is-active": isActive,
            "data-is-entered": effectiveIsEntered,
            role: t3,
            "aria-label": t4,
            className: t7
        }, children));
        $[12] = children;
        $[13] = effectiveIsEntered;
        $[14] = forwardedRef;
        $[15] = handleDragEnter;
        $[16] = handleDragLeave;
        $[17] = isActive;
        $[18] = t3;
        $[19] = t4;
        $[20] = t7;
        $[21] = testId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
}
function $c62cc7a3e277239c$var$GroupDropIndicatorWithDragOverInner_unoptimized({ children: children, isActive: isActive, testId: testId, disableEntered: disableEntered, ariaLabel: ariaLabel }, forwardedRef) {
    const [isEntered, setIsEntered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const ref = (0, $cozmU.useRef)(null);
    const handleDragEnter = (0, $cozmU.useCallback)(()=>{
        if (!isActive || Boolean(disableEntered) || isEntered) return;
        setIsEntered(true); // Announce directly in the event handler rather than in a chained effect,
        // so the live-region fires in the same event dispatch as the state change.
        if (ariaLabel) (0, $2b230915474122a8$export$a9b970dcc4ae71a9)(ariaLabel);
    }, [
        disableEntered,
        isActive,
        isEntered,
        ariaLabel
    ]);
    const handleDragLeave = (0, $cozmU.useCallback)((event)=>{
        if (!isActive || Boolean(disableEntered) || !isEntered) return;
        const relatedTarget = event.relatedTarget;
        if (ref.current && relatedTarget && ref.current.contains(relatedTarget)) return; // Still within bounds, don't trigger leave
        setIsEntered(false);
    }, [
        disableEntered,
        isActive,
        isEntered
    ]); // `isEntered` is only meaningful when `isActive` is true. Compute the effective
    // value during render instead of resetting state in a chained effect, eliminating
    // one extra render cycle whenever `isActive` becomes false.
    const effectiveIsEntered = isActive && isEntered;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        onDragEnter: handleDragEnter,
        onDragLeave: handleDragLeave,
        ref: forwardedRef,
        "data-testid": testId,
        "data-is-active": isActive,
        "data-is-entered": effectiveIsEntered,
        role: isActive ? 'region' : undefined,
        "aria-label": isActive && ariaLabel ? ariaLabel : undefined,
        className: (0, $hekY6.default)([
            isActive && "_2rkolb4i _bfhk19ip",
            effectiveIsEntered && "_1cwg12x7 _12y31dm9 _1qu2nqa1 _12jiq98m"
        ])
    }, children));
}
function $c62cc7a3e277239c$var$GroupDropIndicatorWithDragOverInner(arg0, arg1) {
    if ($c62cc7a3e277239c$var$isReactCompilerActivePlatform_result) return $c62cc7a3e277239c$var$GroupDropIndicatorWithDragOverInner_optimized(arg0, arg1);
    else return $c62cc7a3e277239c$var$GroupDropIndicatorWithDragOverInner_unoptimized(arg0, arg1);
}


var $6ZNK7 = parcelRequire("6ZNK7");













var $iSrRp = parcelRequire("iSrRp");

const $27df85f702a0a220$export$e782a36b4f98f6f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useDragState(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { dragAndDropEnabled: t1, isItemData: isItemData } = t0;
    const dragAndDropEnabled = t1 === undefined ? false : t1;
    const groupDropIndicatorRef = (0, $cozmU.useRef)(null);
    const [dragState, setDragState] = (0, $cozmU.useState)("idle");
    const [dragSource, setDragSource] = (0, $cozmU.useState)(null);
    let t2;
    let t3;
    if ($[0] !== dragAndDropEnabled || $[1] !== isItemData) {
        t2 = ()=>{
            if (!dragAndDropEnabled) return;
            return (0, $iSrRp.monitorForElements)({
                canMonitor: (t4)=>{
                    const { source: source } = t4;
                    return isItemData(source.data);
                },
                onDragStart (t5) {
                    const { source: source_0 } = t5;
                    setDragSource(source_0.data.menuItemId);
                },
                onDrop () {
                    setDragSource(null);
                }
            });
        };
        t3 = [
            isItemData,
            dragAndDropEnabled
        ];
        $[0] = dragAndDropEnabled;
        $[1] = isItemData;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[4] !== dragAndDropEnabled || $[5] !== isItemData) {
        t4 = ()=>{
            if (!dragAndDropEnabled) return;
            const groupDropIndicator = groupDropIndicatorRef.current;
            (0, $bB0i2.default)(groupDropIndicator, "groupDropIndicatorRef should not be null");
            return (0, $iSrRp.dropTargetForElements)({
                element: groupDropIndicator,
                canDrop: (t6)=>{
                    const { source: source_1 } = t6;
                    return isItemData(source_1.data);
                },
                onDragStart () {
                    setDragState("is-over");
                },
                onDragEnter () {
                    setDragState("is-over");
                },
                onDragLeave () {
                    setDragState("idle");
                },
                onDrop () {
                    setDragState("idle");
                }
            });
        };
        t5 = [
            dragAndDropEnabled,
            isItemData
        ];
        $[4] = dragAndDropEnabled;
        $[5] = isItemData;
        $[6] = t4;
        $[7] = t5;
    } else {
        t4 = $[6];
        t5 = $[7];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[8] !== dragSource || $[9] !== dragState) {
        t6 = {
            groupDropIndicatorRef: groupDropIndicatorRef,
            dragState: dragState,
            dragSource: dragSource
        };
        $[8] = dragSource;
        $[9] = dragState;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : function useDragState({ dragAndDropEnabled: dragAndDropEnabled = false, isItemData: isItemData }) {
    const groupDropIndicatorRef = (0, $cozmU.useRef)(null);
    const [dragState, setDragState] = (0, $cozmU.useState)('idle');
    const [dragSource, setDragSource] = (0, $cozmU.useState)(null);
    // Track drag source menuItemId
    (0, $cozmU.useEffect)(()=>{
        if (!dragAndDropEnabled) return;
        return (0, $iSrRp.monitorForElements)({
            canMonitor: ({ source: source })=>isItemData(source.data),
            onDragStart ({ source: source_0 }) {
                setDragSource(source_0.data.menuItemId);
            },
            onDrop () {
                setDragSource(null);
            }
        });
    }, [
        isItemData,
        dragAndDropEnabled
    ]);
    // Track drop target source
    (0, $cozmU.useEffect)(()=>{
        if (!dragAndDropEnabled) return;
        const groupDropIndicator = groupDropIndicatorRef.current;
        (0, $bB0i2.default)(groupDropIndicator, 'groupDropIndicatorRef should not be null');
        return (0, $iSrRp.dropTargetForElements)({
            element: groupDropIndicator,
            canDrop: ({ source: source_1 })=>isItemData(source_1.data),
            onDragStart () {
                setDragState('is-over');
            },
            onDragEnter () {
                setDragState('is-over');
            },
            onDragLeave () {
                setDragState('idle');
            },
            onDrop () {
                setDragState('idle');
            }
        });
    }, [
        dragAndDropEnabled,
        isItemData
    ]);
    return {
        groupDropIndicatorRef: groupDropIndicatorRef,
        dragState: dragState,
        dragSource: dragSource
    };
};





















var $145zT = parcelRequire("145zT");


var $d5um7 = parcelRequire("d5um7");

var $jZuGB = parcelRequire("jZuGB");

var $gMhPZ = parcelRequire("gMhPZ");


var $91jNq = parcelRequire("91jNq");

var $cVdZm = parcelRequire("cVdZm");

var $9aB3o = parcelRequire("9aB3o");


var $huaOC = parcelRequire("huaOC");


var $h11I1 = parcelRequire("h11I1");





var $igMdc = parcelRequire("igMdc");


















var $4nIKB = parcelRequire("4nIKB");









var $lfoFx = parcelRequire("lfoFx");


var $ghNlj = parcelRequire("ghNlj");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");

const $8fae5a59203426f3$var$emptyEntryPointParams = {};
const $8fae5a59203426f3$var$emptyEntryPointProps = {};
function $8fae5a59203426f3$export$4ebbeeb2921cde03({ triggerProps: triggerProps, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorFallback: errorFallback, fallback: fallback, onError: onError, onOpenChange: onOpenChange, isDefaultOpen: isDefaultOpen = false, ...flyoutProps }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const hasRun = (0, $cozmU.useRef)(false);
    const hasLoaded = (0, $cozmU.useRef)(false);
    const id = (0, $cozmU.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const isOpenControlled = flyoutProps.isFlyoutOpen !== undefined && hasLoaded.current;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [content, setContent] = (0, $cozmU.useState)(null);
    const handleOpenChange = (0, $cozmU.useCallback)((open)=>{
        if (isOpenControlled) // Route through external controller so item.isOpen stays the single source of truth
        onOpenChange?.(open);
        else setIsOpen(open);
    }, [
        isOpenControlled,
        onOpenChange
    ]);
    const handleOpen = (0, $cozmU.useCallback)(()=>handleOpenChange(true), [
        handleOpenChange
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        onOpenChange?.(false);
    }, [
        onOpenChange
    ]);
    const onFlyoutOpenChange = (0, $cozmU.useCallback)((open)=>{
        onOpenChange?.(open);
    }, [
        onOpenChange
    ]);
    const load = (0, $cozmU.useCallback)(()=>(0, $6SsN4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $8fae5a59203426f3$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $cozmU.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing flyout
        if (isOpen) return;
        setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $8fae5a59203426f3$var$emptyEntryPointProps,
                closeFlyout: handleClose
            },
            onError: onError
        }));
        hasLoaded.current = true;
    }, [
        entryPointProps,
        errorFallback,
        fallback,
        handleClose,
        id,
        isOpen,
        onError,
        setContent
    ]);
    // Auto-open on first render if isDefaultOpen is true
    (0, $cozmU.useEffect)(()=>{
        if (!hasRun.current && isDefaultOpen) {
            onLoad({
                reference: load()
            });
            handleOpen();
            hasRun.current = true;
        }
    }, [
        handleOpen,
        isDefaultOpen,
        load,
        onLoad
    ]);
    // Load entry point immediately if the flyout is open and it hasn't loaded
    (0, $cozmU.useEffect)(()=>{
        if (flyoutProps.isFlyoutOpen && !hasLoaded.current) onLoad({
            reference: load()
        });
    }, [
        flyoutProps.isFlyoutOpen,
        load,
        onLoad
    ]);
    // Update internal open state when isOpenControlled changes
    // Allows the open state to be dynamically controlled
    (0, $cozmU.useEffect)(()=>{
        isOpenControlled && setIsOpen(!!flyoutProps.isFlyoutOpen);
    }, [
        flyoutProps.isFlyoutOpen,
        isOpenControlled
    ]);
    const handleTriggerClick = (0, $cozmU.useCallback)(()=>{
        isOpen ? handleClose() : handleOpen();
    }, [
        handleClose,
        handleOpen,
        isOpen
    ]);
    const triggerRef = (0, $ghNlj.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const flyoutTriggerRef = (0, $cozmU.useMemo)(()=>{
        const refs = [
            triggerRef
        ];
        if (triggerProps?.triggerRef) refs.push(triggerProps.triggerRef);
        return (0, $4nIKB.mergeRefs)(refs);
    }, [
        triggerRef,
        triggerProps.triggerRef
    ]);
    const flyoutContent = (0, $cozmU.useCallback)(()=>content, [
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91jNq.FlyoutMenuItem), {
        ...flyoutProps,
        // isDefaultOpen={isDefaultOpen}
        isOpen: isOpen,
        onOpenChange: onFlyoutOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9aB3o.FlyoutMenuItemTrigger), {
        ...triggerProps,
        ref: flyoutTriggerRef,
        onClick: handleTriggerClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVdZm.FlyoutMenuItemContent), {
        onClose: handleClose
    }, flyoutContent()));
}



var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


const $85319652f5dda42e$export$34c0c9850f758c93 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("7EBfr")), {
        moduleId: "55f97069",
        priority: "interaction",
        moduleId: 'objectListFlyoutEntrypoint'
    }),
    getPreloadProps: ()=>({})
});


const $7ca1dbfc771207d1$export$8c8993cce765101e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectListFlyout(props) {
    const $ = (0, $bDgLe.c)(21);
    const { dropIndicator: dropIndicator, elemBefore: elemBefore, entryPoint: t0, entryPointParams: entryPointParams, errorFallback: errorFallback, fallback: fallback, hasDragIndicator: hasDragIndicator, isDefaultOpen: isDefaultOpen, isDragging: isDragging, isFlyoutOpen: isFlyoutOpen, isSelected: isSelected, label: label, labelElem: labelElem, onClick: onClick, onOpenChange: onOpenChange, testId: testId, triggerRef: triggerRef, visualContentRef: visualContentRef } = props;
    const entryPoint = t0 === undefined ? (0, $85319652f5dda42e$export$34c0c9850f758c93) : t0;
    const t1 = labelElem ?? label;
    let t2;
    if ($[0] !== dropIndicator || $[1] !== elemBefore || $[2] !== hasDragIndicator || $[3] !== isDragging || $[4] !== isSelected || $[5] !== onClick || $[6] !== t1 || $[7] !== testId || $[8] !== triggerRef || $[9] !== visualContentRef) {
        t2 = {
            elemBefore: elemBefore,
            children: t1,
            isSelected: isSelected,
            onClick: onClick,
            testId: testId,
            hasDragIndicator: hasDragIndicator,
            isDragging: isDragging,
            dropIndicator: dropIndicator,
            triggerRef: triggerRef,
            visualContentRef: visualContentRef
        };
        $[0] = dropIndicator;
        $[1] = elemBefore;
        $[2] = hasDragIndicator;
        $[3] = isDragging;
        $[4] = isSelected;
        $[5] = onClick;
        $[6] = t1;
        $[7] = testId;
        $[8] = triggerRef;
        $[9] = visualContentRef;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[11] !== entryPoint || $[12] !== entryPointParams || $[13] !== errorFallback || $[14] !== fallback || $[15] !== isDefaultOpen || $[16] !== isFlyoutOpen || $[17] !== onOpenChange || $[18] !== props || $[19] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8fae5a59203426f3$export$4ebbeeb2921cde03), {
            entryPoint: entryPoint,
            entryPointProps: props,
            entryPointParams: entryPointParams,
            errorFallback: errorFallback,
            fallback: fallback,
            isDefaultOpen: isDefaultOpen,
            isFlyoutOpen: isFlyoutOpen,
            onOpenChange: onOpenChange,
            triggerProps: t2
        });
        $[11] = entryPoint;
        $[12] = entryPointParams;
        $[13] = errorFallback;
        $[14] = fallback;
        $[15] = isDefaultOpen;
        $[16] = isFlyoutOpen;
        $[17] = onOpenChange;
        $[18] = props;
        $[19] = t2;
        $[20] = t3;
    } else t3 = $[20];
    return t3;
} : function ObjectListFlyout(props) {
    // We are NOT destructuring all of the properties in `props`.
    // There are extra properties (e.g. props.actions) which are being passed to the entrypoint
    const { dropIndicator: dropIndicator, elemBefore: elemBefore, entryPoint: entryPoint = (0, $85319652f5dda42e$export$34c0c9850f758c93), entryPointParams: entryPointParams, errorFallback: errorFallback, fallback: fallback, hasDragIndicator: hasDragIndicator, isDefaultOpen: isDefaultOpen, isDragging: isDragging, isFlyoutOpen: isFlyoutOpen, isSelected: isSelected, label: label, labelElem: labelElem, onClick: onClick, onOpenChange: onOpenChange, testId: testId, triggerRef: triggerRef, visualContentRef: visualContentRef } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8fae5a59203426f3$export$4ebbeeb2921cde03), {
        entryPoint: entryPoint,
        entryPointProps: props,
        entryPointParams: entryPointParams,
        errorFallback: errorFallback,
        fallback: fallback,
        isDefaultOpen: isDefaultOpen,
        isFlyoutOpen: isFlyoutOpen,
        onOpenChange: onOpenChange,
        triggerProps: {
            elemBefore: elemBefore,
            children: labelElem ?? label,
            isSelected: isSelected,
            onClick: onClick,
            testId: testId,
            hasDragIndicator: hasDragIndicator,
            isDragging: isDragging,
            dropIndicator: dropIndicator,
            triggerRef: triggerRef,
            visualContentRef: visualContentRef
        }
    });
};







const $a0cb8887b022d0ae$export$cd440346ca02126b = (item)=>item.type === 'button';
const $a0cb8887b022d0ae$export$8e525d5a1e55be8f = (item)=>item.type === 'custom';
const $a0cb8887b022d0ae$export$e5ec7109da4bc094 = (item)=>item.type === 'expand';
const $a0cb8887b022d0ae$export$ee29322ec7068717 = (item)=>item.type === 'flyout';
const $a0cb8887b022d0ae$export$4fdefbbdae1adf42 = (item)=>item.type === 'link';
const $a0cb8887b022d0ae$export$10dd63e15344d4ca = (item)=>item.type === 'object-list-flyout';
const $a0cb8887b022d0ae$export$f4fba01b0340f4b5 = (item)=>{
    return item.type === 'component';
};
const $a0cb8887b022d0ae$export$b3885daf9ee22eab = (item)=>{
    return item.type === 'component' && !!(item?.isReorderable && item?.menuItemId);
};














const $a3266033c74afcf2$export$60e3e06657245ab = 'gsn-customize-sidebar';
const $a3266033c74afcf2$export$9536180777e6913e = 'gsn-more-menu';
const $a3266033c74afcf2$export$d1f148bb46faf037 = {
    more: 'global.sidebar.more',
    customize: 'global.sidebar.customize',
    bottomElem: 'global.sidebar.bottomElem'
};



const $aa2301cc5f6e0eef$export$8d6902e2f27b22d5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useNavAnalytics() {
    const $ = (0, $bDgLe.c)(82);
    const { fireEvent: fireEvent } = (0, $19ead867f45fce96$export$5bf35293e545f20c)();
    const { disableMenuCustomization: disableMenuCustomization, hasBottomElement: hasBottomElement } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { allItems: allItems, globalItems: globalItems, growthItemShortcuts: growthItemShortcuts, items: items, shortcuts: shortcuts } = (0, $296fb2d582379b95$export$68ff8f5dbbf3b8af)();
    const { hiddenMenuIds: hiddenMenuIds, hiddenItemMenuIds: hiddenItemMenuIds, hiddenShortcutMenuIds: hiddenShortcutMenuIds, visibleMenuIds: visibleMenuIds, visibleItemMenuIds: visibleItemMenuIds, visibleShortcutMenuIds: visibleShortcutMenuIds } = (0, $b7c49387c5e9ce27$export$f340ebbec0629d31)();
    let t0;
    if ($[0] !== disableMenuCustomization || $[1] !== globalItems || $[2] !== hasBottomElement || $[3] !== hiddenItemMenuIds || $[4] !== hiddenShortcutMenuIds || $[5] !== visibleItemMenuIds) {
        let t1;
        if ($[7] !== globalItems) {
            t1 = (id)=>globalItems.has(id);
            $[7] = globalItems;
            $[8] = t1;
        } else t1 = $[8];
        let t2;
        if ($[9] !== disableMenuCustomization || $[10] !== hiddenItemMenuIds || $[11] !== hiddenShortcutMenuIds) {
            t2 = !disableMenuCustomization ? [
                !!hiddenItemMenuIds.length || !!hiddenShortcutMenuIds.length ? (0, $a3266033c74afcf2$export$d1f148bb46faf037).more : (0, $a3266033c74afcf2$export$d1f148bb46faf037).customize
            ] : [];
            $[9] = disableMenuCustomization;
            $[10] = hiddenItemMenuIds;
            $[11] = hiddenShortcutMenuIds;
            $[12] = t2;
        } else t2 = $[12];
        let t3;
        if ($[13] !== hasBottomElement) {
            t3 = hasBottomElement ? [
                (0, $a3266033c74afcf2$export$d1f148bb46faf037).bottomElem
            ] : [];
            $[13] = hasBottomElement;
            $[14] = t3;
        } else t3 = $[14];
        t0 = [
            ...visibleItemMenuIds.filter(t1),
            ...t2,
            ...t3
        ];
        $[0] = disableMenuCustomization;
        $[1] = globalItems;
        $[2] = hasBottomElement;
        $[3] = hiddenItemMenuIds;
        $[4] = hiddenShortcutMenuIds;
        $[5] = visibleItemMenuIds;
        $[6] = t0;
    } else t0 = $[6];
    const globalItemsList = t0;
    let t1;
    if ($[15] !== allItems || $[16] !== globalItems || $[17] !== visibleItemMenuIds) {
        let t2;
        if ($[19] !== allItems || $[20] !== globalItems) {
            t2 = (id_0)=>allItems[id_0] && !globalItems.has(id_0);
            $[19] = allItems;
            $[20] = globalItems;
            $[21] = t2;
        } else t2 = $[21];
        t1 = visibleItemMenuIds.filter(t2);
        $[15] = allItems;
        $[16] = globalItems;
        $[17] = visibleItemMenuIds;
        $[18] = t1;
    } else t1 = $[18];
    const appSpecificItemsList = t1;
    let t2;
    if ($[22] !== growthItemShortcuts) {
        t2 = Object.keys(growthItemShortcuts ?? {});
        $[22] = growthItemShortcuts;
        $[23] = t2;
    } else t2 = $[23];
    const shortcutIds = t2;
    let t3;
    if ($[24] !== shortcutIds || $[25] !== visibleShortcutMenuIds) {
        t3 = [
            ...visibleShortcutMenuIds,
            ...shortcutIds
        ];
        $[24] = shortcutIds;
        $[25] = visibleShortcutMenuIds;
        $[26] = t3;
    } else t3 = $[26];
    const shortcutItemList = t3;
    let t4;
    if ($[27] !== appSpecificItemsList || $[28] !== globalItemsList || $[29] !== shortcutItemList) {
        t4 = [
            ...globalItemsList,
            ...appSpecificItemsList,
            ...shortcutItemList
        ];
        $[27] = appSpecificItemsList;
        $[28] = globalItemsList;
        $[29] = shortcutItemList;
        $[30] = t4;
    } else t4 = $[30];
    const navItemList = t4;
    let map;
    if ($[31] !== visibleMenuIds) {
        map = new Map();
        visibleMenuIds.forEach((id_1, index)=>map.set(id_1, index));
        $[31] = visibleMenuIds;
        $[32] = map;
    } else map = $[32];
    const visibleMenuIdIndexMap = map;
    let t5;
    if ($[33] !== items) {
        t5 = new Set(Object.keys(items));
        $[33] = items;
        $[34] = t5;
    } else t5 = $[34];
    const itemsIdsSet = t5;
    let t6;
    if ($[35] !== growthItemShortcuts || $[36] !== itemsIdsSet || $[37] !== shortcuts) {
        t6 = (id_2)=>!!growthItemShortcuts?.[id_2] || !!shortcuts?.[id_2] ? "appShortcut" : itemsIdsSet.has(id_2) ? "appSpecific" : "global";
        $[35] = growthItemShortcuts;
        $[36] = itemsIdsSet;
        $[37] = shortcuts;
        $[38] = t6;
    } else t6 = $[38];
    const getItemGroup = t6;
    let t7;
    if ($[39] !== appSpecificItemsList || $[40] !== globalItemsList || $[41] !== shortcutItemList) {
        t7 = (group)=>{
            switch(group){
                case "global":
                    return globalItemsList;
                case "appSpecific":
                    return appSpecificItemsList;
                case "appShortcut":
                    return shortcutItemList;
                default:
                    return [];
            }
        };
        $[39] = appSpecificItemsList;
        $[40] = globalItemsList;
        $[41] = shortcutItemList;
        $[42] = t7;
    } else t7 = $[42];
    const getGroupItems = t7;
    let t8;
    if ($[43] !== appSpecificItemsList || $[44] !== fireEvent || $[45] !== globalItemsList || $[46] !== hiddenItemMenuIds || $[47] !== hiddenShortcutMenuIds || $[48] !== shortcutItemList) {
        t8 = ()=>{
            const moreMenuItems = hiddenItemMenuIds.concat(hiddenShortcutMenuIds);
            fireEvent("ui.sideNav.viewed.sideNavMenu", {
                appSpecificItemsCount: appSpecificItemsList.length,
                appSpecificItemsList: appSpecificItemsList,
                appShortcutItemsCount: shortcutItemList.length,
                appShortcutItemsList: shortcutItemList,
                globalItemsCount: globalItemsList.length,
                globalItemsList: globalItemsList,
                inMoreItemsCount: moreMenuItems.length,
                inMoreItemsList: moreMenuItems
            });
        };
        $[43] = appSpecificItemsList;
        $[44] = fireEvent;
        $[45] = globalItemsList;
        $[46] = hiddenItemMenuIds;
        $[47] = hiddenShortcutMenuIds;
        $[48] = shortcutItemList;
        $[49] = t8;
    } else t8 = $[49];
    const fireViewedSideNavEvent = t8;
    let t9;
    if ($[50] !== fireEvent || $[51] !== getGroupItems || $[52] !== getItemGroup || $[53] !== growthItemShortcuts || $[54] !== hiddenMenuIds || $[55] !== navItemList.length || $[56] !== visibleMenuIdIndexMap) {
        t9 = (id_3, navLayoutComponent, t10, t11)=>{
            const isRightClick = t10 === undefined ? false : t10;
            const status = t11 === undefined ? null : t11;
            const currentGroup = getItemGroup(id_3);
            const isInternalGlobalItem = Object.values((0, $a3266033c74afcf2$export$d1f148bb46faf037)).includes(id_3);
            const visibleGroupItems = getGroupItems(currentGroup);
            const isInMore = (0, $a3266033c74afcf2$export$d1f148bb46faf037).customize === id_3 && !!hiddenMenuIds.length || hiddenMenuIds.includes(id_3);
            const currentIndex = isInMore ? -1 : isInternalGlobalItem || !!growthItemShortcuts?.[id_3] ? visibleMenuIdIndexMap.size : visibleMenuIdIndexMap.get(id_3) ?? -1;
            const currentGroupIndex = isInMore ? -1 : visibleGroupItems.indexOf(id_3);
            const currentComponent = navLayoutComponent ? navLayoutComponent : isInMore ? "postMain" : "main";
            fireEvent("ui.sideNav.clicked.sideNavItem", {
                navLayoutComponent: currentComponent,
                navItemsCount: navItemList.length,
                navItemsIndex: currentIndex,
                group: currentGroup,
                groupItemsCount: visibleGroupItems.length,
                groupItemsIndex: currentGroupIndex,
                groupItem: id_3,
                isInMore: isInMore,
                isRightClick: isRightClick,
                status: status
            });
        };
        $[50] = fireEvent;
        $[51] = getGroupItems;
        $[52] = getItemGroup;
        $[53] = growthItemShortcuts;
        $[54] = hiddenMenuIds;
        $[55] = navItemList.length;
        $[56] = visibleMenuIdIndexMap;
        $[57] = t9;
    } else t9 = $[57];
    const fireClickedSideNavItemEvent = t9;
    let t10;
    if ($[58] !== fireEvent || $[59] !== getGroupItems || $[60] !== getItemGroup || $[61] !== growthItemShortcuts || $[62] !== navItemList.length || $[63] !== visibleMenuIdIndexMap) {
        t10 = (id_4, t11)=>{
            const isInMore_0 = t11 === undefined ? false : t11;
            const currentGroup_0 = getItemGroup(id_4);
            const visibleGroupItems_0 = getGroupItems(currentGroup_0);
            const currentIndex_0 = isInMore_0 ? -1 : !!growthItemShortcuts?.[id_4] ? visibleMenuIdIndexMap.size : visibleMenuIdIndexMap.get(id_4) ?? -1;
            const currentGroupIndex_0 = isInMore_0 ? -1 : visibleGroupItems_0.indexOf(id_4);
            const currentComponent_0 = isInMore_0 ? "postMain" : "main";
            fireEvent("ui.sideNav.dragged.sideNavItem", {
                navLayoutComponent: currentComponent_0,
                navItemsCount: navItemList.length,
                navItemsIndex: currentIndex_0,
                group: currentGroup_0,
                groupItemsCount: visibleGroupItems_0.length,
                groupItemsIndex: currentGroupIndex_0,
                groupItem: id_4,
                isInMore: isInMore_0
            });
        };
        $[58] = fireEvent;
        $[59] = getGroupItems;
        $[60] = getItemGroup;
        $[61] = growthItemShortcuts;
        $[62] = navItemList.length;
        $[63] = visibleMenuIdIndexMap;
        $[64] = t10;
    } else t10 = $[64];
    const fireDraggedSideNavItemEvent = t10;
    let t11;
    if ($[65] !== fireEvent || $[66] !== getGroupItems || $[67] !== getItemGroup) {
        t11 = (id_5, subItemsCount, t12, navLayoutComponent_0)=>{
            const isInMore_1 = t12 === undefined ? false : t12;
            const currentGroup_1 = getItemGroup(id_5);
            const visibleGroupItems_1 = getGroupItems(currentGroup_1);
            const currentComponent_1 = navLayoutComponent_0 ? navLayoutComponent_0 : isInMore_1 ? "postMain" : "main";
            fireEvent("ui.sideNav.viewed.sideNavSubMenu", {
                group: currentGroup_1,
                groupItem: id_5,
                groupItemsCount: visibleGroupItems_1.length,
                groupItemsIndex: visibleGroupItems_1.indexOf(id_5),
                groupSubItemCount: subItemsCount ?? null,
                isInMore: isInMore_1,
                navLayoutComponent: currentComponent_1
            });
        };
        $[65] = fireEvent;
        $[66] = getGroupItems;
        $[67] = getItemGroup;
        $[68] = t11;
    } else t11 = $[68];
    const fireViewedSideNavSubMenuEvent = t11;
    let t12;
    if ($[69] !== fireEvent) {
        t12 = (shortcuts_0)=>{
            const attributes = {
                appShortcutItemsCount: shortcuts_0.length,
                appShortcutItemsList: shortcuts_0.map($aa2301cc5f6e0eef$var$_temp)
            };
            fireEvent("ui.sideNav.viewed.sideNavAppShortcutsSection", attributes);
        };
        $[69] = fireEvent;
        $[70] = t12;
    } else t12 = $[70];
    const fireViewedShortcutsEvent = t12;
    let t13;
    if ($[71] !== fireEvent || $[72] !== getGroupItems || $[73] !== getItemGroup) {
        t13 = (id_6, subItemsCount_0, t14, t15, navLayoutComponent_1, extendedSubItemAnalyticsAttributes)=>{
            const isInMore_2 = t14 === undefined ? false : t14;
            const isRightClick_0 = t15 === undefined ? false : t15;
            const currentGroup_2 = getItemGroup(id_6);
            const visibleGroupItems_2 = getGroupItems(currentGroup_2);
            const currentComponent_2 = navLayoutComponent_1 ? navLayoutComponent_1 : isInMore_2 ? "postMain" : "main";
            fireEvent("ui.sideNav.clicked.sideNavSubItem", {
                group: currentGroup_2,
                groupItem: id_6,
                groupItemsCount: visibleGroupItems_2.length,
                groupItemsIndex: visibleGroupItems_2.indexOf(id_6),
                groupSubItem: null,
                groupSubItemCount: subItemsCount_0 ?? null,
                groupSubItemIndex: null,
                isInMore: isInMore_2,
                isRightClick: isRightClick_0,
                navLayoutComponent: currentComponent_2,
                extendedAnalyticsAttributes: extendedSubItemAnalyticsAttributes ?? null
            });
        };
        $[71] = fireEvent;
        $[72] = getGroupItems;
        $[73] = getItemGroup;
        $[74] = t13;
    } else t13 = $[74];
    const fireClickedSideNavSubMenuItemEvent = t13;
    let t14;
    if ($[75] !== fireClickedSideNavItemEvent || $[76] !== fireClickedSideNavSubMenuItemEvent || $[77] !== fireDraggedSideNavItemEvent || $[78] !== fireViewedShortcutsEvent || $[79] !== fireViewedSideNavEvent || $[80] !== fireViewedSideNavSubMenuEvent) {
        t14 = {
            fireClickedSideNavItemEvent: fireClickedSideNavItemEvent,
            fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent,
            fireDraggedSideNavItemEvent: fireDraggedSideNavItemEvent,
            fireViewedShortcutsEvent: fireViewedShortcutsEvent,
            fireViewedSideNavEvent: fireViewedSideNavEvent,
            fireViewedSideNavSubMenuEvent: fireViewedSideNavSubMenuEvent
        };
        $[75] = fireClickedSideNavItemEvent;
        $[76] = fireClickedSideNavSubMenuItemEvent;
        $[77] = fireDraggedSideNavItemEvent;
        $[78] = fireViewedShortcutsEvent;
        $[79] = fireViewedSideNavEvent;
        $[80] = fireViewedSideNavSubMenuEvent;
        $[81] = t14;
    } else t14 = $[81];
    return t14;
} : function useNavAnalytics() {
    const { fireEvent: fireEvent } = (0, $19ead867f45fce96$export$5bf35293e545f20c)();
    const { disableMenuCustomization: disableMenuCustomization, hasBottomElement: hasBottomElement } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { allItems: allItems, globalItems: globalItems, growthItemShortcuts: growthItemShortcuts, items: items, shortcuts: shortcuts } = (0, $296fb2d582379b95$export$68ff8f5dbbf3b8af)();
    const { hiddenMenuIds: hiddenMenuIds, hiddenItemMenuIds: hiddenItemMenuIds, hiddenShortcutMenuIds: hiddenShortcutMenuIds, visibleMenuIds: visibleMenuIds, visibleItemMenuIds: visibleItemMenuIds, visibleShortcutMenuIds: visibleShortcutMenuIds } = (0, $b7c49387c5e9ce27$export$f340ebbec0629d31)();
    // Global items + customize/more + bottom element
    const globalItemsList = (0, $cozmU.useMemo)(()=>[
            ...visibleItemMenuIds.filter((id)=>globalItems.has(id)),
            ...!disableMenuCustomization ? [
                !!hiddenItemMenuIds.length || !!hiddenShortcutMenuIds.length ? (0, $a3266033c74afcf2$export$d1f148bb46faf037).more : (0, $a3266033c74afcf2$export$d1f148bb46faf037).customize
            ] : [],
            ...hasBottomElement ? [
                (0, $a3266033c74afcf2$export$d1f148bb46faf037).bottomElem
            ] : []
        ], [
        disableMenuCustomization,
        hasBottomElement,
        hiddenItemMenuIds,
        hiddenShortcutMenuIds,
        globalItems,
        visibleItemMenuIds
    ]);
    // App specific items
    const appSpecificItemsList = (0, $cozmU.useMemo)(()=>visibleItemMenuIds.filter((id_0)=>allItems[id_0] && !globalItems.has(id_0)), [
        allItems,
        globalItems,
        visibleItemMenuIds
    ]);
    // Shortcuts + growth shortcuts
    const shortcutIds = (0, $cozmU.useMemo)(()=>Object.keys(growthItemShortcuts ?? {}), [
        growthItemShortcuts
    ]);
    const shortcutItemList = (0, $cozmU.useMemo)(()=>[
            ...visibleShortcutMenuIds,
            ...shortcutIds
        ], [
        visibleShortcutMenuIds,
        shortcutIds
    ]);
    // All visible items
    const navItemList = (0, $cozmU.useMemo)(()=>[
            ...globalItemsList,
            ...appSpecificItemsList,
            ...shortcutItemList
        ], [
        globalItemsList,
        appSpecificItemsList,
        shortcutItemList
    ]);
    // Index map for O(1) lookup performance
    const visibleMenuIdIndexMap = (0, $cozmU.useMemo)(()=>{
        const map = new Map();
        visibleMenuIds.forEach((id_1, index)=>map.set(id_1, index));
        return map;
    }, [
        visibleMenuIds
    ]);
    // Item group
    const itemsIdsSet = (0, $cozmU.useMemo)(()=>new Set(Object.keys(items)), [
        items
    ]);
    const getItemGroup = (0, $cozmU.useCallback)((id_2)=>{
        return !!growthItemShortcuts?.[id_2] || !!shortcuts?.[id_2] ? 'appShortcut' : itemsIdsSet.has(id_2) ? 'appSpecific' : 'global';
    }, [
        growthItemShortcuts,
        itemsIdsSet,
        shortcuts
    ]);
    const getGroupItems = (0, $cozmU.useCallback)((group)=>{
        switch(group){
            case 'global':
                return globalItemsList;
            case 'appSpecific':
                return appSpecificItemsList;
            case 'appShortcut':
                return shortcutItemList;
            default:
                return [];
        }
    }, [
        appSpecificItemsList,
        globalItemsList,
        shortcutItemList
    ]);
    const fireViewedSideNavEvent = (0, $cozmU.useCallback)(()=>{
        const moreMenuItems = hiddenItemMenuIds.concat(hiddenShortcutMenuIds);
        fireEvent('ui.sideNav.viewed.sideNavMenu', {
            appSpecificItemsCount: appSpecificItemsList.length,
            appSpecificItemsList: appSpecificItemsList,
            appShortcutItemsCount: shortcutItemList.length,
            appShortcutItemsList: shortcutItemList,
            globalItemsCount: globalItemsList.length,
            globalItemsList: globalItemsList,
            inMoreItemsCount: moreMenuItems.length,
            inMoreItemsList: moreMenuItems
        });
    }, [
        hiddenItemMenuIds,
        hiddenShortcutMenuIds,
        globalItemsList,
        appSpecificItemsList,
        shortcutItemList,
        fireEvent
    ]);
    const fireClickedSideNavItemEvent = (0, $cozmU.useCallback)((id_3, navLayoutComponent, isRightClick = false, status = null)=>{
        // Assign the current group based on the item type
        const currentGroup = getItemGroup(id_3);
        const isInternalGlobalItem = Object.values((0, $a3266033c74afcf2$export$d1f148bb46faf037)).includes(id_3);
        // Get visible items based on their group
        const visibleGroupItems = getGroupItems(currentGroup);
        const isInMore = // customize is in more if there are any hidden items
        (0, $a3266033c74afcf2$export$d1f148bb46faf037).customize === id_3 && !!hiddenMenuIds.length || hiddenMenuIds.includes(id_3);
        // Current index irrespective of the item group
        const currentIndex = isInMore ? -1 : // More and customise and growth shortcuts are always at the end of the list
        isInternalGlobalItem || !!growthItemShortcuts?.[id_3] ? visibleMenuIdIndexMap.size : visibleMenuIdIndexMap.get(id_3) ?? -1;
        // Current index within the item group
        const currentGroupIndex = isInMore ? -1 : visibleGroupItems.indexOf(id_3);
        const currentComponent = navLayoutComponent ? navLayoutComponent : isInMore ? 'postMain' : 'main';
        fireEvent('ui.sideNav.clicked.sideNavItem', {
            navLayoutComponent: currentComponent,
            navItemsCount: navItemList.length,
            navItemsIndex: currentIndex,
            group: currentGroup,
            groupItemsCount: visibleGroupItems.length,
            groupItemsIndex: currentGroupIndex,
            groupItem: id_3,
            isInMore: isInMore,
            isRightClick: isRightClick,
            status: status
        });
    }, [
        fireEvent,
        getGroupItems,
        getItemGroup,
        growthItemShortcuts,
        hiddenMenuIds,
        navItemList.length,
        visibleMenuIdIndexMap
    ]);
    const fireDraggedSideNavItemEvent = (0, $cozmU.useCallback)((id_4, isInMore_0 = false)=>{
        // Assign the current group based on the item type
        const currentGroup_0 = getItemGroup(id_4);
        // Get visible items based on their group
        const visibleGroupItems_0 = getGroupItems(currentGroup_0);
        // Current index irrespective of the item group
        const currentIndex_0 = isInMore_0 ? -1 : // growth shortcuts are always at the end of the list
        !!growthItemShortcuts?.[id_4] ? visibleMenuIdIndexMap.size : visibleMenuIdIndexMap.get(id_4) ?? -1;
        // Current index within the item group
        const currentGroupIndex_0 = isInMore_0 ? -1 : visibleGroupItems_0.indexOf(id_4);
        const currentComponent_0 = isInMore_0 ? 'postMain' : 'main';
        fireEvent('ui.sideNav.dragged.sideNavItem', {
            navLayoutComponent: currentComponent_0,
            navItemsCount: navItemList.length,
            navItemsIndex: currentIndex_0,
            group: currentGroup_0,
            groupItemsCount: visibleGroupItems_0.length,
            groupItemsIndex: currentGroupIndex_0,
            groupItem: id_4,
            isInMore: isInMore_0
        });
    }, [
        fireEvent,
        getGroupItems,
        getItemGroup,
        growthItemShortcuts,
        navItemList.length,
        visibleMenuIdIndexMap
    ]);
    const fireViewedSideNavSubMenuEvent = (0, $cozmU.useCallback)((id_5, subItemsCount, isInMore_1 = false, navLayoutComponent_0)=>{
        // Assign the current group based on the item type
        const currentGroup_1 = getItemGroup(id_5);
        // Get visible items based on their group
        const visibleGroupItems_1 = getGroupItems(currentGroup_1);
        const currentComponent_1 = navLayoutComponent_0 ? navLayoutComponent_0 : isInMore_1 ? 'postMain' : 'main';
        fireEvent('ui.sideNav.viewed.sideNavSubMenu', {
            group: currentGroup_1,
            groupItem: id_5,
            groupItemsCount: visibleGroupItems_1.length,
            groupItemsIndex: visibleGroupItems_1.indexOf(id_5),
            groupSubItemCount: subItemsCount ?? null,
            isInMore: isInMore_1,
            navLayoutComponent: currentComponent_1
        });
    }, [
        fireEvent,
        getGroupItems,
        getItemGroup
    ]);
    const fireViewedShortcutsEvent = (0, $cozmU.useCallback)((shortcuts_0)=>{
        const attributes = {
            appShortcutItemsCount: shortcuts_0.length,
            appShortcutItemsList: shortcuts_0.map((item)=>item.label)
        };
        fireEvent('ui.sideNav.viewed.sideNavAppShortcutsSection', attributes);
    }, [
        fireEvent
    ]);
    const fireClickedSideNavSubMenuItemEvent = (0, $cozmU.useCallback)((id_6, subItemsCount_0, isInMore_2 = false, isRightClick_0 = false, navLayoutComponent_1, extendedSubItemAnalyticsAttributes)=>{
        // Assign the current group based on the item type
        const currentGroup_2 = getItemGroup(id_6);
        // Get visible items based on their group
        const visibleGroupItems_2 = getGroupItems(currentGroup_2);
        const currentComponent_2 = navLayoutComponent_1 ? navLayoutComponent_1 : isInMore_2 ? 'postMain' : 'main';
        fireEvent('ui.sideNav.clicked.sideNavSubItem', {
            group: currentGroup_2,
            groupItem: id_6,
            groupItemsCount: visibleGroupItems_2.length,
            groupItemsIndex: visibleGroupItems_2.indexOf(id_6),
            groupSubItem: null,
            groupSubItemCount: subItemsCount_0 ?? null,
            groupSubItemIndex: null,
            isInMore: isInMore_2,
            isRightClick: isRightClick_0,
            navLayoutComponent: currentComponent_2,
            extendedAnalyticsAttributes: extendedSubItemAnalyticsAttributes ?? null
        });
    }, [
        fireEvent,
        getGroupItems,
        getItemGroup
    ]);
    return {
        fireClickedSideNavItemEvent: fireClickedSideNavItemEvent,
        fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent,
        fireDraggedSideNavItemEvent: fireDraggedSideNavItemEvent,
        fireViewedShortcutsEvent: fireViewedShortcutsEvent,
        fireViewedSideNavEvent: fireViewedSideNavEvent,
        fireViewedSideNavSubMenuEvent: fireViewedSideNavSubMenuEvent
    };
};
function $aa2301cc5f6e0eef$var$_temp(item) {
    return item.label;
}











const $9f15b3cc67dce92b$export$e66526057f4a5c1e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useExpandOpenState(item, peek) {
    const $ = (0, $bDgLe.c)(14);
    const { type: type } = item;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "expand",
            "flyout",
            "object-list-flyout"
        ];
        $[0] = t0;
    } else t0 = $[0];
    const isExpandable = t0.includes(type);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "expand",
            "flyout"
        ];
        $[1] = t1;
    } else t1 = $[1];
    const isExpandableOnPeek = t1.includes(type);
    const isExpandedFromProps = (type === "expand" ? item.isExpanded : undefined) ?? (type === "flyout" || type === "object-list-flyout" ? item.isOpen : undefined);
    const isDefaultExpanded = (type === "expand" ? item.isDefaultExpanded : undefined) ?? (type === "flyout" || type === "object-list-flyout" ? item.isDefaultOpen : undefined);
    const initState = isExpandableOnPeek && peek ? true : typeof isExpandedFromProps === "boolean" ? isExpandedFromProps : typeof isDefaultExpanded === "boolean" ? isDefaultExpanded : false;
    const [isExpandOrFlyoutOpen, setIsExpandOrFlyoutOpen] = (0, $cozmU.useState)(initState);
    let t2;
    if ($[2] !== isExpandable || $[3] !== isExpandableOnPeek || $[4] !== isExpandedFromProps || $[5] !== peek) {
        t2 = {
            isExpandedFromProps: isExpandedFromProps,
            isExpandable: isExpandable,
            peek: peek,
            isExpandableOnPeek: isExpandableOnPeek,
            setIsExpandOrFlyoutOpen: setIsExpandOrFlyoutOpen
        };
        $[2] = isExpandable;
        $[3] = isExpandableOnPeek;
        $[4] = isExpandedFromProps;
        $[5] = peek;
        $[6] = t2;
    } else t2 = $[6];
    const hookParams = t2;
    $9f15b3cc67dce92b$var$useCustomSyncState(hookParams);
    const onExpanded = (type === "expand" ? item.onExpansionToggle : undefined) ?? (type === "flyout" || type === "object-list-flyout" ? item.onOpenChange : undefined);
    let t3;
    if ($[7] !== isExpandable || $[8] !== onExpanded) {
        t3 = (isExpandedOrOpen)=>{
            if (!isExpandable) return;
            setIsExpandOrFlyoutOpen(isExpandedOrOpen);
            onExpanded?.(isExpandedOrOpen);
        };
        $[7] = isExpandable;
        $[8] = onExpanded;
        $[9] = t3;
    } else t3 = $[9];
    const onExpandFlyoutToggle = t3;
    let t4;
    if ($[10] !== isExpandOrFlyoutOpen || $[11] !== isExpandable || $[12] !== onExpandFlyoutToggle) {
        t4 = {
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            onExpandFlyoutToggle: onExpandFlyoutToggle,
            isExpandable: isExpandable
        };
        $[10] = isExpandOrFlyoutOpen;
        $[11] = isExpandable;
        $[12] = onExpandFlyoutToggle;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : function useExpandOpenState(item, peek) {
    const { type: type } = item;
    const isExpandable = [
        'expand',
        'flyout',
        'object-list-flyout'
    ].includes(type);
    const isExpandableOnPeek = [
        'expand',
        'flyout'
    ].includes(type);
    const isExpandedFromProps = (type === 'expand' ? item.isExpanded : undefined) ?? (type === 'flyout' || type === 'object-list-flyout' ? item.isOpen : undefined);
    const isDefaultExpanded = (type === 'expand' ? item.isDefaultExpanded : undefined) ?? (type === 'flyout' || type === 'object-list-flyout' ? item.isDefaultOpen : undefined);
    // Peeked expand/flyout items should open initially, even if they are controlled closed.
    const initState = isExpandableOnPeek && peek ? true : typeof isExpandedFromProps === 'boolean' ? isExpandedFromProps : typeof isDefaultExpanded === 'boolean' ? isDefaultExpanded : false;
    const [isExpandOrFlyoutOpen, setIsExpandOrFlyoutOpen] = (0, $cozmU.useState)(initState);
    const hookParams = (0, $cozmU.useMemo)(()=>({
            isExpandedFromProps: isExpandedFromProps,
            isExpandable: isExpandable,
            peek: peek,
            isExpandableOnPeek: isExpandableOnPeek,
            setIsExpandOrFlyoutOpen: setIsExpandOrFlyoutOpen
        }), [
        isExpandedFromProps,
        isExpandable,
        peek,
        isExpandableOnPeek,
        setIsExpandOrFlyoutOpen
    ]);
    $9f15b3cc67dce92b$var$useCustomSyncState(hookParams);
    const onExpanded = (type === 'expand' ? item.onExpansionToggle : undefined) ?? (type === 'flyout' || type === 'object-list-flyout' ? item.onOpenChange : undefined);
    const onExpandFlyoutToggle = (0, $cozmU.useCallback)((isExpandedOrOpen)=>{
        if (!isExpandable) return;
        setIsExpandOrFlyoutOpen(isExpandedOrOpen);
        onExpanded?.(isExpandedOrOpen);
    }, [
        isExpandable,
        onExpanded
    ]);
    return {
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        isExpandable: isExpandable
    };
};
// Sync internal state when controlled props change during render (not in an effect).
// This avoids hydration mismatches caused by useEffect setting state post-hydration.
// See: https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
function $9f15b3cc67dce92b$var$useCustomSyncState(params) {
    const { isExpandedFromProps: isExpandedFromProps, isExpandable: isExpandable, peek: peek, isExpandableOnPeek: isExpandableOnPeek, setIsExpandOrFlyoutOpen: setIsExpandOrFlyoutOpen } = params;
    const prevIsExpandedFromProps = (0, $cozmU.useRef)(isExpandedFromProps);
    const prevPeek = (0, $cozmU.useRef)(peek);
    if (isExpandable) {
        if (isExpandedFromProps !== prevIsExpandedFromProps.current) {
            prevIsExpandedFromProps.current = isExpandedFromProps;
            if (typeof isExpandedFromProps === 'boolean' && !peek) setIsExpandOrFlyoutOpen(isExpandedFromProps);
        }
        if (peek !== prevPeek.current) {
            prevPeek.current = peek;
            if (isExpandableOnPeek && peek) setIsExpandOrFlyoutOpen(true);
        }
    }
}


// Gated behind `navx-4728-jira-stability-fixes`: gate ON renders the refactored
// `NavItemRawStable`, which splits each item type into its own memoised leaf
// component and hands each leaf a referentially-stable `onClick` so the
// memoised `LinkMenuItem` / `ButtonMenuItem` / trigger leaves are not handed a
// brand-new handler on every `NavItem` render (which would defeat their memo).
// Gate OFF renders the original `NavItemRaw`, preserving current behaviour.
const $fbfe2ad3510eceba$var$GatedNavItem = (0, $rECdA.componentWithFG)('navx-4728-jira-stability-fixes', $fbfe2ad3510eceba$var$NavItemRawStable, $fbfe2ad3510eceba$var$NavItemRaw);
const $fbfe2ad3510eceba$export$e3925dbaeffcc83f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($fbfe2ad3510eceba$var$GatedNavItem);
var $fbfe2ad3510eceba$export$2e2bcd8739ae039 = $fbfe2ad3510eceba$export$e3925dbaeffcc83f;
const $fbfe2ad3510eceba$var$isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $fbfe2ad3510eceba$var$NavItemRaw_optimized(t0) {
    const $ = (0, $bDgLe.c)(227);
    const { id: id, item: item, peek: t1, isInMoreMenu: t2, onClick: onClick, onPeek: onPeek, group: t3 } = t0;
    const peek = t1 === undefined ? false : t1;
    const isInMoreMenu = t2 === undefined ? false : t2;
    const group = t3 === undefined ? (0, $gq8Du.L1_MENU_GROUPS).MENU : t3;
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { type: type } = item;
    const ItemWrapper = item.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const { isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isExpandable: isExpandable } = (0, $9f15b3cc67dce92b$export$e66526057f4a5c1e)(item, peek);
    let t4;
    if ($[0] !== group || $[1] !== id || $[2] !== isExpandOrFlyoutOpen || $[3] !== isExpandable || $[4] !== item || $[5] !== l1DragAndDropEnabled || $[6] !== onExpandFlyoutToggle || $[7] !== peek) {
        t4 = {
            item: item,
            id: id,
            isExpandable: isExpandable,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            onExpandFlyoutToggle: onExpandFlyoutToggle,
            peek: peek,
            group: group,
            l1DragAndDropEnabled: l1DragAndDropEnabled
        };
        $[0] = group;
        $[1] = id;
        $[2] = isExpandOrFlyoutOpen;
        $[3] = isExpandable;
        $[4] = item;
        $[5] = l1DragAndDropEnabled;
        $[6] = onExpandFlyoutToggle;
        $[7] = peek;
        $[8] = t4;
    } else t4 = $[8];
    const { draggableRef: draggableRef, isItemDraggable: isItemDraggable, isDragging: isDragging, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview } = (0, $igMdc.useL1ItemDragAndDrop)(t4);
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent, fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent, fireViewedSideNavSubMenuEvent: fireViewedSideNavSubMenuEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    let t5;
    if ($[9] !== fireClickedSideNavItemEvent || $[10] !== id) {
        t5 = (isRightClick, status)=>{
            (0, $ixfCV.fg)("navx-global-side-nav-confluence") ? fireClickedSideNavItemEvent(id, undefined, isRightClick, status) : fireClickedSideNavItemEvent(id, undefined, isRightClick);
        };
        $[9] = fireClickedSideNavItemEvent;
        $[10] = id;
        $[11] = t5;
    } else t5 = $[11];
    const onNavItemClick = t5;
    let t6;
    if ($[12] !== fireClickedSideNavSubMenuItemEvent || $[13] !== id || $[14] !== isInMoreMenu) {
        t6 = (isRightClick_0, extendedAttributes)=>{
            fireClickedSideNavSubMenuItemEvent(id, undefined, isInMoreMenu, isRightClick_0, undefined, extendedAttributes ?? null);
        };
        $[12] = fireClickedSideNavSubMenuItemEvent;
        $[13] = id;
        $[14] = isInMoreMenu;
        $[15] = t6;
    } else t6 = $[15];
    const onSubMenuItemClick = t6;
    let t7;
    if ($[16] !== fireViewedSideNavSubMenuEvent || $[17] !== id || $[18] !== isExpandOrFlyoutOpen || $[19] !== isExpandable || $[20] !== isInMoreMenu) {
        t7 = ()=>{
            if (isExpandable && isExpandOrFlyoutOpen) fireViewedSideNavSubMenuEvent(id, undefined, isInMoreMenu);
        };
        $[16] = fireViewedSideNavSubMenuEvent;
        $[17] = id;
        $[18] = isExpandOrFlyoutOpen;
        $[19] = isExpandable;
        $[20] = isInMoreMenu;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== fireViewedSideNavSubMenuEvent || $[23] !== id || $[24] !== isExpandOrFlyoutOpen || $[25] !== isExpandable || $[26] !== isInMoreMenu || $[27] !== type) {
        t8 = [
            fireViewedSideNavSubMenuEvent,
            id,
            isExpandOrFlyoutOpen,
            isExpandable,
            isInMoreMenu,
            type
        ];
        $[22] = fireViewedSideNavSubMenuEvent;
        $[23] = id;
        $[24] = isExpandOrFlyoutOpen;
        $[25] = isExpandable;
        $[26] = isInMoreMenu;
        $[27] = type;
        $[28] = t8;
    } else t8 = $[28];
    (0, $cozmU.useEffect)(t7, t8);
    if ((0, $a0cb8887b022d0ae$export$8e525d5a1e55be8f)(item)) {
        const Wrapper = item.isMenuListItem ? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment : (0, $h11I1.MenuListItem);
        const t9 = isInMoreMenu && !peek;
        let t10;
        if ($[29] !== fireClickedSideNavItemEvent || $[30] !== id || $[31] !== item.Component.defaultProps || $[32] !== onClick) {
            t10 = (...t11)=>{
                const args = t11;
                item.Component.defaultProps?.onClick?.(...args);
                fireClickedSideNavItemEvent(id);
                onClick?.();
            };
            $[29] = fireClickedSideNavItemEvent;
            $[30] = id;
            $[31] = item.Component.defaultProps;
            $[32] = onClick;
            $[33] = t10;
        } else t10 = $[33];
        let t11;
        if ($[34] !== draggableRef || $[35] !== dropIndicator || $[36] !== dropTargetRef || $[37] !== isDragging || $[38] !== isExpandOrFlyoutOpen || $[39] !== isItemDraggable || $[40] !== item.Component || $[41] !== onExpandFlyoutToggle || $[42] !== onPeek || $[43] !== peek || $[44] !== t10 || $[45] !== t9) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(item.Component, {
                draggableRef: draggableRef,
                dropIndicator: dropIndicator,
                hasDragIndicator: isItemDraggable,
                isDragging: isDragging,
                isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
                isInMoreMenu: t9,
                isPeeked: peek,
                onClick: t10,
                onExpandFlyoutToggle: onExpandFlyoutToggle,
                onPeek: onPeek,
                visualContentRef: dropTargetRef
            });
            $[34] = draggableRef;
            $[35] = dropIndicator;
            $[36] = dropTargetRef;
            $[37] = isDragging;
            $[38] = isExpandOrFlyoutOpen;
            $[39] = isItemDraggable;
            $[40] = item.Component;
            $[41] = onExpandFlyoutToggle;
            $[42] = onPeek;
            $[43] = peek;
            $[44] = t10;
            $[45] = t9;
            $[46] = t11;
        } else t11 = $[46];
        let t12;
        if ($[47] !== Wrapper || $[48] !== maybeDragPreview || $[49] !== t11) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, t11, maybeDragPreview);
            $[47] = Wrapper;
            $[48] = maybeDragPreview;
            $[49] = t11;
            $[50] = t12;
        } else t12 = $[50];
        let t13;
        if ($[51] !== ItemWrapper || $[52] !== t12) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t12);
            $[51] = ItemWrapper;
            $[52] = t12;
            $[53] = t13;
        } else t13 = $[53];
        return t13;
    } else {
        if ((0, $a0cb8887b022d0ae$export$4fdefbbdae1adf42)(item)) {
            let t9;
            if ($[54] !== item) {
                t9 = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, "type");
                $[54] = item;
                $[55] = t9;
            } else t9 = $[55];
            let label;
            let labelElem;
            let linkMenuItemProps;
            if ($[56] !== t9) {
                ({ label: label, labelElem: labelElem, ...linkMenuItemProps } = t9);
                $[56] = t9;
                $[57] = label;
                $[58] = labelElem;
                $[59] = linkMenuItemProps;
            } else {
                label = $[57];
                labelElem = $[58];
                linkMenuItemProps = $[59];
            }
            let t10;
            if ($[60] !== linkMenuItemProps || $[61] !== onClick || $[62] !== onNavItemClick) {
                t10 = (...t11)=>{
                    const args_0 = t11;
                    linkMenuItemProps.onClick?.(...args_0);
                    onNavItemClick();
                    onClick?.();
                };
                $[60] = linkMenuItemProps;
                $[61] = onClick;
                $[62] = onNavItemClick;
                $[63] = t10;
            } else t10 = $[63];
            let t11;
            if ($[64] !== group || $[65] !== id || $[66] !== isInMoreMenu || $[67] !== isItemDraggable || $[68] !== item) {
                t11 = $fbfe2ad3510eceba$var$getActionsOnHover({
                    id: id,
                    isItemDraggable: isItemDraggable,
                    item: item,
                    isInMoreMenu: isInMoreMenu,
                    group: group
                });
                $[64] = group;
                $[65] = id;
                $[66] = isInMoreMenu;
                $[67] = isItemDraggable;
                $[68] = item;
                $[69] = t11;
            } else t11 = $[69];
            const t12 = labelElem ?? label;
            let t13;
            if ($[70] !== draggableRef || $[71] !== dropIndicator || $[72] !== dropTargetRef || $[73] !== isDragging || $[74] !== isItemDraggable || $[75] !== linkMenuItemProps || $[76] !== t10 || $[77] !== t11 || $[78] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
                    ...linkMenuItemProps,
                    onClick: t10,
                    hasDragIndicator: isItemDraggable,
                    ref: draggableRef,
                    isDragging: isDragging,
                    dropIndicator: dropIndicator,
                    visualContentRef: dropTargetRef,
                    actionsOnHover: t11
                }, t12);
                $[70] = draggableRef;
                $[71] = dropIndicator;
                $[72] = dropTargetRef;
                $[73] = isDragging;
                $[74] = isItemDraggable;
                $[75] = linkMenuItemProps;
                $[76] = t10;
                $[77] = t11;
                $[78] = t12;
                $[79] = t13;
            } else t13 = $[79];
            let t14;
            if ($[80] !== maybeDragPreview || $[81] !== onNavItemClick || $[82] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8z22l.ElementEventListener), {
                    handler: onNavItemClick
                }, t13, maybeDragPreview);
                $[80] = maybeDragPreview;
                $[81] = onNavItemClick;
                $[82] = t13;
                $[83] = t14;
            } else t14 = $[83];
            let t15;
            if ($[84] !== ItemWrapper || $[85] !== t14) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t14);
                $[84] = ItemWrapper;
                $[85] = t14;
                $[86] = t15;
            } else t15 = $[86];
            return t15;
        } else if ((0, $a0cb8887b022d0ae$export$cd440346ca02126b)(item)) {
            let t9;
            if ($[87] !== item) {
                t9 = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, "type");
                $[87] = item;
                $[88] = t9;
            } else t9 = $[88];
            let buttonMenuItemProps;
            let labelElem_0;
            let label_0;
            if ($[89] !== t9) {
                ({ label: label_0, labelElem: labelElem_0, ...buttonMenuItemProps } = t9);
                $[89] = t9;
                $[90] = buttonMenuItemProps;
                $[91] = labelElem_0;
                $[92] = label_0;
            } else {
                buttonMenuItemProps = $[90];
                labelElem_0 = $[91];
                label_0 = $[92];
            }
            let t10;
            if ($[93] !== buttonMenuItemProps || $[94] !== onClick || $[95] !== onNavItemClick) {
                t10 = (...t11)=>{
                    const args_1 = t11;
                    buttonMenuItemProps.onClick?.(...args_1);
                    onNavItemClick();
                    onClick?.();
                };
                $[93] = buttonMenuItemProps;
                $[94] = onClick;
                $[95] = onNavItemClick;
                $[96] = t10;
            } else t10 = $[96];
            let t11;
            if ($[97] !== group || $[98] !== id || $[99] !== isInMoreMenu || $[100] !== isItemDraggable || $[101] !== item) {
                t11 = $fbfe2ad3510eceba$var$getActionsOnHover({
                    id: id,
                    isItemDraggable: isItemDraggable,
                    item: item,
                    isInMoreMenu: isInMoreMenu,
                    group: group
                });
                $[97] = group;
                $[98] = id;
                $[99] = isInMoreMenu;
                $[100] = isItemDraggable;
                $[101] = item;
                $[102] = t11;
            } else t11 = $[102];
            const t12 = labelElem_0 ?? label_0;
            let t13;
            if ($[103] !== buttonMenuItemProps || $[104] !== draggableRef || $[105] !== dropIndicator || $[106] !== dropTargetRef || $[107] !== isDragging || $[108] !== isItemDraggable || $[109] !== t10 || $[110] !== t11 || $[111] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
                    ...buttonMenuItemProps,
                    onClick: t10,
                    hasDragIndicator: isItemDraggable,
                    ref: draggableRef,
                    isDragging: isDragging,
                    dropIndicator: dropIndicator,
                    visualContentRef: dropTargetRef,
                    actionsOnHover: t11
                }, t12);
                $[103] = buttonMenuItemProps;
                $[104] = draggableRef;
                $[105] = dropIndicator;
                $[106] = dropTargetRef;
                $[107] = isDragging;
                $[108] = isItemDraggable;
                $[109] = t10;
                $[110] = t11;
                $[111] = t12;
                $[112] = t13;
            } else t13 = $[112];
            let t14;
            if ($[113] !== ItemWrapper || $[114] !== maybeDragPreview || $[115] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t13, maybeDragPreview);
                $[113] = ItemWrapper;
                $[114] = maybeDragPreview;
                $[115] = t13;
                $[116] = t14;
            } else t14 = $[116];
            return t14;
        } else {
            if ((0, $a0cb8887b022d0ae$export$e5ec7109da4bc094)(item)) {
                let t9;
                if ($[117] !== item) {
                    t9 = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, "type", "isDefaultExpanded", "isExpanded", "onExpansionToggle");
                    $[117] = item;
                    $[118] = t9;
                } else t9 = $[118];
                let elemBefore;
                let labelElem_1;
                let label_1;
                let triggerProps;
                if ($[119] !== t9) {
                    const { children: children, elemBefore: t10, label: t11, labelElem: t12, ...t13 } = t9;
                    elemBefore = t10;
                    label_1 = t11;
                    labelElem_1 = t12;
                    triggerProps = t13;
                    $[119] = t9;
                    $[120] = elemBefore;
                    $[121] = labelElem_1;
                    $[122] = label_1;
                    $[123] = triggerProps;
                } else {
                    elemBefore = $[120];
                    labelElem_1 = $[121];
                    label_1 = $[122];
                    triggerProps = $[123];
                }
                let t10;
                if ($[124] !== item.children || $[125] !== onSubMenuItemClick) {
                    t10 = (0, $fa495778d00d6098$export$b46bb3dcfcaed790)(item.children, onSubMenuItemClick);
                    $[124] = item.children;
                    $[125] = onSubMenuItemClick;
                    $[126] = t10;
                } else t10 = $[126];
                const wrappedChildren = t10;
                let t11;
                if ($[127] !== isExpandOrFlyoutOpen || $[128] !== onClick || $[129] !== onNavItemClick || $[130] !== triggerProps) {
                    t11 = (...t12)=>{
                        const args_2 = t12;
                        triggerProps.onClick?.(...args_2);
                        (0, $ixfCV.fg)("navx-global-side-nav-confluence") ? onNavItemClick(false, isExpandOrFlyoutOpen ? "collapsed" : "expanded") : onNavItemClick();
                        onClick?.();
                    };
                    $[127] = isExpandOrFlyoutOpen;
                    $[128] = onClick;
                    $[129] = onNavItemClick;
                    $[130] = triggerProps;
                    $[131] = t11;
                } else t11 = $[131];
                const t12 = isDragging ? null : elemBefore;
                let t13;
                if ($[132] !== group || $[133] !== id || $[134] !== isInMoreMenu || $[135] !== isItemDraggable || $[136] !== item) {
                    t13 = $fbfe2ad3510eceba$var$getActionsOnHover({
                        id: id,
                        isItemDraggable: isItemDraggable,
                        item: item,
                        isInMoreMenu: isInMoreMenu,
                        group: group
                    });
                    $[132] = group;
                    $[133] = id;
                    $[134] = isInMoreMenu;
                    $[135] = isItemDraggable;
                    $[136] = item;
                    $[137] = t13;
                } else t13 = $[137];
                const t14 = labelElem_1 ?? label_1;
                let t15;
                if ($[138] !== draggableRef || $[139] !== isDragging || $[140] !== isItemDraggable || $[141] !== t11 || $[142] !== t12 || $[143] !== t13 || $[144] !== t14 || $[145] !== triggerProps) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMhPZ.ExpandableMenuItemTrigger), {
                        ...triggerProps,
                        onClick: t11,
                        elemBefore: t12,
                        hasDragIndicator: isItemDraggable,
                        ref: draggableRef,
                        isDragging: isDragging,
                        actionsOnHover: t13
                    }, t14);
                    $[138] = draggableRef;
                    $[139] = isDragging;
                    $[140] = isItemDraggable;
                    $[141] = t11;
                    $[142] = t12;
                    $[143] = t13;
                    $[144] = t14;
                    $[145] = triggerProps;
                    $[146] = t15;
                } else t15 = $[146];
                let t16;
                if ($[147] !== wrappedChildren) {
                    t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jZuGB.ExpandableMenuItemContent), null, wrappedChildren);
                    $[147] = wrappedChildren;
                    $[148] = t16;
                } else t16 = $[148];
                let t17;
                if ($[149] !== dropIndicator || $[150] !== dropTargetRef || $[151] !== isExpandOrFlyoutOpen || $[152] !== onExpandFlyoutToggle || $[153] !== t15 || $[154] !== t16) {
                    t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5um7.ExpandableMenuItem), {
                        dropIndicator: dropIndicator,
                        isExpanded: isExpandOrFlyoutOpen,
                        onExpansionToggle: onExpandFlyoutToggle,
                        ref: dropTargetRef
                    }, t15, t16);
                    $[149] = dropIndicator;
                    $[150] = dropTargetRef;
                    $[151] = isExpandOrFlyoutOpen;
                    $[152] = onExpandFlyoutToggle;
                    $[153] = t15;
                    $[154] = t16;
                    $[155] = t17;
                } else t17 = $[155];
                let t18;
                if ($[156] !== ItemWrapper || $[157] !== maybeDragPreview || $[158] !== t17) {
                    t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t17, maybeDragPreview);
                    $[156] = ItemWrapper;
                    $[157] = maybeDragPreview;
                    $[158] = t17;
                    $[159] = t18;
                } else t18 = $[159];
                return t18;
            } else if ((0, $a0cb8887b022d0ae$export$ee29322ec7068717)(item)) {
                let t9;
                if ($[160] !== item) {
                    t9 = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, "type", "isDefaultOpen", "isOpen", "onOpenChange");
                    $[160] = item;
                    $[161] = t9;
                } else t9 = $[161];
                let labelElem_2;
                let label_2;
                let triggerProps_0;
                if ($[162] !== t9) {
                    const { children: children_0, label: t10, labelElem: t11, ...t12 } = t9;
                    label_2 = t10;
                    labelElem_2 = t11;
                    triggerProps_0 = t12;
                    $[162] = t9;
                    $[163] = labelElem_2;
                    $[164] = label_2;
                    $[165] = triggerProps_0;
                } else {
                    labelElem_2 = $[163];
                    label_2 = $[164];
                    triggerProps_0 = $[165];
                }
                let t10;
                if ($[166] !== item.children || $[167] !== onSubMenuItemClick) {
                    t10 = (0, $fa495778d00d6098$export$b46bb3dcfcaed790)(item.children, onSubMenuItemClick);
                    $[166] = item.children;
                    $[167] = onSubMenuItemClick;
                    $[168] = t10;
                } else t10 = $[168];
                const wrappedChildren_0 = t10;
                let t11;
                if ($[169] !== isExpandOrFlyoutOpen || $[170] !== onClick || $[171] !== onExpandFlyoutToggle || $[172] !== onNavItemClick || $[173] !== triggerProps_0) {
                    t11 = (...t12)=>{
                        const args_3 = t12;
                        triggerProps_0.onClick?.(...args_3);
                        onExpandFlyoutToggle(!isExpandOrFlyoutOpen);
                        (0, $ixfCV.fg)("navx-global-side-nav-confluence") ? onNavItemClick(false, isExpandOrFlyoutOpen ? "collapsed" : "expanded") : onNavItemClick();
                        onClick?.();
                    };
                    $[169] = isExpandOrFlyoutOpen;
                    $[170] = onClick;
                    $[171] = onExpandFlyoutToggle;
                    $[172] = onNavItemClick;
                    $[173] = triggerProps_0;
                    $[174] = t11;
                } else t11 = $[174];
                const t12 = labelElem_2 ?? label_2;
                let t13;
                if ($[175] !== draggableRef || $[176] !== dropIndicator || $[177] !== dropTargetRef || $[178] !== isDragging || $[179] !== isItemDraggable || $[180] !== t11 || $[181] !== t12 || $[182] !== triggerProps_0) {
                    t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9aB3o.FlyoutMenuItemTrigger), {
                        ...triggerProps_0,
                        onClick: t11,
                        hasDragIndicator: isItemDraggable,
                        ref: draggableRef,
                        isDragging: isDragging,
                        dropIndicator: dropIndicator,
                        visualContentRef: dropTargetRef
                    }, t12);
                    $[175] = draggableRef;
                    $[176] = dropIndicator;
                    $[177] = dropTargetRef;
                    $[178] = isDragging;
                    $[179] = isItemDraggable;
                    $[180] = t11;
                    $[181] = t12;
                    $[182] = triggerProps_0;
                    $[183] = t13;
                } else t13 = $[183];
                let t14;
                if ($[184] !== onExpandFlyoutToggle) {
                    t14 = ()=>onExpandFlyoutToggle(false);
                    $[184] = onExpandFlyoutToggle;
                    $[185] = t14;
                } else t14 = $[185];
                let t15;
                if ($[186] !== t14 || $[187] !== wrappedChildren_0) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVdZm.FlyoutMenuItemContent), {
                        onClose: t14
                    }, wrappedChildren_0);
                    $[186] = t14;
                    $[187] = wrappedChildren_0;
                    $[188] = t15;
                } else t15 = $[188];
                let t16;
                if ($[189] !== isExpandOrFlyoutOpen || $[190] !== t13 || $[191] !== t15) {
                    t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91jNq.FlyoutMenuItem), {
                        isOpen: isExpandOrFlyoutOpen
                    }, t13, t15);
                    $[189] = isExpandOrFlyoutOpen;
                    $[190] = t13;
                    $[191] = t15;
                    $[192] = t16;
                } else t16 = $[192];
                let t17;
                if ($[193] !== ItemWrapper || $[194] !== maybeDragPreview || $[195] !== t16) {
                    t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t16, maybeDragPreview);
                    $[193] = ItemWrapper;
                    $[194] = maybeDragPreview;
                    $[195] = t16;
                    $[196] = t17;
                } else t17 = $[196];
                return t17;
            } else {
                if ((0, $a0cb8887b022d0ae$export$10dd63e15344d4ca)(item)) {
                    let t9;
                    if ($[197] !== item) {
                        t9 = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, "type", "isOpen", "onOpenChange");
                        $[197] = item;
                        $[198] = t9;
                    } else t9 = $[198];
                    const objectListFlyoutProps = t9;
                    const isOpenExternallyControlled = typeof item.isOpen === "boolean";
                    const isControlledFlyout = isOpenExternallyControlled ? item.isOpen : isExpandOrFlyoutOpen || isDragging ? isExpandOrFlyoutOpen : undefined;
                    let t10;
                    if ($[199] !== isExpandOrFlyoutOpen || $[200] !== objectListFlyoutProps || $[201] !== onClick || $[202] !== onExpandFlyoutToggle || $[203] !== onNavItemClick) {
                        t10 = (...t11)=>{
                            const args_4 = t11;
                            onExpandFlyoutToggle(!isExpandOrFlyoutOpen);
                            objectListFlyoutProps.onClick?.(...args_4);
                            (0, $ixfCV.fg)("navx-global-side-nav-confluence") ? onNavItemClick(false, isExpandOrFlyoutOpen ? "collapsed" : "expanded") : onNavItemClick();
                            onClick?.();
                        };
                        $[199] = isExpandOrFlyoutOpen;
                        $[200] = objectListFlyoutProps;
                        $[201] = onClick;
                        $[202] = onExpandFlyoutToggle;
                        $[203] = onNavItemClick;
                        $[204] = t10;
                    } else t10 = $[204];
                    let t11;
                    if ($[205] !== objectListFlyoutProps || $[206] !== onSubMenuItemClick) {
                        t11 = (event, extendedSubItemAnalyticsAttributes)=>{
                            objectListFlyoutProps.onSubMenuItemClick?.(event, extendedSubItemAnalyticsAttributes);
                            onSubMenuItemClick(false, extendedSubItemAnalyticsAttributes);
                        };
                        $[205] = objectListFlyoutProps;
                        $[206] = onSubMenuItemClick;
                        $[207] = t11;
                    } else t11 = $[207];
                    let t12;
                    if ($[208] !== draggableRef || $[209] !== dropIndicator || $[210] !== dropTargetRef || $[211] !== id || $[212] !== isControlledFlyout || $[213] !== isDragging || $[214] !== isItemDraggable || $[215] !== objectListFlyoutProps || $[216] !== onExpandFlyoutToggle || $[217] !== t10 || $[218] !== t11) {
                        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ca1dbfc771207d1$export$8c8993cce765101e), {
                            ...objectListFlyoutProps,
                            itemMenuId: id,
                            onClick: t10,
                            onSubMenuItemClick: t11,
                            isFlyoutOpen: isControlledFlyout,
                            onOpenChange: onExpandFlyoutToggle,
                            hasDragIndicator: isItemDraggable,
                            triggerRef: draggableRef,
                            isDragging: isDragging,
                            dropIndicator: dropIndicator,
                            visualContentRef: dropTargetRef
                        });
                        $[208] = draggableRef;
                        $[209] = dropIndicator;
                        $[210] = dropTargetRef;
                        $[211] = id;
                        $[212] = isControlledFlyout;
                        $[213] = isDragging;
                        $[214] = isItemDraggable;
                        $[215] = objectListFlyoutProps;
                        $[216] = onExpandFlyoutToggle;
                        $[217] = t10;
                        $[218] = t11;
                        $[219] = t12;
                    } else t12 = $[219];
                    let t13;
                    if ($[220] !== maybeDragPreview || $[221] !== onSubMenuItemClick || $[222] !== t12) {
                        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8z22l.ElementEventListenerProvider), {
                            handler: onSubMenuItemClick
                        }, t12, maybeDragPreview);
                        $[220] = maybeDragPreview;
                        $[221] = onSubMenuItemClick;
                        $[222] = t12;
                        $[223] = t13;
                    } else t13 = $[223];
                    let t14;
                    if ($[224] !== ItemWrapper || $[225] !== t13) {
                        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t13);
                        $[224] = ItemWrapper;
                        $[225] = t13;
                        $[226] = t14;
                    } else t14 = $[226];
                    return t14;
                } else return null;
            }
        }
    }
}
function $fbfe2ad3510eceba$var$NavItemRaw_unoptimized({ id: id, item: item, peek: peek = false, isInMoreMenu: isInMoreMenu = false, onClick: onClick, onPeek: onPeek, group: group = (0, $gq8Du.L1_MENU_GROUPS).MENU }) {
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { type: type } = item;
    const ItemWrapper = item.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const { isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isExpandable: isExpandable } = (0, $9f15b3cc67dce92b$export$e66526057f4a5c1e)(item, peek);
    const { draggableRef: draggableRef, isItemDraggable: isItemDraggable, isDragging: isDragging, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview } = (0, $igMdc.useL1ItemDragAndDrop)({
        item: item,
        id: id,
        isExpandable: isExpandable,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        peek: peek,
        group: group,
        l1DragAndDropEnabled: l1DragAndDropEnabled
    });
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent, fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent, fireViewedSideNavSubMenuEvent: fireViewedSideNavSubMenuEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    // Common internal onClick handler for all top-level item types
    const onNavItemClick = (0, $cozmU.useCallback)((isRightClick, status)=>{
        (0, $ixfCV.fg)('navx-global-side-nav-confluence') ? fireClickedSideNavItemEvent(id, undefined, isRightClick, status) : fireClickedSideNavItemEvent(id, undefined, isRightClick);
    }, [
        fireClickedSideNavItemEvent,
        id
    ]);
    // Common onSubMenuItemClick handler for all sub-menu item types
    const onSubMenuItemClick = (0, $cozmU.useCallback)((isRightClick_0, extendedAttributes)=>{
        fireClickedSideNavSubMenuItemEvent(id, undefined, isInMoreMenu, isRightClick_0, undefined, extendedAttributes ?? null);
    }, [
        fireClickedSideNavSubMenuItemEvent,
        id,
        isInMoreMenu
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isExpandable && isExpandOrFlyoutOpen) fireViewedSideNavSubMenuEvent(id, undefined, isInMoreMenu);
    }, [
        fireViewedSideNavSubMenuEvent,
        id,
        isExpandOrFlyoutOpen,
        isExpandable,
        isInMoreMenu,
        type
    ]);
    if ((0, $a0cb8887b022d0ae$export$8e525d5a1e55be8f)(item)) {
        const Wrapper = item.isMenuListItem ? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment : (0, $h11I1.MenuListItem);
        // If the item is a custom item, render it directly
        // TODO: Add customizationHandlers prop when ready.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(item.Component, {
            draggableRef: draggableRef,
            dropIndicator: dropIndicator,
            hasDragIndicator: isItemDraggable,
            isDragging: isDragging,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            isInMoreMenu: isInMoreMenu && !peek,
            isPeeked: peek,
            onClick: (...args)=>{
                item.Component.defaultProps?.onClick?.(...args);
                fireClickedSideNavItemEvent(id);
                onClick?.();
            },
            onExpandFlyoutToggle: onExpandFlyoutToggle,
            onPeek: onPeek,
            visualContentRef: dropTargetRef
        }), maybeDragPreview));
    } else if ((0, $a0cb8887b022d0ae$export$4fdefbbdae1adf42)(item)) {
        const { label: label, labelElem: labelElem, ...linkMenuItemProps } = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, 'type');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8z22l.ElementEventListener), {
            handler: onNavItemClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            ...linkMenuItemProps,
            onClick: (...args_0)=>{
                linkMenuItemProps.onClick?.(...args_0);
                onNavItemClick();
                onClick?.();
            },
            hasDragIndicator: isItemDraggable,
            ref: draggableRef,
            isDragging: isDragging,
            dropIndicator: dropIndicator,
            visualContentRef: dropTargetRef,
            actionsOnHover: $fbfe2ad3510eceba$var$getActionsOnHover({
                id: id,
                isItemDraggable: isItemDraggable,
                item: item,
                isInMoreMenu: isInMoreMenu,
                group: group
            })
        }, labelElem ?? label), maybeDragPreview));
    } else if ((0, $a0cb8887b022d0ae$export$cd440346ca02126b)(item)) {
        const { label: label_0, labelElem: labelElem_0, ...buttonMenuItemProps } = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, 'type');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
            ...buttonMenuItemProps,
            onClick: (...args_1)=>{
                buttonMenuItemProps.onClick?.(...args_1);
                onNavItemClick();
                onClick?.();
            },
            hasDragIndicator: isItemDraggable,
            ref: draggableRef,
            isDragging: isDragging,
            dropIndicator: dropIndicator,
            visualContentRef: dropTargetRef,
            actionsOnHover: $fbfe2ad3510eceba$var$getActionsOnHover({
                id: id,
                isItemDraggable: isItemDraggable,
                item: item,
                isInMoreMenu: isInMoreMenu,
                group: group
            })
        }, labelElem_0 ?? label_0), maybeDragPreview);
    } else if ((0, $a0cb8887b022d0ae$export$e5ec7109da4bc094)(item)) {
        // eslint-disable-next-line no-unused-vars
        const { children: children, elemBefore: elemBefore, label: label_1, labelElem: labelElem_1, ...triggerProps } = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, 'type', 'isDefaultExpanded', // Handled above with isExpandOrFlyoutOpen - listed here so it doesn't go in triggerProps
        'isExpanded', // Handled above with isExpandOrFlyoutOpen - listed here so it doesn't go in triggerProps
        'onExpansionToggle' // Handled above with onExpandFlyoutToggle - listed here so it doesn't go in triggerProps
        );
        // Wrap children with our analytics listener to capture their click events
        const wrappedChildren = (0, $fa495778d00d6098$export$b46bb3dcfcaed790)(item.children, onSubMenuItemClick);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5um7.ExpandableMenuItem), {
            dropIndicator: dropIndicator,
            isExpanded: isExpandOrFlyoutOpen,
            onExpansionToggle: onExpandFlyoutToggle,
            ref: dropTargetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMhPZ.ExpandableMenuItemTrigger), {
            ...triggerProps,
            onClick: (...args_2)=>{
                triggerProps.onClick?.(...args_2);
                (0, $ixfCV.fg)('navx-global-side-nav-confluence') ? onNavItemClick(false, isExpandOrFlyoutOpen ? 'collapsed' : 'expanded') : onNavItemClick();
                onClick?.();
            },
            // During drags, custom elemBefore is not shown
            // https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#drag-start
            elemBefore: isDragging ? null : elemBefore,
            hasDragIndicator: isItemDraggable,
            ref: draggableRef,
            isDragging: isDragging,
            actionsOnHover: $fbfe2ad3510eceba$var$getActionsOnHover({
                id: id,
                isItemDraggable: isItemDraggable,
                item: item,
                isInMoreMenu: isInMoreMenu,
                group: group
            })
        }, labelElem_1 ?? label_1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jZuGB.ExpandableMenuItemContent), null, wrappedChildren)), maybeDragPreview);
    } else if ((0, $a0cb8887b022d0ae$export$ee29322ec7068717)(item)) {
        // eslint-disable-next-line no-unused-vars
        const { children: children_0, label: label_2, labelElem: labelElem_2, ...triggerProps_0 } = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, 'type', 'isDefaultOpen', // Handled above with isExpandOrFlyoutOpen - listed here so it doesn't go in triggerProps
        'isOpen', // Handled above with isExpandOrFlyoutOpen - listed here so it doesn't go in triggerProps
        'onOpenChange' // Handled above with onExpandFlyoutToggle - listed here so it doesn't go in triggerProps
        );
        // Wrap children with our analytics listener to capture their click events
        const wrappedChildren_0 = (0, $fa495778d00d6098$export$b46bb3dcfcaed790)(item.children, onSubMenuItemClick);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91jNq.FlyoutMenuItem), {
            isOpen: isExpandOrFlyoutOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9aB3o.FlyoutMenuItemTrigger), {
            ...triggerProps_0,
            onClick: (...args_3)=>{
                triggerProps_0.onClick?.(...args_3);
                // Toggle the flyout open state
                onExpandFlyoutToggle(!isExpandOrFlyoutOpen);
                (0, $ixfCV.fg)('navx-global-side-nav-confluence') ? onNavItemClick(false, isExpandOrFlyoutOpen ? 'collapsed' : 'expanded') : onNavItemClick();
                onClick?.();
            },
            hasDragIndicator: isItemDraggable,
            ref: draggableRef,
            isDragging: isDragging,
            dropIndicator: dropIndicator,
            visualContentRef: dropTargetRef
        }, labelElem_2 ?? label_2), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVdZm.FlyoutMenuItemContent), {
            onClose: ()=>onExpandFlyoutToggle(false)
        }, wrappedChildren_0)), maybeDragPreview);
    } else if ((0, $a0cb8887b022d0ae$export$10dd63e15344d4ca)(item)) {
        const objectListFlyoutProps = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, 'type', 'isOpen', // Handled above with isExpandOrFlyoutOpen - listed here so it doesn't go in objectListFlyoutProps
        'onOpenChange' // Handled above with onExpandFlyoutToggle - listed here so it doesn't go in objectListFlyoutProps
        );
        const isOpenExternallyControlled = typeof item.isOpen === 'boolean';
        // We only want to control the flyout if it is already open, or when we are doing a drag operation.
        // In other cases, we should return undefined to signal that the OLF is not controlled.
        const isControlledFlyout = isOpenExternallyControlled ? item.isOpen : isExpandOrFlyoutOpen || isDragging ? isExpandOrFlyoutOpen : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8z22l.ElementEventListenerProvider), {
            handler: onSubMenuItemClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ca1dbfc771207d1$export$8c8993cce765101e), {
            ...objectListFlyoutProps,
            itemMenuId: id,
            onClick: (...args_4)=>{
                // Toggle the flyout open state
                onExpandFlyoutToggle(!isExpandOrFlyoutOpen);
                objectListFlyoutProps.onClick?.(...args_4);
                (0, $ixfCV.fg)('navx-global-side-nav-confluence') ? onNavItemClick(false, isExpandOrFlyoutOpen ? 'collapsed' : 'expanded') : onNavItemClick();
                onClick?.();
            },
            onSubMenuItemClick: (event, extendedSubItemAnalyticsAttributes)=>{
                objectListFlyoutProps.onSubMenuItemClick?.(event, extendedSubItemAnalyticsAttributes);
                onSubMenuItemClick(false, extendedSubItemAnalyticsAttributes);
            },
            isFlyoutOpen: isControlledFlyout,
            onOpenChange: onExpandFlyoutToggle,
            hasDragIndicator: isItemDraggable,
            triggerRef: draggableRef,
            isDragging: isDragging,
            dropIndicator: dropIndicator,
            visualContentRef: dropTargetRef
        }), maybeDragPreview));
    } else return null;
}
/**
 * Shared, already-computed values that the dispatcher (`NavItemRawStable`) hands
 * to every leaf component. Keeping the hooks in the dispatcher means they run
 * unconditionally (rules-of-hooks safe), while each leaf only adds its own
 * stable `onClick` handler.
 */ function $fbfe2ad3510eceba$var$NavItemRaw(arg0) {
    if ($fbfe2ad3510eceba$var$isReactCompilerActivePlatform_result) return $fbfe2ad3510eceba$var$NavItemRaw_optimized(arg0);
    else return $fbfe2ad3510eceba$var$NavItemRaw_unoptimized(arg0);
}
/**
 * Refactored dispatcher used when `navx-4728-jira-stability-fixes` is ON.
 *
 * All shared hooks run here once, then a thin type-guard switch selects which
 * memoised leaf component to render. The leaves receive the computed values via
 * `SharedLeafProps` and own their referentially-stable `onClick` handlers, so a
 * re-render of `NavItemRawStable` that does not change a leaf's props lets that
 * leaf bail out of re-rendering.
 */ const $fbfe2ad3510eceba$var$_isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $fbfe2ad3510eceba$var$NavItemRawStable_optimized(t0) {
    const $ = (0, $bDgLe.c)(66);
    const { id: id, item: item, peek: t1, isInMoreMenu: t2, onClick: onClick, onPeek: onPeek, group: t3 } = t0;
    const peek = t1 === undefined ? false : t1;
    const isInMoreMenu = t2 === undefined ? false : t2;
    const group = t3 === undefined ? (0, $gq8Du.L1_MENU_GROUPS).MENU : t3;
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { type: type } = item;
    const ItemWrapper = item.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const { isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isExpandable: isExpandable } = (0, $9f15b3cc67dce92b$export$e66526057f4a5c1e)(item, peek);
    let t4;
    if ($[0] !== group || $[1] !== id || $[2] !== isExpandOrFlyoutOpen || $[3] !== isExpandable || $[4] !== item || $[5] !== l1DragAndDropEnabled || $[6] !== onExpandFlyoutToggle || $[7] !== peek) {
        t4 = {
            item: item,
            id: id,
            isExpandable: isExpandable,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            onExpandFlyoutToggle: onExpandFlyoutToggle,
            peek: peek,
            group: group,
            l1DragAndDropEnabled: l1DragAndDropEnabled
        };
        $[0] = group;
        $[1] = id;
        $[2] = isExpandOrFlyoutOpen;
        $[3] = isExpandable;
        $[4] = item;
        $[5] = l1DragAndDropEnabled;
        $[6] = onExpandFlyoutToggle;
        $[7] = peek;
        $[8] = t4;
    } else t4 = $[8];
    const { draggableRef: draggableRef, isItemDraggable: isItemDraggable, isDragging: isDragging, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview } = (0, $igMdc.useL1ItemDragAndDrop)(t4);
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent, fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent, fireViewedSideNavSubMenuEvent: fireViewedSideNavSubMenuEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    let t5;
    if ($[9] !== fireClickedSideNavItemEvent || $[10] !== id) {
        t5 = (isRightClick, status)=>{
            (0, $ixfCV.fg)("navx-global-side-nav-confluence") ? fireClickedSideNavItemEvent(id, undefined, isRightClick, status) : fireClickedSideNavItemEvent(id, undefined, isRightClick);
        };
        $[9] = fireClickedSideNavItemEvent;
        $[10] = id;
        $[11] = t5;
    } else t5 = $[11];
    const onNavItemClick = t5;
    let t6;
    if ($[12] !== fireClickedSideNavSubMenuItemEvent || $[13] !== id || $[14] !== isInMoreMenu) {
        t6 = (isRightClick_0, extendedAttributes)=>{
            fireClickedSideNavSubMenuItemEvent(id, undefined, isInMoreMenu, isRightClick_0, undefined, extendedAttributes ?? null);
        };
        $[12] = fireClickedSideNavSubMenuItemEvent;
        $[13] = id;
        $[14] = isInMoreMenu;
        $[15] = t6;
    } else t6 = $[15];
    const onSubMenuItemClick = t6;
    let t7;
    if ($[16] !== fireViewedSideNavSubMenuEvent || $[17] !== id || $[18] !== isExpandOrFlyoutOpen || $[19] !== isExpandable || $[20] !== isInMoreMenu) {
        t7 = ()=>{
            if (isExpandable && isExpandOrFlyoutOpen) fireViewedSideNavSubMenuEvent(id, undefined, isInMoreMenu);
        };
        $[16] = fireViewedSideNavSubMenuEvent;
        $[17] = id;
        $[18] = isExpandOrFlyoutOpen;
        $[19] = isExpandable;
        $[20] = isInMoreMenu;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== fireViewedSideNavSubMenuEvent || $[23] !== id || $[24] !== isExpandOrFlyoutOpen || $[25] !== isExpandable || $[26] !== isInMoreMenu || $[27] !== type) {
        t8 = [
            fireViewedSideNavSubMenuEvent,
            id,
            isExpandOrFlyoutOpen,
            isExpandable,
            isInMoreMenu,
            type
        ];
        $[22] = fireViewedSideNavSubMenuEvent;
        $[23] = id;
        $[24] = isExpandOrFlyoutOpen;
        $[25] = isExpandable;
        $[26] = isInMoreMenu;
        $[27] = type;
        $[28] = t8;
    } else t8 = $[28];
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[29] !== ItemWrapper || $[30] !== draggableRef || $[31] !== dropIndicator || $[32] !== dropTargetRef || $[33] !== fireClickedSideNavItemEvent || $[34] !== group || $[35] !== id || $[36] !== isDragging || $[37] !== isExpandOrFlyoutOpen || $[38] !== isInMoreMenu || $[39] !== isItemDraggable || $[40] !== maybeDragPreview || $[41] !== onClick || $[42] !== onExpandFlyoutToggle || $[43] !== onNavItemClick || $[44] !== onPeek || $[45] !== onSubMenuItemClick || $[46] !== peek) {
        t9 = {
            id: id,
            onClick: onClick,
            onPeek: onPeek,
            peek: peek,
            isInMoreMenu: isInMoreMenu,
            group: group,
            ItemWrapper: ItemWrapper,
            draggableRef: draggableRef,
            dropTargetRef: dropTargetRef,
            dropIndicator: dropIndicator,
            maybeDragPreview: maybeDragPreview,
            isItemDraggable: isItemDraggable,
            isDragging: isDragging,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            onExpandFlyoutToggle: onExpandFlyoutToggle,
            onNavItemClick: onNavItemClick,
            onSubMenuItemClick: onSubMenuItemClick,
            fireClickedSideNavItemEvent: fireClickedSideNavItemEvent
        };
        $[29] = ItemWrapper;
        $[30] = draggableRef;
        $[31] = dropIndicator;
        $[32] = dropTargetRef;
        $[33] = fireClickedSideNavItemEvent;
        $[34] = group;
        $[35] = id;
        $[36] = isDragging;
        $[37] = isExpandOrFlyoutOpen;
        $[38] = isInMoreMenu;
        $[39] = isItemDraggable;
        $[40] = maybeDragPreview;
        $[41] = onClick;
        $[42] = onExpandFlyoutToggle;
        $[43] = onNavItemClick;
        $[44] = onPeek;
        $[45] = onSubMenuItemClick;
        $[46] = peek;
        $[47] = t9;
    } else t9 = $[47];
    const shared = t9;
    if ((0, $a0cb8887b022d0ae$export$8e525d5a1e55be8f)(item)) {
        let t10;
        if ($[48] !== item || $[49] !== shared) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbfe2ad3510eceba$var$CustomNavItem, {
                item: item,
                ...shared
            });
            $[48] = item;
            $[49] = shared;
            $[50] = t10;
        } else t10 = $[50];
        return t10;
    } else {
        if ((0, $a0cb8887b022d0ae$export$4fdefbbdae1adf42)(item)) {
            let t10;
            if ($[51] !== item || $[52] !== shared) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbfe2ad3510eceba$var$LinkNavItem, {
                    item: item,
                    ...shared
                });
                $[51] = item;
                $[52] = shared;
                $[53] = t10;
            } else t10 = $[53];
            return t10;
        } else if ((0, $a0cb8887b022d0ae$export$cd440346ca02126b)(item)) {
            let t10;
            if ($[54] !== item || $[55] !== shared) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbfe2ad3510eceba$var$ButtonNavItem, {
                    item: item,
                    ...shared
                });
                $[54] = item;
                $[55] = shared;
                $[56] = t10;
            } else t10 = $[56];
            return t10;
        } else {
            if ((0, $a0cb8887b022d0ae$export$e5ec7109da4bc094)(item)) {
                let t10;
                if ($[57] !== item || $[58] !== shared) {
                    t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbfe2ad3510eceba$var$ExpandableNavItem, {
                        item: item,
                        ...shared
                    });
                    $[57] = item;
                    $[58] = shared;
                    $[59] = t10;
                } else t10 = $[59];
                return t10;
            } else if ((0, $a0cb8887b022d0ae$export$ee29322ec7068717)(item)) {
                let t10;
                if ($[60] !== item || $[61] !== shared) {
                    t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbfe2ad3510eceba$var$FlyoutNavItem, {
                        item: item,
                        ...shared
                    });
                    $[60] = item;
                    $[61] = shared;
                    $[62] = t10;
                } else t10 = $[62];
                return t10;
            } else {
                if ((0, $a0cb8887b022d0ae$export$10dd63e15344d4ca)(item)) {
                    let t10;
                    if ($[63] !== item || $[64] !== shared) {
                        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbfe2ad3510eceba$var$ObjectListFlyoutNavItem, {
                            item: item,
                            ...shared
                        });
                        $[63] = item;
                        $[64] = shared;
                        $[65] = t10;
                    } else t10 = $[65];
                    return t10;
                } else return null;
            }
        }
    }
}
function $fbfe2ad3510eceba$var$NavItemRawStable_unoptimized({ id: id, item: item, peek: peek = false, isInMoreMenu: isInMoreMenu = false, onClick: onClick, onPeek: onPeek, group: group = (0, $gq8Du.L1_MENU_GROUPS).MENU }) {
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { type: type } = item;
    const ItemWrapper = item.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const { isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isExpandable: isExpandable } = (0, $9f15b3cc67dce92b$export$e66526057f4a5c1e)(item, peek);
    const { draggableRef: draggableRef, isItemDraggable: isItemDraggable, isDragging: isDragging, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview } = (0, $igMdc.useL1ItemDragAndDrop)({
        item: item,
        id: id,
        isExpandable: isExpandable,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        peek: peek,
        group: group,
        l1DragAndDropEnabled: l1DragAndDropEnabled
    });
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent, fireClickedSideNavSubMenuItemEvent: fireClickedSideNavSubMenuItemEvent, fireViewedSideNavSubMenuEvent: fireViewedSideNavSubMenuEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    // Common internal onClick handler for all top-level item types
    const onNavItemClick = (0, $cozmU.useCallback)((isRightClick, status)=>{
        (0, $ixfCV.fg)('navx-global-side-nav-confluence') ? fireClickedSideNavItemEvent(id, undefined, isRightClick, status) : fireClickedSideNavItemEvent(id, undefined, isRightClick);
    }, [
        fireClickedSideNavItemEvent,
        id
    ]);
    // Common onSubMenuItemClick handler for all sub-menu item types
    const onSubMenuItemClick = (0, $cozmU.useCallback)((isRightClick_0, extendedAttributes)=>{
        fireClickedSideNavSubMenuItemEvent(id, undefined, isInMoreMenu, isRightClick_0, undefined, extendedAttributes ?? null);
    }, [
        fireClickedSideNavSubMenuItemEvent,
        id,
        isInMoreMenu
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isExpandable && isExpandOrFlyoutOpen) fireViewedSideNavSubMenuEvent(id, undefined, isInMoreMenu);
    }, [
        fireViewedSideNavSubMenuEvent,
        id,
        isExpandOrFlyoutOpen,
        isExpandable,
        isInMoreMenu,
        type
    ]);
    const shared = {
        id: id,
        onClick: onClick,
        onPeek: onPeek,
        peek: peek,
        isInMoreMenu: isInMoreMenu,
        group: group,
        ItemWrapper: ItemWrapper,
        draggableRef: draggableRef,
        dropTargetRef: dropTargetRef,
        dropIndicator: dropIndicator,
        maybeDragPreview: maybeDragPreview,
        isItemDraggable: isItemDraggable,
        isDragging: isDragging,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        onNavItemClick: onNavItemClick,
        onSubMenuItemClick: onSubMenuItemClick,
        fireClickedSideNavItemEvent: fireClickedSideNavItemEvent
    };
    if ((0, $a0cb8887b022d0ae$export$8e525d5a1e55be8f)(item)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbfe2ad3510eceba$var$CustomNavItem, {
        item: item,
        ...shared
    });
    else if ((0, $a0cb8887b022d0ae$export$4fdefbbdae1adf42)(item)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbfe2ad3510eceba$var$LinkNavItem, {
        item: item,
        ...shared
    });
    else if ((0, $a0cb8887b022d0ae$export$cd440346ca02126b)(item)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbfe2ad3510eceba$var$ButtonNavItem, {
        item: item,
        ...shared
    });
    else if ((0, $a0cb8887b022d0ae$export$e5ec7109da4bc094)(item)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbfe2ad3510eceba$var$ExpandableNavItem, {
        item: item,
        ...shared
    });
    else if ((0, $a0cb8887b022d0ae$export$ee29322ec7068717)(item)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbfe2ad3510eceba$var$FlyoutNavItem, {
        item: item,
        ...shared
    });
    else if ((0, $a0cb8887b022d0ae$export$10dd63e15344d4ca)(item)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbfe2ad3510eceba$var$ObjectListFlyoutNavItem, {
        item: item,
        ...shared
    });
    else return null;
}
function $fbfe2ad3510eceba$var$NavItemRawStable(arg0) {
    if ($fbfe2ad3510eceba$var$_isReactCompilerActivePlatform_result) return $fbfe2ad3510eceba$var$NavItemRawStable_optimized(arg0);
    else return $fbfe2ad3510eceba$var$NavItemRawStable_unoptimized(arg0);
}
const $fbfe2ad3510eceba$var$CustomNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function CustomNavItem({ item: item, onClick: onClick, onPeek: onPeek, peek: peek, isInMoreMenu: isInMoreMenu, ItemWrapper: ItemWrapper, draggableRef: draggableRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview, isItemDraggable: isItemDraggable, isDragging: isDragging, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, fireClickedSideNavItemEvent: fireClickedSideNavItemEvent, id: id }) {
    const Wrapper = item.isMenuListItem ? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment : (0, $h11I1.MenuListItem);
    // Stable click handler. `customItemOnClickRef` carries the latest per-item
    // default onClick so the callback identity stays stable across renders.
    const customItemOnClickRef = (0, $cozmU.useRef)(item.Component.defaultProps?.onClick);
    customItemOnClickRef.current = item.Component.defaultProps?.onClick;
    const onCustomItemClick = (0, $cozmU.useCallback)((...args)=>{
        customItemOnClickRef.current?.(...args);
        fireClickedSideNavItemEvent(id);
        onClick?.();
    }, [
        fireClickedSideNavItemEvent,
        id,
        onClick
    ]);
    // TODO: Add customizationHandlers prop when ready.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(item.Component, {
        draggableRef: draggableRef,
        dropIndicator: dropIndicator,
        hasDragIndicator: isItemDraggable,
        isDragging: isDragging,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        isInMoreMenu: isInMoreMenu && !peek,
        isPeeked: peek,
        onClick: onCustomItemClick,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        onPeek: onPeek,
        visualContentRef: dropTargetRef
    }), maybeDragPreview));
});
const $fbfe2ad3510eceba$var$LinkNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function LinkNavItem({ item: item, onClick: onClick, isInMoreMenu: isInMoreMenu, group: group, ItemWrapper: ItemWrapper, draggableRef: draggableRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview, isItemDraggable: isItemDraggable, isDragging: isDragging, onNavItemClick: onNavItemClick, id: id }) {
    const { label: label, labelElem: labelElem, ...linkMenuItemProps } = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, 'type');
    // Stable click handler. `itemOnClickRef` carries the latest per-item onClick.
    const itemOnClickRef = (0, $cozmU.useRef)(linkMenuItemProps.onClick);
    itemOnClickRef.current = linkMenuItemProps.onClick;
    const onLinkItemClick = (0, $cozmU.useCallback)((...args)=>{
        itemOnClickRef.current?.(...args);
        onNavItemClick();
        onClick?.();
    }, [
        onNavItemClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8z22l.ElementEventListener), {
        handler: onNavItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
        ...linkMenuItemProps,
        onClick: onLinkItemClick,
        hasDragIndicator: isItemDraggable,
        ref: draggableRef,
        isDragging: isDragging,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef,
        actionsOnHover: $fbfe2ad3510eceba$var$getActionsOnHover({
            id: id,
            isItemDraggable: isItemDraggable,
            item: item,
            isInMoreMenu: isInMoreMenu,
            group: group
        })
    }, labelElem ?? label), maybeDragPreview));
});
const $fbfe2ad3510eceba$var$ButtonNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function ButtonNavItem({ item: item, onClick: onClick, isInMoreMenu: isInMoreMenu, group: group, ItemWrapper: ItemWrapper, draggableRef: draggableRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview, isItemDraggable: isItemDraggable, isDragging: isDragging, onNavItemClick: onNavItemClick, id: id }) {
    const { label: label, labelElem: labelElem, ...buttonMenuItemProps } = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, 'type');
    // Stable click handler. `itemOnClickRef` carries the latest per-item onClick.
    const itemOnClickRef = (0, $cozmU.useRef)(buttonMenuItemProps.onClick);
    itemOnClickRef.current = buttonMenuItemProps.onClick;
    const onButtonItemClick = (0, $cozmU.useCallback)((...args)=>{
        itemOnClickRef.current?.(...args);
        onNavItemClick();
        onClick?.();
    }, [
        onNavItemClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
        ...buttonMenuItemProps,
        onClick: onButtonItemClick,
        hasDragIndicator: isItemDraggable,
        ref: draggableRef,
        isDragging: isDragging,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef,
        actionsOnHover: $fbfe2ad3510eceba$var$getActionsOnHover({
            id: id,
            isItemDraggable: isItemDraggable,
            item: item,
            isInMoreMenu: isInMoreMenu,
            group: group
        })
    }, labelElem ?? label), maybeDragPreview);
});
const $fbfe2ad3510eceba$var$ExpandableNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function ExpandableNavItem({ item: item, onClick: onClick, isInMoreMenu: isInMoreMenu, group: group, ItemWrapper: ItemWrapper, draggableRef: draggableRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview, isItemDraggable: isItemDraggable, isDragging: isDragging, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, onNavItemClick: onNavItemClick, onSubMenuItemClick: onSubMenuItemClick, id: id }) {
    // eslint-disable-next-line no-unused-vars
    const { children: children, elemBefore: elemBefore, label: label, labelElem: labelElem, ...triggerProps } = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, 'type', 'isDefaultExpanded', // Handled above with isExpandOrFlyoutOpen - listed here so it doesn't go in triggerProps
    'isExpanded', // Handled above with isExpandOrFlyoutOpen - listed here so it doesn't go in triggerProps
    'onExpansionToggle' // Handled above with onExpandFlyoutToggle - listed here so it doesn't go in triggerProps
    );
    // Wrap children with our analytics listener to capture their click events
    const wrappedChildren = (0, $fa495778d00d6098$export$b46bb3dcfcaed790)(item.children, onSubMenuItemClick);
    // Latest-ref for the open state so the stable handler reads the current value
    // without being recreated whenever it toggles.
    const isExpandOrFlyoutOpenRef = (0, $cozmU.useRef)(isExpandOrFlyoutOpen);
    isExpandOrFlyoutOpenRef.current = isExpandOrFlyoutOpen;
    // Stable click handler for the expandable trigger.
    const triggerOnClickRef = (0, $cozmU.useRef)(triggerProps.onClick);
    triggerOnClickRef.current = triggerProps.onClick;
    const onTriggerClick = (0, $cozmU.useCallback)((...args)=>{
        triggerOnClickRef.current?.(...args);
        (0, $ixfCV.fg)('navx-global-side-nav-confluence') ? onNavItemClick(false, isExpandOrFlyoutOpenRef.current ? 'collapsed' : 'expanded') : onNavItemClick();
        onClick?.();
    }, [
        onNavItemClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5um7.ExpandableMenuItem), {
        dropIndicator: dropIndicator,
        isExpanded: isExpandOrFlyoutOpen,
        onExpansionToggle: onExpandFlyoutToggle,
        ref: dropTargetRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMhPZ.ExpandableMenuItemTrigger), {
        ...triggerProps,
        onClick: onTriggerClick,
        // During drags, custom elemBefore is not shown
        // https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#drag-start
        elemBefore: isDragging ? null : elemBefore,
        hasDragIndicator: isItemDraggable,
        ref: draggableRef,
        isDragging: isDragging,
        actionsOnHover: $fbfe2ad3510eceba$var$getActionsOnHover({
            id: id,
            isItemDraggable: isItemDraggable,
            item: item,
            isInMoreMenu: isInMoreMenu,
            group: group
        })
    }, labelElem ?? label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jZuGB.ExpandableMenuItemContent), null, wrappedChildren)), maybeDragPreview);
});
const $fbfe2ad3510eceba$var$FlyoutNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function FlyoutNavItem({ item: item, onClick: onClick, ItemWrapper: ItemWrapper, draggableRef: draggableRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview, isItemDraggable: isItemDraggable, isDragging: isDragging, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, onNavItemClick: onNavItemClick, onSubMenuItemClick: onSubMenuItemClick }) {
    // eslint-disable-next-line no-unused-vars
    const { children: children, label: label, labelElem: labelElem, ...triggerProps } = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, 'type', 'isDefaultOpen', // Handled above with isExpandOrFlyoutOpen - listed here so it doesn't go in triggerProps
    'isOpen', // Handled above with isExpandOrFlyoutOpen - listed here so it doesn't go in triggerProps
    'onOpenChange' // Handled above with onExpandFlyoutToggle - listed here so it doesn't go in triggerProps
    );
    // Wrap children with our analytics listener to capture their click events
    const wrappedChildren = (0, $fa495778d00d6098$export$b46bb3dcfcaed790)(item.children, onSubMenuItemClick);
    const isExpandOrFlyoutOpenRef = (0, $cozmU.useRef)(isExpandOrFlyoutOpen);
    isExpandOrFlyoutOpenRef.current = isExpandOrFlyoutOpen;
    // Stable click handler for the flyout trigger.
    const triggerOnClickRef = (0, $cozmU.useRef)(triggerProps.onClick);
    triggerOnClickRef.current = triggerProps.onClick;
    const onTriggerClick = (0, $cozmU.useCallback)((...args)=>{
        triggerOnClickRef.current?.(...args);
        // Toggle the flyout open state
        onExpandFlyoutToggle(!isExpandOrFlyoutOpenRef.current);
        (0, $ixfCV.fg)('navx-global-side-nav-confluence') ? onNavItemClick(false, isExpandOrFlyoutOpenRef.current ? 'collapsed' : 'expanded') : onNavItemClick();
        onClick?.();
    }, [
        onExpandFlyoutToggle,
        onNavItemClick,
        onClick
    ]);
    const onContentClose = (0, $cozmU.useCallback)(()=>onExpandFlyoutToggle(false), [
        onExpandFlyoutToggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91jNq.FlyoutMenuItem), {
        isOpen: isExpandOrFlyoutOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9aB3o.FlyoutMenuItemTrigger), {
        ...triggerProps,
        onClick: onTriggerClick,
        hasDragIndicator: isItemDraggable,
        ref: draggableRef,
        isDragging: isDragging,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef
    }, labelElem ?? label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVdZm.FlyoutMenuItemContent), {
        onClose: onContentClose
    }, wrappedChildren)), maybeDragPreview);
});
const $fbfe2ad3510eceba$var$ObjectListFlyoutNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function ObjectListFlyoutNavItem({ item: item, onClick: onClick, ItemWrapper: ItemWrapper, draggableRef: draggableRef, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator, maybeDragPreview: maybeDragPreview, isItemDraggable: isItemDraggable, isDragging: isDragging, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, onNavItemClick: onNavItemClick, onSubMenuItemClick: onSubMenuItemClick, id: id }) {
    const objectListFlyoutProps = (0, $beafcbdcfa7a52a6$export$d6eadbd047ebd460)(item, 'type', 'isOpen', // Handled above with isExpandOrFlyoutOpen - listed here so it doesn't go in objectListFlyoutProps
    'onOpenChange' // Handled above with onExpandFlyoutToggle - listed here so it doesn't go in objectListFlyoutProps
    );
    const isOpenExternallyControlled = typeof item.isOpen === 'boolean';
    // We only want to control the flyout if it is already open, or when we are doing a drag operation.
    // In other cases, we should return undefined to signal that the OLF is not controlled.
    const isControlledFlyout = isOpenExternallyControlled ? item.isOpen : isExpandOrFlyoutOpen || isDragging ? isExpandOrFlyoutOpen : undefined;
    const isExpandOrFlyoutOpenRef = (0, $cozmU.useRef)(isExpandOrFlyoutOpen);
    isExpandOrFlyoutOpenRef.current = isExpandOrFlyoutOpen;
    // Stable click handler for the object-list flyout trigger. Toggles the flyout
    // first (matching the original order), then per-item onClick + analytics.
    const flyoutOnClickRef = (0, $cozmU.useRef)(objectListFlyoutProps.onClick);
    flyoutOnClickRef.current = objectListFlyoutProps.onClick;
    const onObjectListFlyoutClick = (0, $cozmU.useCallback)((...args)=>{
        onExpandFlyoutToggle(!isExpandOrFlyoutOpenRef.current);
        flyoutOnClickRef.current?.(...args);
        (0, $ixfCV.fg)('navx-global-side-nav-confluence') ? onNavItemClick(false, isExpandOrFlyoutOpenRef.current ? 'collapsed' : 'expanded') : onNavItemClick();
        onClick?.();
    }, [
        onExpandFlyoutToggle,
        onNavItemClick,
        onClick
    ]);
    const subMenuItemOnClickRef = (0, $cozmU.useRef)(objectListFlyoutProps.onSubMenuItemClick);
    subMenuItemOnClickRef.current = objectListFlyoutProps.onSubMenuItemClick;
    const onObjectListSubMenuItemClick = (0, $cozmU.useCallback)((event, extendedSubItemAnalyticsAttributes)=>{
        subMenuItemOnClickRef.current?.(event, extendedSubItemAnalyticsAttributes);
        onSubMenuItemClick(false, extendedSubItemAnalyticsAttributes);
    }, [
        onSubMenuItemClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8z22l.ElementEventListenerProvider), {
        handler: onSubMenuItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ca1dbfc771207d1$export$8c8993cce765101e), {
        ...objectListFlyoutProps,
        itemMenuId: id,
        onClick: onObjectListFlyoutClick,
        onSubMenuItemClick: onObjectListSubMenuItemClick,
        isFlyoutOpen: isControlledFlyout,
        onOpenChange: onExpandFlyoutToggle,
        hasDragIndicator: isItemDraggable,
        triggerRef: draggableRef,
        isDragging: isDragging,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef
    }), maybeDragPreview));
});
// This cannot be a React function-component, otherwise the Link/Button/Expand.actionsOnHover prop will can never be undefined.
// When there are no actionsOnHover and the item is not draggable, actionsOnHover MUST return undefined, to avoid the
// elemAfter from being hidden unintentionally.
function $fbfe2ad3510eceba$var$getActionsOnHover({ item: item }) {
    return item.actionsOnHover ?? null;
}














var $4dGdo = parcelRequire("4dGdo");

function $18d95b841ca8b556$export$f5b5f29328df2633(element) {
    element.animate([
        {
            backgroundColor: "var(--ds-background-selected, #E9F2FE)"
        },
        {}
    ], {
        duration: (0, $4dGdo.durations).large,
        /**
     * This is equivalent to the browser default, but we are making it
     * explicit to avoid relying on implicit behavior.
     *
     * This curve is not part of `@atlaskit/motion` but it was an intentional
     * design decision to use this curve.
     */ easing: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
        iterations: 1
    });
}




var $3obFl = parcelRequire("3obFl");






const $c1e6c4a8833c9806$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    a11yAnnouncementItemHidden: {
        id: "navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-hidden",
        defaultMessage: "The top level menu item {label} has been hidden and moved to the More menu."
    },
    a11yAnnouncementItemUnhidden: {
        id: "navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-unhidden",
        defaultMessage: "The top level menu item {label} has been unhidden and moved from the more menu to position {finishIndex}."
    },
    a11yAnnouncementItemReordered: {
        id: "navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-reordered",
        defaultMessage: "The top level menu item {label} has been moved from position {startIndex} to {finishIndex}."
    },
    a11yAnnouncementItemVisible: {
        id: "navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-visible",
        defaultMessage: "The top level menu item {label} has been moved from the More menu to the visible items."
    }
});


function $706c0a2842c08c35$export$440b6dd66925f04d(userMenuDataShapes, elementRegistry) {
    /*
  Get current order of items and shortcuts
  Apply reorder or hide operation
  Save the updated data using onSave
  */ const intl = (0, $kSwu1.useIntl)();
    const { fireEvent: fireEvent } = (0, $19ead867f45fce96$export$5bf35293e545f20c)();
    const { fireDraggedSideNavItemEvent: fireDraggedSideNavItemEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    // Clean up live region when unmounted
    (0, $cozmU.useEffect)(()=>{
        return ()=>$2b230915474122a8$export$de863c629cb9919d();
    }, []);
    /**
   * Run flash/focus/announce/analytics directly after
   * state updates settle, without the intermediate state → effect chain.
   * We use Promise.resolve().then() to schedule after React has flushed the state update.
   */ const runPostActionEffects = (0, $cozmU.useCallback)((action)=>{
        Promise.resolve().then(()=>{
            if ($706c0a2842c08c35$var$isItemReorderAction(action)) {
                const label = action.draggedMenuItemLabel || action.draggedMenuItemId;
                const element = elementRegistry.getL1ItemElement(action.draggedMenuItemId);
                if (element) {
                    (0, $18d95b841ca8b556$export$f5b5f29328df2633)(element);
                    if (action.trigger === 'keyboard') setTimeout(()=>element.focus());
                    $2b230915474122a8$export$a9b970dcc4ae71a9(intl.formatMessage((0, $c1e6c4a8833c9806$export$defe85febe8b728c).a11yAnnouncementItemReordered, {
                        label: label,
                        startIndex: action.startIndex + 1,
                        finishIndex: action.finishIndex + 1
                    }));
                    fireDraggedSideNavItemEvent(action.draggedMenuItemId, false);
                }
                return;
            }
            if ($706c0a2842c08c35$var$isItemHideAction(action)) {
                const label = action.draggedMenuItemLabel || action.draggedMenuItemId;
                const moreMenuElement = elementRegistry.getMoreMenuElement();
                if (moreMenuElement) {
                    (0, $18d95b841ca8b556$export$f5b5f29328df2633)(moreMenuElement);
                    if (action.trigger === 'keyboard') setTimeout(()=>moreMenuElement.focus());
                    $2b230915474122a8$export$a9b970dcc4ae71a9(intl.formatMessage((0, $c1e6c4a8833c9806$export$defe85febe8b728c).a11yAnnouncementItemHidden, {
                        label: label
                    }));
                    fireDraggedSideNavItemEvent(action.draggedMenuItemId, true);
                }
                return;
            }
            if ($706c0a2842c08c35$var$isItemUnhideAction(action)) {
                const label = action.draggedMenuItemLabel || action.draggedMenuItemId;
                const element = elementRegistry.getL1ItemElement(action.draggedMenuItemId);
                if (element) {
                    (0, $18d95b841ca8b556$export$f5b5f29328df2633)(element);
                    if (action.trigger === 'keyboard') setTimeout(()=>element.focus());
                    $2b230915474122a8$export$a9b970dcc4ae71a9(intl.formatMessage((0, $c1e6c4a8833c9806$export$defe85febe8b728c).a11yAnnouncementItemUnhidden, {
                        label: label,
                        finishIndex: action.finishIndex + 1
                    }));
                    fireDraggedSideNavItemEvent(action.draggedMenuItemId, false);
                }
                return;
            }
            if ($706c0a2842c08c35$var$isItemVisibleAction(action)) {
                const label = action.draggedMenuItemLabel || action.draggedMenuItemId;
                const moreMenuElement = elementRegistry.getMoreMenuElement();
                if (moreMenuElement) {
                    $2b230915474122a8$export$a9b970dcc4ae71a9(intl.formatMessage((0, $c1e6c4a8833c9806$export$defe85febe8b728c).a11yAnnouncementItemVisible, {
                        label: label
                    }));
                    fireDraggedSideNavItemEvent(action.draggedMenuItemId, false);
                }
            }
        });
    }, // Intentional omission of `fireDraggedSideNavItemEvent` from dependencies to avoid firing twice
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        elementRegistry,
        intl
    ]);
    const dragAndDropSave = (0, $cozmU.useCallback)(async (action)=>{
        // item reordered into visible menu
        if ($706c0a2842c08c35$var$isItemReorderAction(action)) {
            (0, $bB0i2.default)(action.droppedOnMenuItemId, 'item-reorder action must have droppedOnMenuItemId');
            const startIndex = userMenuDataShapes.userMenuData.findIndex((datum)=>datum.menuId === action.draggedMenuItemId);
            const itemsAndShortcutsIdsWithoutDraggedItem = userMenuDataShapes.userMenuData.map((datum)=>datum.menuId).filter((id)=>id !== action.draggedMenuItemId);
            const dropTargetIndex = itemsAndShortcutsIdsWithoutDraggedItem.indexOf(action.droppedOnMenuItemId);
            if (startIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `startIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            if (dropTargetIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `dropTargetIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            const finishIndex = action.instruction.operation === 'reorder-after' ? dropTargetIndex + 1 : dropTargetIndex;
            const visibleStartIndex = userMenuDataShapes.visibleMenuIds.indexOf(action.draggedMenuItemId);
            const visibleDropTargetIndex = userMenuDataShapes.visibleMenuIds.filter((id)=>id !== action.draggedMenuItemId).indexOf(action.droppedOnMenuItemId);
            if (visibleStartIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `visibleStartIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            if (visibleDropTargetIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `visibleDropTargetIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            const visibleFinishIndex = action.instruction.operation === 'reorder-after' ? visibleDropTargetIndex + 1 : visibleDropTargetIndex;
            const reordered = (0, $3obFl.reorder)({
                list: userMenuDataShapes.userMenuData,
                startIndex: startIndex,
                finishIndex: finishIndex
            });
            userMenuDataShapes.setUserMenuData(reordered);
            const extendedAction = {
                ...action,
                startIndex: visibleStartIndex,
                finishIndex: visibleFinishIndex
            };
            runPostActionEffects(extendedAction);
            return;
        }
        // item is dragged into hide button
        if ($706c0a2842c08c35$var$isItemHideAction(action)) {
            const dataWithHiddenItem = userMenuDataShapes.userMenuData.map((datum)=>{
                if (datum.menuId === action.draggedMenuItemId) return {
                    ...datum,
                    visible: false
                };
                return datum;
            });
            userMenuDataShapes.setUserMenuData(dataWithHiddenItem);
            runPostActionEffects(action);
            return;
        }
        // hidden item dragged into visible button
        if ($706c0a2842c08c35$var$isItemVisibleAction(action)) {
            const dataWithVisibleItem = userMenuDataShapes.userMenuData.map((datum)=>{
                if (datum.menuId === action.draggedMenuItemId) return {
                    ...datum,
                    visible: true
                };
                return datum;
            });
            userMenuDataShapes.setUserMenuData(dataWithVisibleItem);
            runPostActionEffects(action);
            return;
        }
        // hidden item dragged into visible menu
        if ($706c0a2842c08c35$var$isItemUnhideAction(action)) {
            (0, $bB0i2.default)(action.droppedOnMenuItemId, 'item-unhide action must have droppedOnMenuItemId');
            const userMenuDataWithUnhiddenItem = userMenuDataShapes.userMenuData.map((data)=>{
                if (data.menuId === action.draggedMenuItemId) return {
                    ...data,
                    visible: true
                };
                return data;
            });
            const startIndex = userMenuDataWithUnhiddenItem.findIndex((datum)=>datum.menuId === action.draggedMenuItemId);
            const itemsAndShortcutsIdsWithoutDraggedItem = userMenuDataWithUnhiddenItem.map((datum)=>datum.menuId).filter((id)=>id !== action.draggedMenuItemId);
            const dropTargetIndex = itemsAndShortcutsIdsWithoutDraggedItem.indexOf(action.droppedOnMenuItemId);
            if (startIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `startIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            if (dropTargetIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `dropTargetIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            const finishIndex = action.instruction.operation === 'reorder-after' ? dropTargetIndex + 1 : dropTargetIndex;
            const visibleDropTargetIndex = userMenuDataShapes.visibleMenuIds.filter((id)=>id !== action.draggedMenuItemId).indexOf(action.droppedOnMenuItemId);
            if (visibleDropTargetIndex === -1) {
                fireEvent('operational.sideNav.actionFailed', {
                    operation: 'dragAndDropSave',
                    reason: `visibleDropTargetIndex not found for ${action.draggedMenuItemId}`
                });
                return;
            }
            const visibleFinishIndex = action.instruction.operation === 'reorder-after' ? visibleDropTargetIndex + 1 : visibleDropTargetIndex;
            const reordered = (0, $3obFl.reorder)({
                list: userMenuDataWithUnhiddenItem,
                startIndex: startIndex,
                finishIndex: finishIndex
            });
            userMenuDataShapes.setUserMenuData(reordered);
            const extendedAction = {
                ...action,
                finishIndex: visibleFinishIndex
            };
            runPostActionEffects(extendedAction);
            return;
        }
    }, [
        fireEvent,
        runPostActionEffects,
        userMenuDataShapes
    ]);
    return {
        dragAndDropSave: dragAndDropSave
    };
}
function $706c0a2842c08c35$var$isItemReorderAction(action) {
    return action.type === 'item-reorder';
}
function $706c0a2842c08c35$var$isItemHideAction(action) {
    return action.type === 'item-hide';
}
function $706c0a2842c08c35$var$isItemUnhideAction(action) {
    return action.type === 'item-unhide';
}
function $706c0a2842c08c35$var$isItemVisibleAction(action) {
    return action.type === 'item-visible';
}









var $htuV6 = parcelRequire("htuV6");







function $0ebfb3ac63800ecb$export$9e5b5542ce283d4c({ l1DragAndDropEnabled: l1DragAndDropEnabled, dragAndDropSave: dragAndDropSave, setDraggingL1Group: setDraggingL1Group, hiddenMenuIds: hiddenMenuIds }) {
    // Keep a ref up to date with the latest hiddenMenuIds on every render.
    // This allows the onDrop closure to always read the current value without
    // needing hiddenMenuIds in the monitor's dependency array.
    const hiddenMenuIdsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(hiddenMenuIds);
    (0, $cozmU.useEffect)(()=>{
        hiddenMenuIdsRef.current = hiddenMenuIds;
    });
    (0, $cozmU.useEffect)(()=>{
        if (!l1DragAndDropEnabled) return;
        return (0, $iSrRp.monitorForElements)({
            canMonitor: ({ source: source })=>(0, $6ZNK7.isL1ItemData)(source.data) && (0, $6ZNK7.isL1ItemDataInGroup)(source.data, [
                    (0, $gq8Du.L1_MENU_GROUPS).MENU,
                    (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
                ]),
            onDragStart ({ source: source }) {
                if (!(0, $6ZNK7.isL1ItemData)(source.data)) return;
                setDraggingL1Group(source.data.group);
            },
            onDrop ({ source: source, location: location }) {
                const dragging = source.data;
                setDraggingL1Group(null);
                const [innerMost] = location.current.dropTargets;
                if (!innerMost) return;
                const dropTargetData = innerMost.data;
                const instruction = (0, $htuV6.extractInstruction)(dropTargetData);
                if (!instruction) return;
                // Read from ref — always holds the latest hiddenMenuIds without causing
                // the monitor to re-register when the list changes.
                const hiddenMenuIds = hiddenMenuIdsRef.current;
                // Dragging out from More Menu
                if ((0, $6ZNK7.isL1ItemData)(dragging) && (0, $6ZNK7.isL1ItemData)(dropTargetData) && hiddenMenuIds.includes(dragging.menuItemId)) {
                    dragAndDropSave({
                        type: 'item-unhide',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        droppedOnMenuItemId: dropTargetData.menuItemId,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
                // Drag and Drop Order within Shortcuts group
                if ((0, $6ZNK7.isL1ItemData)(dragging) && (0, $6ZNK7.isL1ItemData)(dropTargetData) && (0, $6ZNK7.isL1ItemDataInGroup)(dragging, (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS) && (0, $6ZNK7.isL1ItemDataInGroup)(dropTargetData, (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS)) {
                    dragAndDropSave({
                        type: 'item-reorder',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        droppedOnMenuItemId: dropTargetData.menuItemId,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
                // Drag and Drop Order within Menu group
                if ((0, $6ZNK7.isL1ItemData)(dragging) && (0, $6ZNK7.isL1ItemData)(dropTargetData) && (0, $6ZNK7.isL1ItemDataInGroup)(dragging, (0, $gq8Du.L1_MENU_GROUPS).MENU) && (0, $6ZNK7.isL1ItemDataInGroup)(dropTargetData, (0, $gq8Du.L1_MENU_GROUPS).MENU)) {
                    dragAndDropSave({
                        type: 'item-reorder',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        droppedOnMenuItemId: dropTargetData.menuItemId,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
                // Drag into More Menu (hide or show)
                if ((0, $6ZNK7.isL1ItemData)(dragging) && (0, $6ZNK7.isL1ItemDataInGroup)(dragging, [
                    (0, $gq8Du.L1_MENU_GROUPS).MENU,
                    (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
                ]) && (0, $6ZNK7.isMoreMenuData)(dropTargetData)) {
                    dragAndDropSave({
                        type: hiddenMenuIds.includes(dragging.menuItemId) ? 'item-visible' : 'item-hide',
                        draggedMenuItemId: dragging.menuItemId,
                        draggedMenuItemLabel: dragging.label,
                        instruction: instruction,
                        trigger: 'pointer'
                    });
                    return;
                }
            }
        });
    // Stable dep array: hiddenMenuIds is intentionally excluded — it is kept current via the
    // ref above. Only re-register the monitor when the save function or enabled flag changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dragAndDropSave,
        l1DragAndDropEnabled,
        setDraggingL1Group
    ]);
}

















var $38vK5 = parcelRequire("38vK5");











const $3e97dfd5d57e4a85$export$6215040b989f9b0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInViewport(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { ref: ref, rootMargin: t1, onInViewport: onInViewport } = t0;
    const rootMargin = t1 === undefined ? "0px 0px 200px 0px" : t1;
    const isInViewportRef = (0, $cozmU.useRef)(false);
    let t2;
    let t3;
    if ($[0] !== onInViewport || $[1] !== ref || $[2] !== rootMargin) {
        t2 = ()=>{
            if (!ref.current) {
                isInViewportRef.current = false;
                return;
            }
            const observer = new IntersectionObserver((t4)=>{
                const [entry] = t4;
                isInViewportRef.current = entry.isIntersecting;
                if (entry.isIntersecting && onInViewport) onInViewport();
            }, {
                rootMargin: rootMargin
            });
            observer.observe(ref.current);
            return ()=>observer.disconnect();
        };
        t3 = [
            rootMargin,
            ref,
            onInViewport
        ];
        $[0] = onInViewport;
        $[1] = ref;
        $[2] = rootMargin;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useInViewport({ ref: ref, rootMargin: rootMargin = '0px 0px 200px 0px', onInViewport: onInViewport }) {
    // Use a ref instead of state to track viewport visibility.
    // This avoids hydration mismatches caused by IntersectionObserver firing immediately
    // after mount and calling a useState setter, which triggers a re-render.
    // The ref is exposed via a getter for consumers that only need the current value.
    const isInViewportRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!ref.current) {
            isInViewportRef.current = false;
            return;
        }
        const observer = new IntersectionObserver(([entry])=>{
            isInViewportRef.current = entry.isIntersecting;
            // Call the callback directly in the observer to avoid a chain-of-computation
            // anti-pattern (effect → state/ref → effect).
            if (entry.isIntersecting && onInViewport) onInViewport();
        }, {
            rootMargin: rootMargin
        });
        observer.observe(ref.current);
        return ()=>observer.disconnect();
    }, [
        rootMargin,
        ref,
        onInViewport
    ]);
};













var $cbY7C = parcelRequire("cbY7C");


var $55fM8 = parcelRequire("55fM8");

const $47f62af1c1aad647$var$DEBOUNCE_DURATION = 50;
const $47f62af1c1aad647$var$MIN_SCROLL_OFFSET = 0;
const $47f62af1c1aad647$export$a884902d10f751f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useScrollDirection(params) {
    const $ = (0, $bDgLe.c)(4);
    const { ref: ref, onScroll: onScroll } = params;
    const lastScrollY = (0, $cozmU.useRef)(0);
    let t0;
    let t1;
    if ($[0] !== onScroll || $[1] !== ref) {
        t0 = ()=>{
            if (!ref || !ref.current) return;
            const onScrollDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
                const scrollY = ref.current.scrollTop;
                const direction = scrollY > lastScrollY.current ? "down" : "up";
                if (scrollY - lastScrollY.current > $47f62af1c1aad647$var$MIN_SCROLL_OFFSET || scrollY - lastScrollY.current < -1 * $47f62af1c1aad647$var$MIN_SCROLL_OFFSET) onScroll(direction);
                lastScrollY.current = scrollY > 0 ? scrollY : 0;
            }, $47f62af1c1aad647$var$DEBOUNCE_DURATION);
            return (0, $cbY7C.bind)(ref.current, {
                type: "scroll",
                listener: onScrollDebounced,
                options: {
                    capture: true
                }
            });
        };
        t1 = [
            ref,
            onScroll
        ];
        $[0] = onScroll;
        $[1] = ref;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : function useScrollDirection(params) {
    const { ref: ref, onScroll: onScroll } = params;
    const lastScrollY = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const onScrollDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            const scrollY = ref.current.scrollTop;
            const direction = scrollY > lastScrollY.current ? 'down' : 'up';
            if (scrollY - lastScrollY.current > $47f62af1c1aad647$var$MIN_SCROLL_OFFSET || scrollY - lastScrollY.current < -1 * $47f62af1c1aad647$var$MIN_SCROLL_OFFSET) // Call the callback directly in the event handler to avoid a chain-of-computation
            // anti-pattern (effect → state → effect).
            onScroll(direction);
            lastScrollY.current = scrollY > 0 ? scrollY : 0;
        }, $47f62af1c1aad647$var$DEBOUNCE_DURATION);
        return (0, $cbY7C.bind)(ref.current, {
            type: 'scroll',
            listener: onScrollDebounced,
            options: {
                capture: true
            }
        });
    // Only depend on ref and onScrollCallback — no need to re-subscribe when scrollDirection changes.
    }, [
        ref,
        onScroll
    ]);
};

















const $8d09e1a1f65a97fb$export$afc6d5ca319092bd = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $8d09e1a1f65a97fb$export$4a602ad7e09bdb2c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($8d09e1a1f65a97fb$export$afc6d5ca319092bd);
    (0, $bB0i2.default)(context, "useSideNavVisibility must be used within an SideNavVisibilityProvider");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($8d09e1a1f65a97fb$export$afc6d5ca319092bd);
    (0, $bB0i2.default)(context, 'useSideNavVisibility must be used within an SideNavVisibilityProvider');
    return context;
};
const $8d09e1a1f65a97fb$export$aac8e996360f6ad9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SideNavVisibilityProvider(t0) {
    const $ = (0, $bDgLe.c)(29);
    const { children: children, onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, onResizeEnd: onResizeEnd, onResizeStart: onResizeStart, setUserSideNavData: setUserSideNavData } = t0;
    const { fireEvent: fireEvent } = (0, $19ead867f45fce96$export$5bf35293e545f20c)();
    let t1;
    if ($[0] !== fireEvent || $[1] !== onCollapse || $[2] !== setUserSideNavData) {
        t1 = (args)=>{
            fireEvent("ui.sideNav.collapsed", {
                ...args
            });
            setUserSideNavData({
                defaultCollapsed: true
            });
            onCollapse?.(args);
        };
        $[0] = fireEvent;
        $[1] = onCollapse;
        $[2] = setUserSideNavData;
        $[3] = t1;
    } else t1 = $[3];
    const onCollapseHandler = t1;
    let t2;
    if ($[4] !== fireEvent || $[5] !== onExpand || $[6] !== setUserSideNavData) {
        t2 = (args_0)=>{
            fireEvent("ui.sideNav.expanded", {
                ...args_0
            });
            setUserSideNavData({
                defaultCollapsed: false
            });
            onExpand?.(args_0);
        };
        $[4] = fireEvent;
        $[5] = onExpand;
        $[6] = setUserSideNavData;
        $[7] = t2;
    } else t2 = $[7];
    const onExpandHandler = t2;
    let t3;
    if ($[8] !== onPeekStart) {
        t3 = ()=>{
            onPeekStart?.();
        };
        $[8] = onPeekStart;
        $[9] = t3;
    } else t3 = $[9];
    const onPeekStartHandler = t3;
    let t4;
    if ($[10] !== onPeekEnd) {
        t4 = (args_1)=>{
            onPeekEnd?.(args_1);
        };
        $[10] = onPeekEnd;
        $[11] = t4;
    } else t4 = $[11];
    const onPeekEndHandler = t4;
    let t5;
    if ($[12] !== fireEvent || $[13] !== onResizeStart) {
        t5 = (args_2)=>{
            fireEvent("ui.sideNav.resizeStart", {
                ...args_2
            });
            onResizeStart?.(args_2);
        };
        $[12] = fireEvent;
        $[13] = onResizeStart;
        $[14] = t5;
    } else t5 = $[14];
    const onResizeStartHandler = t5;
    let t6;
    if ($[15] !== fireEvent || $[16] !== onResizeEnd || $[17] !== setUserSideNavData) {
        t6 = (args_3)=>{
            fireEvent("ui.sideNav.resizeEnd", {
                ...args_3
            });
            setUserSideNavData({
                defaultWidth: args_3.finalWidth
            });
            onResizeEnd?.(args_3);
        };
        $[15] = fireEvent;
        $[16] = onResizeEnd;
        $[17] = setUserSideNavData;
        $[18] = t6;
    } else t6 = $[18];
    const onResizeEndHandler = t6;
    let t7;
    if ($[19] !== onCollapseHandler || $[20] !== onExpandHandler || $[21] !== onPeekEndHandler || $[22] !== onPeekStartHandler || $[23] !== onResizeEndHandler || $[24] !== onResizeStartHandler) {
        t7 = {
            onExpand: onExpandHandler,
            onCollapse: onCollapseHandler,
            onPeekStart: onPeekStartHandler,
            onPeekEnd: onPeekEndHandler,
            onResizeEnd: onResizeEndHandler,
            onResizeStart: onResizeStartHandler
        };
        $[19] = onCollapseHandler;
        $[20] = onExpandHandler;
        $[21] = onPeekEndHandler;
        $[22] = onPeekStartHandler;
        $[23] = onResizeEndHandler;
        $[24] = onResizeStartHandler;
        $[25] = t7;
    } else t7 = $[25];
    const stableContextValue = t7;
    let t8;
    if ($[26] !== children || $[27] !== stableContextValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d09e1a1f65a97fb$export$afc6d5ca319092bd.Provider, {
            value: stableContextValue
        }, children);
        $[26] = children;
        $[27] = stableContextValue;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : function SideNavVisibilityProvider({ children: children, onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, onResizeEnd: onResizeEnd, onResizeStart: onResizeStart, setUserSideNavData: setUserSideNavData }) {
    const { fireEvent: fireEvent } = (0, $19ead867f45fce96$export$5bf35293e545f20c)();
    const onCollapseHandler = (0, $cozmU.useCallback)((args)=>{
        fireEvent('ui.sideNav.collapsed', {
            ...args
        });
        setUserSideNavData({
            defaultCollapsed: true
        });
        onCollapse?.(args);
    }, [
        fireEvent,
        onCollapse,
        setUserSideNavData
    ]);
    const onExpandHandler = (0, $cozmU.useCallback)((args_0)=>{
        fireEvent('ui.sideNav.expanded', {
            ...args_0
        });
        setUserSideNavData({
            defaultCollapsed: false
        });
        onExpand?.(args_0);
    }, [
        fireEvent,
        onExpand,
        setUserSideNavData
    ]);
    const onPeekStartHandler = (0, $cozmU.useCallback)(()=>{
        onPeekStart?.();
    }, [
        onPeekStart
    ]);
    const onPeekEndHandler = (0, $cozmU.useCallback)((args_1)=>{
        onPeekEnd?.(args_1);
    }, [
        onPeekEnd
    ]);
    const onResizeStartHandler = (0, $cozmU.useCallback)((args_2)=>{
        fireEvent('ui.sideNav.resizeStart', {
            ...args_2
        });
        onResizeStart?.(args_2);
    }, [
        fireEvent,
        onResizeStart
    ]);
    const onResizeEndHandler = (0, $cozmU.useCallback)((args_3)=>{
        fireEvent('ui.sideNav.resizeEnd', {
            ...args_3
        });
        setUserSideNavData({
            defaultWidth: args_3.finalWidth
        });
        onResizeEnd?.(args_3);
    }, [
        fireEvent,
        onResizeEnd,
        setUserSideNavData
    ]);
    const stableContextValue = (0, $cozmU.useMemo)(()=>({
            onExpand: onExpandHandler,
            onCollapse: onCollapseHandler,
            onPeekStart: onPeekStartHandler,
            onPeekEnd: onPeekEndHandler,
            onResizeEnd: onResizeEndHandler,
            onResizeStart: onResizeStartHandler
        }), [
        onExpandHandler,
        onCollapseHandler,
        onResizeEndHandler,
        onResizeStartHandler,
        onPeekStartHandler,
        onPeekEndHandler
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d09e1a1f65a97fb$export$afc6d5ca319092bd.Provider, {
        value: stableContextValue
    }, children);
};



const $52d918d1c2e11cae$export$5c53281b43e13144 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GSNSideNavigationLayout(props) {
    const $ = (0, $bDgLe.c)(11);
    const { setUserSideNavData: setUserSideNavData } = (0, $102e17007742dcab$export$af1627270f7f3b2c)();
    const { onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd } = props;
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52d918d1c2e11cae$var$GSNLayoutComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== onCollapse || $[3] !== onExpand || $[4] !== onPeekEnd || $[5] !== onPeekStart || $[6] !== onResizeEnd || $[7] !== onResizeStart || $[8] !== setUserSideNavData || $[9] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8d09e1a1f65a97fb$export$aac8e996360f6ad9), {
            setUserSideNavData: setUserSideNavData,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd
        }, t0);
        $[2] = onCollapse;
        $[3] = onExpand;
        $[4] = onPeekEnd;
        $[5] = onPeekStart;
        $[6] = onResizeEnd;
        $[7] = onResizeStart;
        $[8] = setUserSideNavData;
        $[9] = t0;
        $[10] = t1;
    } else t1 = $[10];
    return t1;
} : function GSNSideNavigationLayout(props) {
    const { setUserSideNavData: setUserSideNavData } = (0, $102e17007742dcab$export$af1627270f7f3b2c)();
    const { onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8d09e1a1f65a97fb$export$aac8e996360f6ad9), {
        setUserSideNavData: setUserSideNavData,
        onExpand: onExpand,
        onCollapse: onCollapse,
        onPeekStart: onPeekStart,
        onPeekEnd: onPeekEnd,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($52d918d1c2e11cae$var$GSNLayoutComponent, props));
};
function $52d918d1c2e11cae$var$GSNLayoutComponent({ preMainElem: preMainElem, postMainElem: postMainElem, bottomElem: bottomElem, children: children, testId: testId, sideNavContentRef: sideNavContentRef }) {
    const { fireEvent: fireEvent } = (0, $19ead867f45fce96$export$5bf35293e545f20c)();
    const { userSideNavData: userSideNavData } = (0, $102e17007742dcab$export$af1627270f7f3b2c)();
    const { onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd } = (0, $8d09e1a1f65a97fb$export$4a602ad7e09bdb2c)();
    const internalSideNavRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const combinedRef = (0, $cozmU.useCallback)((instance)=>{
        internalSideNavRef.current = instance;
        if (typeof sideNavContentRef === 'function') sideNavContentRef(instance);
        else if (sideNavContentRef) sideNavContentRef.current = instance;
    }, [
        sideNavContentRef
    ]);
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { fireViewedSideNavEvent: fireViewedSideNavEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    const fireScrollAnalytics = (0, $cozmU.useCallback)((direction)=>{
        fireEvent('ui.sideNav.scrolled.sideNavMenu', {
            scrollDirection: direction
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fireEvent
    ]);
    (0, $47f62af1c1aad647$export$a884902d10f751f2)({
        onScroll: fireScrollAnalytics,
        ref: internalSideNavRef
    });
    (0, $3e97dfd5d57e4a85$export$6215040b989f9b0f)({
        ref: internalSideNavRef,
        rootMargin: '0px',
        onInViewport: fireViewedSideNavEvent
    });
    (0, $cozmU.useEffect)(()=>{
        if (!l1DragAndDropEnabled) return;
        const scrollable = internalSideNavRef.current;
        (0, $bB0i2.default)(scrollable, 'sideNavContentRef must be set');
        return (0, $38vK5.autoScrollForElements)({
            element: scrollable,
            canScroll: ({ source: source })=>source.data.type === 'menu-item'
        });
    }, [
        l1DragAndDropEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $409e78b28aeb95f3$export$610d5f09b69fac71), {
        testId: testId,
        onExpand: onExpand,
        onCollapse: onCollapse,
        onPeekStart: onPeekStart,
        onPeekEnd: onPeekEnd,
        defaultWidth: userSideNavData.defaultWidth,
        defaultCollapsed: userSideNavData.defaultCollapsed,
        sideNavContentRef: combinedRef,
        preMainElem: preMainElem,
        postMainElem: postMainElem,
        onResizeEnd: onResizeEnd,
        onResizeStart: onResizeStart,
        bottomElem: bottomElem
    }, children);
}















var $w6R6I = parcelRequire("w6R6I");





var $3izAL = parcelRequire("3izAL");


var $2wCqQ = parcelRequire("2wCqQ");





var $czzzJ = parcelRequire("czzzJ");























var $6L2pn = parcelRequire("6L2pn");


const $f9c7833f93cdb3f1$export$9ef62ebfdd487c3d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { shortcutsConfig: shortcutsConfig, growthShortcutsConfig: growthShortcutsConfig, visibleShortcuts: visibleShortcuts } = t0;
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    let t1;
    if ($[0] !== fireClickedSideNavItemEvent || $[1] !== growthShortcutsConfig || $[2] !== shortcutsConfig || $[3] !== visibleShortcuts) {
        let t2;
        if ($[5] !== shortcutsConfig) {
            t2 = (acc, id)=>{
                const shortcut = shortcutsConfig?.[id];
                if (shortcut) acc.push({
                    menuItemId: id,
                    ...shortcut
                });
                return acc;
            };
            $[5] = shortcutsConfig;
            $[6] = t2;
        } else t2 = $[6];
        const availableShortcuts = visibleShortcuts.reduce(t2, []);
        if (growthShortcutsConfig) availableShortcuts.push(...Object.entries(growthShortcutsConfig).map($f9c7833f93cdb3f1$var$_temp));
        const availableShortcutsWithNonEmptyUrls = availableShortcuts.filter($f9c7833f93cdb3f1$var$_temp2);
        let t3;
        if ($[7] !== fireClickedSideNavItemEvent) {
            t3 = (shortcut_2)=>({
                    ...shortcut_2,
                    onClick: ()=>{
                        shortcut_2.onClick?.();
                        fireClickedSideNavItemEvent(shortcut_2.menuItemId, "postMain");
                    },
                    ...shortcut_2.type === "link" && {
                        onRightClick: ()=>{
                            shortcut_2.onRightClick?.();
                            fireClickedSideNavItemEvent(shortcut_2.menuItemId, "postMain", true);
                        }
                    }
                });
            $[7] = fireClickedSideNavItemEvent;
            $[8] = t3;
        } else t3 = $[8];
        t1 = availableShortcutsWithNonEmptyUrls.map(t3);
        $[0] = fireClickedSideNavItemEvent;
        $[1] = growthShortcutsConfig;
        $[2] = shortcutsConfig;
        $[3] = visibleShortcuts;
        $[4] = t1;
    } else t1 = $[4];
    const shortcutsWithMenuId = t1;
    let t2;
    if ($[9] !== shortcutsWithMenuId) {
        t2 = shortcutsWithMenuId.map($f9c7833f93cdb3f1$var$_temp3);
        $[9] = shortcutsWithMenuId;
        $[10] = t2;
    } else t2 = $[10];
    const t3 = t2;
    const t4 = shortcutsWithMenuId;
    let t5;
    if ($[11] !== t3 || $[12] !== t4) {
        t5 = {
            shortcuts: t3,
            shortcutsWithMenuId: t4
        };
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ shortcutsConfig: shortcutsConfig, growthShortcutsConfig: growthShortcutsConfig, visibleShortcuts: visibleShortcuts })=>{
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    // 1. Filter the shortcut config based on visible menu items
    const shortcutsWithMenuId = (0, $cozmU.useMemo)(()=>{
        const availableShortcuts = visibleShortcuts.reduce((acc, id)=>{
            const shortcut = shortcutsConfig?.[id];
            if (shortcut) acc.push({
                menuItemId: id,
                ...shortcut
            });
            return acc;
        }, []);
        if (growthShortcutsConfig) availableShortcuts.push(...Object.entries(growthShortcutsConfig).map(([id_0, shortcut_0])=>({
                menuItemId: id_0,
                ...shortcut_0
            })));
        const availableShortcutsWithNonEmptyUrls = availableShortcuts.filter((shortcut_1)=>{
            // If a shortcut has no resolvable URL, it may ultimately render nothing.
            // Filter those out so we can avoid rendering the whole GAS block when empty.
            if (shortcut_1.type === 'link' || shortcut_1.type === 'internal') {
                const url = (0, $6L2pn.getUrlMaybe)(shortcut_1);
                return url !== undefined && url.trim() !== '';
            }
            // Component shortcuts can still render meaningful UI without a URL.
            return true;
        });
        return availableShortcutsWithNonEmptyUrls.map((shortcut_2)=>({
                ...shortcut_2,
                onClick: ()=>{
                    shortcut_2.onClick?.();
                    fireClickedSideNavItemEvent(shortcut_2.menuItemId, 'postMain');
                },
                ...shortcut_2.type === 'link' && {
                    onRightClick: ()=>{
                        shortcut_2.onRightClick?.();
                        fireClickedSideNavItemEvent(shortcut_2.menuItemId, 'postMain', true);
                    }
                }
            }));
    }, [
        visibleShortcuts,
        growthShortcutsConfig,
        shortcutsConfig,
        fireClickedSideNavItemEvent
    ]);
    return {
        // eslint-disable-next-line no-unused-vars
        shortcuts: shortcutsWithMenuId.map(({ menuItemId: menuItemId, ...shortcut_3 })=>shortcut_3),
        shortcutsWithMenuId: shortcutsWithMenuId
    };
};
function $f9c7833f93cdb3f1$var$_temp(t0) {
    const [id_0, shortcut_0] = t0;
    return {
        menuItemId: id_0,
        ...shortcut_0
    };
}
function $f9c7833f93cdb3f1$var$_temp2(shortcut_1) {
    if (shortcut_1.type === "link" || shortcut_1.type === "internal") {
        const url = (0, $6L2pn.getUrlMaybe)(shortcut_1);
        return url !== undefined && url.trim() !== "";
    }
    return true;
}
function $f9c7833f93cdb3f1$var$_temp3(t0) {
    const { menuItemId: menuItemId, ...shortcut_3 } = t0;
    return shortcut_3;
}























var $6H0Pg = parcelRequire("6H0Pg");





var $1K9mF = parcelRequire("1K9mF");





var $fZMfl = parcelRequire("fZMfl");

// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)





























const $d8eaaaeffc210405$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("ldUti")),
    da: ()=>(parcelRequire("55rcS")),
    de: ()=>(parcelRequire("8uv6r")),
    en: ()=>Promise.resolve((parcelRequire("fZMfl"))),
    'en-GB': ()=>(parcelRequire("k5Rvi")),
    'en-ZZ': ()=>(parcelRequire("bInGL")),
    es: ()=>(parcelRequire("2JfQu")),
    fi: ()=>(parcelRequire("dZAP2")),
    fr: ()=>(parcelRequire("hJsAN")),
    hr: ()=>(parcelRequire("5I5ax")),
    hu: ()=>(parcelRequire("hxfIm")),
    it: ()=>(parcelRequire("eAVG3")),
    ja: ()=>(parcelRequire("8lMto")),
    ko: ()=>(parcelRequire("k0AEC")),
    nb: ()=>(parcelRequire("kgzep")),
    nl: ()=>(parcelRequire("3KWD2")),
    pl: ()=>(parcelRequire("9unjC")),
    'pt-BR': ()=>(parcelRequire("7pbJK")),
    ru: ()=>(parcelRequire("ct4lI")),
    sl: ()=>(parcelRequire("16IXY")),
    'sr-RS': ()=>(parcelRequire("jecWh")),
    'sr-YR': ()=>(parcelRequire("5u5UZ")),
    sv: ()=>(parcelRequire("hiyXn")),
    th: ()=>(parcelRequire("2SxF3")),
    tr: ()=>(parcelRequire("cLunN")),
    uk: ()=>(parcelRequire("fIOP1")),
    vi: ()=>(parcelRequire("4iUgC")),
    zh: ()=>(parcelRequire("e3JnQ")),
    'zh-TW': ()=>(parcelRequire("9rgB5"))
};


const $f4659e28fee58f44$export$2f688dfcc031530a = (0, $aibb0.createAsyncIntlProvider)({
    defaultMessages: (0, $fZMfl.default),
    asyncLanguages: $d8eaaaeffc210405$export$3770c7a7737d463c
});





const $743c6017cae8fcb4$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    description: {
        id: "navigation.global-more-menu.error.description",
        defaultMessage: "Refresh the page and try again"
    },
    header: {
        id: "navigation.global-more-menu.error.header",
        defaultMessage: "We couldn\u2019t load more sidebar options"
    }
});















var $lmzCg = parcelRequire("lmzCg");


var $6TaGl = parcelRequire("6TaGl");





var $7iIKP = parcelRequire("7iIKP");





var $2BWHC = parcelRequire("2BWHC");


var $kJwFk = parcelRequire("kJwFk");








const $4fd6325ccc15d453$export$84811aec0a83d9e5 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("13HE4")), {
        moduleId: "225b9015",
        priority: "interaction",
        moduleId: 'global-more-menu-content-entrypoint'
    }),
    getPreloadProps: ()=>({})
});





const $fc7fc202a75f0eae$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    moreMenuTriggerLabel: {
        id: "navigation.global-more-menu.trigger-label",
        defaultMessage: "More"
    }
});


const $95449636994cc371$var$styles = {
    popup: "_1bsb1rgy"
};
function $95449636994cc371$export$b426d2e536b00785(props) {
    const { customizeSidebarMenuItem: customizeSidebarMenuItem, showMoreMenu: showMoreMenu = true } = props; // This ref is ultimately passed to the Customization Modal, which should cause the modal dialog to
    // return focus to either the Customize Button or the More Menu trigger element.
    // This component is unusual because it must change the
    // visible-menuitem based on whether the more menu needs to show or not.
    const returnFocusRef = (0, $cozmU.useRef)(null); // customizeSidebarMenuItemWithRef adds a ref to the customizeSidebarMenuItem (to allow focussing)
    // and a returnFocusRef, which is passed to the Modal. It doesn't make sense for the caller to
    // define the ref, so *we* add the ref to the component dynamically.
    // The component is then rendered either within the More Menu (when showMoreMenu is true),
    // or as a standalone-button.
    // The isValidElement() test is a formality - it should always pass because GSN should always pass a
    // proper customizeSidebarMenuItem.
    const customizeSidebarMenuItemWithRef = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ (0, $cozmU.isValidElement)(customizeSidebarMenuItem) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(customizeSidebarMenuItem, {
            returnFocusRef: returnFocusRef,
            ref: returnFocusRef
        }) : customizeSidebarMenuItem;
    }, [
        customizeSidebarMenuItem
    ]);
    if (showMoreMenu) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95449636994cc371$var$MoreMenuTriggerInner, {
        ...props,
        customizeSidebarMenuItem: customizeSidebarMenuItemWithRef,
        returnFocusRef: returnFocusRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95449636994cc371$var$CustomizeSidebarTriggerStandalone, {
        returnFocusRef: returnFocusRef,
        customizeSidebarMenuItem: customizeSidebarMenuItem
    });
}
const $95449636994cc371$var$CustomizeSidebarTriggerStandalone = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CustomizeSidebarTriggerStandalone(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { customizeSidebarMenuItem: customizeSidebarMenuItem, returnFocusRef: returnFocusRef } = t0;
    let t1;
    if ($[0] !== returnFocusRef) {
        t1 = {
            returnFocusRef: returnFocusRef,
            ref: returnFocusRef
        };
        $[0] = returnFocusRef;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== customizeSidebarMenuItem || $[3] !== t1) {
        t2 = {
            item: customizeSidebarMenuItem,
            otherProps: t1
        };
        $[2] = customizeSidebarMenuItem;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return (0, $kJwFk.useStandaloneButtonMenuItem)(t2);
} : function CustomizeSidebarTriggerStandalone({ customizeSidebarMenuItem: customizeSidebarMenuItem, returnFocusRef: returnFocusRef }) {
    return (0, $kJwFk.useStandaloneButtonMenuItem)({
        item: customizeSidebarMenuItem,
        otherProps: {
            returnFocusRef: returnFocusRef,
            ref: returnFocusRef
        }
    });
};
const $95449636994cc371$var$MoreMenuTriggerButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MoreMenuTriggerButton(t0) {
    const $ = (0, $bDgLe.c)(8);
    let children;
    let mergedRefs;
    let props;
    if ($[0] !== t0) {
        ({ children: children, mergedRefs: mergedRefs, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = mergedRefs;
        $[3] = props;
    } else {
        children = $[1];
        mergedRefs = $[2];
        props = $[3];
    }
    let t1;
    if ($[4] !== children || $[5] !== mergedRefs || $[6] !== props) {
        t1 = {
            item: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
                ref: mergedRefs,
                ...props
            }, children)
        };
        $[4] = children;
        $[5] = mergedRefs;
        $[6] = props;
        $[7] = t1;
    } else t1 = $[7];
    return (0, $kJwFk.useStandaloneButtonMenuItem)(t1);
} : function MoreMenuTriggerButton({ children: children, mergedRefs: mergedRefs, ...props }) {
    return (0, $kJwFk.useStandaloneButtonMenuItem)({
        item: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
            ref: mergedRefs,
            ...props
        }, children)
    });
};
const $95449636994cc371$var$MoreMenuTriggerInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MoreMenuTriggerInner(props) {
    const $ = (0, $bDgLe.c)(23);
    const { appItemsData: appItemsData, customizeSidebarMenuItem: customizeSidebarMenuItem, dropIndicator: dropIndicator, menuItemComponent: menuItemComponent, moreMenuItemLabel: moreMenuItemLabel, onClickMoreMenuTrigger: onClickMoreMenuTrigger, productItemsData: productItemsData, returnFocusRef: returnFocusRef, testId: testId, triggerRef: triggerRef, triggerVisualContentRef: triggerVisualContentRef } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== onClickMoreMenuTrigger) {
        t0 = ()=>{
            onClickMoreMenuTrigger?.();
        };
        $[0] = onClickMoreMenuTrigger;
        $[1] = t0;
    } else t0 = $[1];
    const handleTriggerClick = t0;
    let t1;
    if ($[2] !== dropIndicator || $[3] !== formatMessage || $[4] !== handleTriggerClick || $[5] !== moreMenuItemLabel || $[6] !== returnFocusRef || $[7] !== testId || $[8] !== triggerRef || $[9] !== triggerVisualContentRef) {
        t1 = (triggerProps)=>{
            const { ref: ref, ...restTriggerProps } = triggerProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95449636994cc371$var$MoreMenuTriggerButton, {
                ...restTriggerProps,
                mergedRefs: (0, $lmzCg.default)(triggerRef ? [
                    triggerRef,
                    ref,
                    returnFocusRef
                ] : [
                    ref,
                    returnFocusRef
                ]),
                dropIndicator: dropIndicator,
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                }),
                isSelected: triggerProps["aria-expanded"],
                interactionName: (0, $1K9mF.GLOBAL_MORE_MENU_INTERACTION_NAME),
                onClick: handleTriggerClick,
                testId: testId,
                visualContentRef: triggerVisualContentRef
            }, moreMenuItemLabel ?? formatMessage((0, $fc7fc202a75f0eae$export$defe85febe8b728c).moreMenuTriggerLabel));
        };
        $[2] = dropIndicator;
        $[3] = formatMessage;
        $[4] = handleTriggerClick;
        $[5] = moreMenuItemLabel;
        $[6] = returnFocusRef;
        $[7] = testId;
        $[8] = triggerRef;
        $[9] = triggerVisualContentRef;
        $[10] = t1;
    } else t1 = $[10];
    const triggerFn = t1;
    let t2;
    if ($[11] !== customizeSidebarMenuItem || $[12] !== menuItemComponent) {
        t2 = {
            customizeSidebarMenuItem: customizeSidebarMenuItem,
            menuItemComponent: menuItemComponent
        };
        $[11] = customizeSidebarMenuItem;
        $[12] = menuItemComponent;
        $[13] = t2;
    } else t2 = $[13];
    const entryPointProps = t2;
    let t3;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            -4,
            4
        ];
        $[14] = t3;
    } else t3 = $[14];
    const t4 = `${testId || "more-menu"}-content`;
    let t5;
    if ($[15] !== entryPointProps || $[16] !== t4 || $[17] !== triggerFn) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7iIKP.PopupTrigger), {
            entryPoint: (0, $4fd6325ccc15d453$export$84811aec0a83d9e5),
            entryPointProps: entryPointProps,
            offset: t3,
            placement: "bottom-start",
            preloadOnFocus: true,
            role: undefined,
            shouldFitContainer: true,
            shouldRenderToParent: true,
            strategy: "absolute",
            testId: t4,
            trigger: triggerFn,
            xcss: $95449636994cc371$var$styles.popup
        });
        $[15] = entryPointProps;
        $[16] = t4;
        $[17] = triggerFn;
        $[18] = t5;
    } else t5 = $[18];
    let t6;
    if ($[19] !== appItemsData || $[20] !== productItemsData || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2BWHC.PopupDataProvider), {
            appItemsData: appItemsData,
            productItemsData: productItemsData
        }, t5);
        $[19] = appItemsData;
        $[20] = productItemsData;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
} : function MoreMenuTriggerInner(props) {
    const { appItemsData: appItemsData, customizeSidebarMenuItem: customizeSidebarMenuItem, dropIndicator: dropIndicator, menuItemComponent: menuItemComponent, moreMenuItemLabel: moreMenuItemLabel, onClickMoreMenuTrigger: onClickMoreMenuTrigger, productItemsData: productItemsData, returnFocusRef: returnFocusRef, testId: testId, triggerRef: triggerRef, triggerVisualContentRef: triggerVisualContentRef } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleTriggerClick = (0, $cozmU.useCallback)(()=>{
        onClickMoreMenuTrigger?.();
    }, [
        onClickMoreMenuTrigger
    ]);
    const triggerFn = (0, $cozmU.useCallback)((triggerProps)=>{
        const { ref: ref, ...restTriggerProps } = triggerProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95449636994cc371$var$MoreMenuTriggerButton, {
            ...restTriggerProps,
            mergedRefs: (0, $lmzCg.default)(triggerRef ? [
                triggerRef,
                ref,
                returnFocusRef
            ] : [
                ref,
                returnFocusRef
            ]),
            dropIndicator: dropIndicator,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            }),
            isSelected: triggerProps['aria-expanded'],
            interactionName: (0, $1K9mF.GLOBAL_MORE_MENU_INTERACTION_NAME),
            onClick: handleTriggerClick,
            testId: testId,
            visualContentRef: triggerVisualContentRef
        }, moreMenuItemLabel ?? formatMessage((0, $fc7fc202a75f0eae$export$defe85febe8b728c).moreMenuTriggerLabel));
    }, [
        dropIndicator,
        formatMessage,
        handleTriggerClick,
        moreMenuItemLabel,
        returnFocusRef,
        testId,
        triggerRef,
        triggerVisualContentRef
    ]);
    const entryPointProps = (0, $cozmU.useMemo)(()=>({
            customizeSidebarMenuItem: customizeSidebarMenuItem,
            menuItemComponent: menuItemComponent
        }), [
        customizeSidebarMenuItem,
        menuItemComponent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2BWHC.PopupDataProvider), {
        appItemsData: appItemsData,
        productItemsData: productItemsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7iIKP.PopupTrigger), {
        entryPoint: (0, $4fd6325ccc15d453$export$84811aec0a83d9e5),
        entryPointProps: entryPointProps,
        // This will keep an even spacing of menu items between those inside the dropdown and those above,
        // and keep the icons aligned
        offset: [
            -4,
            4
        ],
        placement: "bottom-start",
        preloadOnFocus: true,
        role: undefined,
        shouldFitContainer: true,
        shouldRenderToParent: true,
        strategy: "absolute",
        testId: `${testId || 'more-menu'}-content`,
        trigger: triggerFn,
        xcss: $95449636994cc371$var$styles.popup
    }));
};


function $d9c9e32fa5c785a5$export$89456cd3628213b2(productItemsData, appItemsData, peekingMenuIds) {
    const checkIsHiddenMenuItem = ({ menuId: menuId, visible: visible })=>!visible && !peekingMenuIds.includes(menuId);
    const hiddenProductItemsData = productItemsData.filter(checkIsHiddenMenuItem);
    const hiddenAppItemsData = appItemsData.filter(checkIsHiddenMenuItem);
    return {
        hiddenProductItemsData: hiddenProductItemsData,
        hiddenAppItemsData: hiddenAppItemsData,
        shouldShowMoreMenu: hiddenProductItemsData.length !== 0 || hiddenAppItemsData.length !== 0
    };
}


const $79e67fc33ee3bfb0$export$6741e824c68e9927 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalMoreMenu(props) {
    const $ = (0, $bDgLe.c)(5);
    const { intlMode: intlMode } = props;
    const t0 = intlMode === "inherit";
    let t1;
    if ($[0] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6H0Pg.default), {
            name: (0, $1K9mF.GLOBAL_MORE_MENU_INTERACTION_NAME)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $743c6017cae8fcb4$export$defe85febe8b728c),
            interactionId: (0, $1K9mF.GLOBAL_MORE_MENU_INTERACTION_ID),
            showFlags: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($79e67fc33ee3bfb0$var$GlobalMoreMenuInner, props)));
        $[0] = props;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4659e28fee58f44$export$2f688dfcc031530a), {
            disabled: t0
        }, t1);
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function GlobalMoreMenu(props) {
    const { intlMode: intlMode } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4659e28fee58f44$export$2f688dfcc031530a), {
        disabled: intlMode === 'inherit'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6H0Pg.default), {
        name: (0, $1K9mF.GLOBAL_MORE_MENU_INTERACTION_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
        errorMessages: (0, $743c6017cae8fcb4$export$defe85febe8b728c),
        interactionId: (0, $1K9mF.GLOBAL_MORE_MENU_INTERACTION_ID),
        showFlags: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($79e67fc33ee3bfb0$var$GlobalMoreMenuInner, props))));
};
const $79e67fc33ee3bfb0$var$GlobalMoreMenuInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalMoreMenuInner(t0) {
    const $ = (0, $bDgLe.c)(20);
    const { productItemsData: productItemsData, appItemsData: t1, menuItemComponent: menuItemComponent, customizeSidebarMenuItem: customizeSidebarMenuItem, moreMenuItemLabel: moreMenuItemLabel, peekingMenuIds: t2, onClickMoreMenuTrigger: onClickMoreMenuTrigger, testId: testId, triggerRef: triggerRef, triggerVisualContentRef: triggerVisualContentRef, dropIndicator: dropIndicator } = t0;
    let t3;
    if ($[0] !== t1) {
        t3 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t3;
    } else t3 = $[1];
    const appItemsData = t3;
    let t4;
    if ($[2] !== t2) {
        t4 = t2 === undefined ? [] : t2;
        $[2] = t2;
        $[3] = t4;
    } else t4 = $[3];
    const peekingMenuIds = t4;
    let t5;
    if ($[4] !== appItemsData || $[5] !== peekingMenuIds || $[6] !== productItemsData) {
        t5 = (0, $d9c9e32fa5c785a5$export$89456cd3628213b2)(productItemsData, appItemsData, peekingMenuIds);
        $[4] = appItemsData;
        $[5] = peekingMenuIds;
        $[6] = productItemsData;
        $[7] = t5;
    } else t5 = $[7];
    const { hiddenProductItemsData: hiddenProductItemsData, hiddenAppItemsData: hiddenAppItemsData, shouldShowMoreMenu: shouldShowMoreMenu } = t5;
    let t6;
    if ($[8] !== customizeSidebarMenuItem || $[9] !== dropIndicator || $[10] !== hiddenAppItemsData || $[11] !== hiddenProductItemsData || $[12] !== menuItemComponent || $[13] !== moreMenuItemLabel || $[14] !== onClickMoreMenuTrigger || $[15] !== shouldShowMoreMenu || $[16] !== testId || $[17] !== triggerRef || $[18] !== triggerVisualContentRef) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95449636994cc371$export$b426d2e536b00785), {
            appItemsData: hiddenAppItemsData,
            customizeSidebarMenuItem: customizeSidebarMenuItem,
            dropIndicator: dropIndicator,
            menuItemComponent: menuItemComponent,
            moreMenuItemLabel: moreMenuItemLabel,
            onClickMoreMenuTrigger: onClickMoreMenuTrigger,
            productItemsData: hiddenProductItemsData,
            showMoreMenu: shouldShowMoreMenu,
            testId: testId,
            triggerRef: triggerRef,
            triggerVisualContentRef: triggerVisualContentRef
        });
        $[8] = customizeSidebarMenuItem;
        $[9] = dropIndicator;
        $[10] = hiddenAppItemsData;
        $[11] = hiddenProductItemsData;
        $[12] = menuItemComponent;
        $[13] = moreMenuItemLabel;
        $[14] = onClickMoreMenuTrigger;
        $[15] = shouldShowMoreMenu;
        $[16] = testId;
        $[17] = triggerRef;
        $[18] = triggerVisualContentRef;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
} : function GlobalMoreMenuInner({ productItemsData: productItemsData, appItemsData: appItemsData = [], menuItemComponent: menuItemComponent, customizeSidebarMenuItem: customizeSidebarMenuItem, moreMenuItemLabel: moreMenuItemLabel, peekingMenuIds: peekingMenuIds = [], onClickMoreMenuTrigger: onClickMoreMenuTrigger, testId: testId, triggerRef: triggerRef, triggerVisualContentRef: triggerVisualContentRef, dropIndicator: dropIndicator }) {
    const { hiddenProductItemsData: hiddenProductItemsData, hiddenAppItemsData: hiddenAppItemsData, shouldShowMoreMenu: shouldShowMoreMenu } = (0, $d9c9e32fa5c785a5$export$89456cd3628213b2)(productItemsData, appItemsData, peekingMenuIds);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95449636994cc371$export$b426d2e536b00785), {
        appItemsData: hiddenAppItemsData,
        customizeSidebarMenuItem: customizeSidebarMenuItem,
        dropIndicator: dropIndicator,
        menuItemComponent: menuItemComponent,
        moreMenuItemLabel: moreMenuItemLabel,
        onClickMoreMenuTrigger: onClickMoreMenuTrigger,
        productItemsData: hiddenProductItemsData,
        showMoreMenu: shouldShowMoreMenu,
        testId: testId,
        triggerRef: triggerRef,
        triggerVisualContentRef: triggerVisualContentRef
    });
};




















var $dPtk6 = parcelRequire("dPtk6");





var $1aX82 = parcelRequire("1aX82");


var $fAint = parcelRequire("fAint");

function $5f42595937138524$export$fc8975fe9e50b6c4(userMenuData, items) {
    return userMenuData.map((item)=>{
        const itemConfig = items[item.menuId];
        if (!itemConfig) return item;
        return {
            ...item,
            isNotCustomizable: itemConfig.isReorderable === false,
            isNotToggleable: itemConfig.isHideable === false
        };
    });
}


const $f020f1a892af9db8$export$a035ba4c7e651a8e = (items, _shortcuts)=>{
    // Check if any item is reorderable or hideable
    return Object.values(items).some((item)=>item.isReorderable !== false || item.isHideable !== false);
};












const $a820ca197e8020b3$export$ecbfe7cad2f40363 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { setUserMenuData: setUserMenuData } = (0, $b7c49387c5e9ce27$export$f340ebbec0629d31)();
    let t0;
    if ($[0] !== setUserMenuData) {
        t0 = async (updatedItemExtendedUserMenuData, updatedShortcutExtendedUserMenuData)=>{
            const userMenuData = updatedItemExtendedUserMenuData.concat(updatedShortcutExtendedUserMenuData).map($a820ca197e8020b3$var$_temp);
            setUserMenuData(userMenuData);
        };
        $[0] = setUserMenuData;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { setUserMenuData: setUserMenuData } = (0, $b7c49387c5e9ce27$export$f340ebbec0629d31)();
    return (0, $cozmU.useCallback)(async (updatedItemExtendedUserMenuData, updatedShortcutExtendedUserMenuData)=>{
        // Put the data back together and remove extra properties
        const userMenuData = updatedItemExtendedUserMenuData.concat(updatedShortcutExtendedUserMenuData).map(({ menuId: menuId, visible: visible })=>({
                menuId: menuId,
                visible: visible
            }));
        setUserMenuData(userMenuData);
    }, [
        setUserMenuData
    ]);
};
function $a820ca197e8020b3$var$_temp(t0) {
    const { menuId: menuId, visible: visible } = t0;
    return {
        menuId: menuId,
        visible: visible
    };
}










const $0c6ead36f4099071$export$ce0411fdea635705 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("6Kz1B")), {
        moduleId: "b2e7e7c1",
        priority: "interaction",
        moduleId: 'navigation.global-side-navigation.customization-modal'
    }),
    getPreloadProps: ()=>({})
});





const $57cdf41011594bc7$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    customizeSidebarMenuItemLabel: {
        id: "navigation.global-side-navigation.customize-sidebar-menu-item.label",
        defaultMessage: "Customize sidebar"
    }
});





















var $iMnC5 = parcelRequire("iMnC5");

function $2d0950c204248747$export$5412ec86882b110d(items, shortcuts) {
    return (menuId)=>{
        const item = items[menuId];
        if (item) {
            const { elemBefore: icon, label: label } = item;
            return {
                icon: icon,
                label: label
            };
        }
        const shortcut = shortcuts[menuId];
        if (shortcut) {
            const { icon: icon, label: label } = shortcut;
            return {
                icon: $2d0950c204248747$var$ShortcutWrapper(icon),
                label: label
            };
        }
        throw Error(`Menu id ${menuId} not found in either items or shortcuts`);
    };
}
// Add 2px padding around all shortcut icons, as their xsmall-size is 20px. For the app-items,
// their size is 16px, with space="spacious" (taking them to 24px). This added padding means
// the app item icons and shortcut icons should have the same size-including-padding.
const $2d0950c204248747$var$styles = {
    box: "_1e0c1txw _ae4v1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
const $2d0950c204248747$var$ShortcutWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ShortcutWrapper(icon) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== icon) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $2d0950c204248747$var$styles.box
        }, " ", icon);
        $[0] = icon;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function ShortcutWrapper(icon) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $2d0950c204248747$var$styles.box
    }, " ", icon);
};


const $ae37b391ab89a5b3$export$946f6bdd4c4f6c7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (items, shortcuts)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== items || $[1] !== shortcuts) {
        t0 = (menuId)=>(0, $2d0950c204248747$export$5412ec86882b110d)(items, shortcuts)(menuId);
        $[0] = items;
        $[1] = shortcuts;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (items, shortcuts)=>(0, $cozmU.useCallback)((menuId)=>(0, $2d0950c204248747$export$5412ec86882b110d)(items, shortcuts)(menuId), [
        items,
        shortcuts
    ]);


const $6cf1761583d2338a$export$b7fa0daee00ba08b = /*#__PURE__*/ (0, $cozmU.forwardRef)($6cf1761583d2338a$var$CustomizeSidebarMenuItemWithRef);
const $6cf1761583d2338a$var$isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $6cf1761583d2338a$var$CustomizeSidebarMenuItemWithRef_optimized(t0, ref) {
    const $ = (0, $bDgLe.c)(22);
    const { appLabel: appLabel, closeMenu: closeMenu, items: items, onClick: onClick, returnFocusRef: returnFocusRef, listItemRef: listItemRef, shortcuts: shortcuts, testId: testId } = t0;
    const getMenuIconAndLabel = (0, $ae37b391ab89a5b3$export$946f6bdd4c4f6c7)(items, shortcuts);
    const { itemUserMenuData: itemUserMenuData, shortcutUserMenuData: shortcutUserMenuData } = (0, $b7c49387c5e9ce27$export$f340ebbec0629d31)();
    let t1;
    if ($[0] !== itemUserMenuData || $[1] !== items) {
        t1 = (0, $5f42595937138524$export$fc8975fe9e50b6c4)(itemUserMenuData, items);
        $[0] = itemUserMenuData;
        $[1] = items;
        $[2] = t1;
    } else t1 = $[2];
    const itemExtendedUserMenuData = t1;
    const onSave = (0, $a820ca197e8020b3$export$ecbfe7cad2f40363)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const interactionName = (0, $fAint.NavigationExperienceId).customizationModalLoad.experienceId;
    let t2;
    if ($[3] !== closeMenu || $[4] !== onClick) {
        t2 = ()=>{
            closeMenu?.();
            onClick?.();
        };
        $[3] = closeMenu;
        $[4] = onClick;
        $[5] = t2;
    } else t2 = $[5];
    const handleClick = t2;
    if (!(0, $f020f1a892af9db8$export$a035ba4c7e651a8e)(items, shortcuts)) return null;
    let t3;
    if ($[6] !== appLabel || $[7] !== getMenuIconAndLabel || $[8] !== itemExtendedUserMenuData || $[9] !== onSave || $[10] !== returnFocusRef || $[11] !== shortcutUserMenuData) {
        t3 = {
            appLabel: appLabel,
            getMenuIconAndLabel: getMenuIconAndLabel,
            itemExtendedUserMenuData: itemExtendedUserMenuData,
            onSave: onSave,
            returnFocusRef: returnFocusRef,
            shortcutExtendedUserMenuData: shortcutUserMenuData
        };
        $[6] = appLabel;
        $[7] = getMenuIconAndLabel;
        $[8] = itemExtendedUserMenuData;
        $[9] = onSave;
        $[10] = returnFocusRef;
        $[11] = shortcutUserMenuData;
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== formatMessage || $[14] !== handleClick || $[15] !== listItemRef || $[16] !== ref || $[17] !== testId) {
        t4 = (t5)=>{
            const { ref: triggerRef } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dPtk6))), {
                    label: ""
                }),
                ref: (0, $4nIKB.mergeRefs)([
                    triggerRef,
                    ref
                ]),
                testId: testId,
                onClick: handleClick,
                interactionName: interactionName,
                listItemRef: listItemRef
            }, formatMessage((0, $57cdf41011594bc7$export$defe85febe8b728c).customizeSidebarMenuItemLabel));
        };
        $[13] = formatMessage;
        $[14] = handleClick;
        $[15] = listItemRef;
        $[16] = ref;
        $[17] = testId;
        $[18] = t4;
    } else t4 = $[18];
    let t5;
    if ($[19] !== t3 || $[20] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1aX82.ModalTrigger), {
            entryPoint: (0, $0c6ead36f4099071$export$ce0411fdea635705),
            entryPointProps: t3
        }, t4);
        $[19] = t3;
        $[20] = t4;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
}
function $6cf1761583d2338a$var$CustomizeSidebarMenuItemWithRef_unoptimized({ appLabel: appLabel, closeMenu: closeMenu, items: items, onClick: onClick, returnFocusRef: returnFocusRef, listItemRef: listItemRef, shortcuts: shortcuts, testId: testId }, ref) {
    const getMenuIconAndLabel = (0, $ae37b391ab89a5b3$export$946f6bdd4c4f6c7)(items, shortcuts);
    const { itemUserMenuData: itemUserMenuData, shortcutUserMenuData: shortcutUserMenuData } = (0, $b7c49387c5e9ce27$export$f340ebbec0629d31)();
    const itemExtendedUserMenuData = (0, $5f42595937138524$export$fc8975fe9e50b6c4)(itemUserMenuData, items);
    const onSave = (0, $a820ca197e8020b3$export$ecbfe7cad2f40363)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const interactionName = (0, $fAint.NavigationExperienceId).customizationModalLoad.experienceId;
    const handleClick = (0, $cozmU.useCallback)(()=>{
        closeMenu?.();
        onClick?.();
    }, [
        closeMenu,
        onClick
    ]);
    if (!(0, $f020f1a892af9db8$export$a035ba4c7e651a8e)(items, shortcuts)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1aX82.ModalTrigger), {
        entryPoint: (0, $0c6ead36f4099071$export$ce0411fdea635705),
        entryPointProps: {
            appLabel: appLabel,
            getMenuIconAndLabel: getMenuIconAndLabel,
            itemExtendedUserMenuData: itemExtendedUserMenuData,
            onSave: onSave,
            returnFocusRef: returnFocusRef,
            shortcutExtendedUserMenuData: shortcutUserMenuData
        }
    }, ({ ref: triggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dPtk6))), {
                label: ""
            }),
            ref: (0, $4nIKB.mergeRefs)([
                triggerRef,
                ref
            ]),
            testId: testId,
            onClick: handleClick,
            interactionName: interactionName,
            listItemRef: listItemRef
        }, formatMessage((0, $57cdf41011594bc7$export$defe85febe8b728c).customizeSidebarMenuItemLabel)));
}
function $6cf1761583d2338a$var$CustomizeSidebarMenuItemWithRef(arg0, arg1) {
    if ($6cf1761583d2338a$var$isReactCompilerActivePlatform_result) return $6cf1761583d2338a$var$CustomizeSidebarMenuItemWithRef_optimized(arg0, arg1);
    else return $6cf1761583d2338a$var$CustomizeSidebarMenuItemWithRef_unoptimized(arg0, arg1);
}















var $V3JOP = parcelRequire("V3JOP");




var $eaC3G = parcelRequire("eaC3G");












const $f0704f881f8ef4d2$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    linkExternalIconLabel: {
        id: "navigation.global-side-navigation.more-menu-item.link-external-item-label",
        defaultMessage: "Open external link icon"
    }
});


const $0d78cea80e1358a3$var$MoreMenuItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MoreMenuItem(t0) {
    const $ = (0, $bDgLe.c)(27);
    const { id: id, items: items, onClick: onClick, openShortcutsInSameTab: openShortcutsInSameTab, shortcutItems: shortcutItems } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const setPeekMenuId = (0, $e462797418f11995$export$a90578dce3c14324)();
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const shortcutItem = shortcutItems?.[id];
    if (shortcutItem) {
        if (shortcutItem.type === "component") {
            let t1;
            if ($[0] !== id || $[1] !== l1DragAndDropEnabled || $[2] !== shortcutItem) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d78cea80e1358a3$var$MoreShortcutItem, {
                    id: id,
                    shortcutItem: shortcutItem,
                    l1DragAndDropEnabled: l1DragAndDropEnabled
                });
                $[0] = id;
                $[1] = l1DragAndDropEnabled;
                $[2] = shortcutItem;
                $[3] = t1;
            } else t1 = $[3];
            return t1;
        }
        let t1;
        if ($[4] !== formatMessage || $[5] !== openShortcutsInSameTab || $[6] !== shortcutItem) {
            t1 = $0d78cea80e1358a3$var$buildMoreShortcutItem({
                shortcutItem: shortcutItem,
                formatMessage: formatMessage,
                openShortcutsInSameTab: openShortcutsInSameTab
            });
            $[4] = formatMessage;
            $[5] = openShortcutsInSameTab;
            $[6] = shortcutItem;
            $[7] = t1;
        } else t1 = $[7];
        const moreItem = t1;
        let t2;
        if ($[8] !== id || $[9] !== moreItem) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbfe2ad3510eceba$export$2e2bcd8739ae039), {
                id: id,
                item: moreItem,
                isInMoreMenu: true,
                group: (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
            });
            $[8] = id;
            $[9] = moreItem;
            $[10] = t2;
        } else t2 = $[10];
        return t2;
    }
    const item = items[id];
    if (!item) throw new Error(`NavItem: No item found for id "${id}". Ensure the item is defined in appItems or globalItems.`);
    if ((0, $a0cb8887b022d0ae$export$8e525d5a1e55be8f)(item)) {
        let t1;
        if ($[11] !== id || $[12] !== setPeekMenuId) {
            t1 = ()=>setPeekMenuId(id);
            $[11] = id;
            $[12] = setPeekMenuId;
            $[13] = t1;
        } else t1 = $[13];
        let t2;
        if ($[14] !== id || $[15] !== item || $[16] !== onClick || $[17] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbfe2ad3510eceba$export$2e2bcd8739ae039), {
                id: id,
                item: item,
                isInMoreMenu: true,
                onPeek: t1,
                onClick: onClick
            });
            $[14] = id;
            $[15] = item;
            $[16] = onClick;
            $[17] = t1;
            $[18] = t2;
        } else t2 = $[18];
        return t2;
    }
    let t1;
    if ($[19] !== id || $[20] !== item || $[21] !== onClick || $[22] !== setPeekMenuId) {
        t1 = $0d78cea80e1358a3$var$buildMoreItem({
            id: id,
            item: item,
            onClick: onClick,
            onPeek: setPeekMenuId
        });
        $[19] = id;
        $[20] = item;
        $[21] = onClick;
        $[22] = setPeekMenuId;
        $[23] = t1;
    } else t1 = $[23];
    const moreItem_0 = t1;
    let t2;
    if ($[24] !== id || $[25] !== moreItem_0) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbfe2ad3510eceba$export$2e2bcd8739ae039), {
            id: id,
            item: moreItem_0,
            isInMoreMenu: true
        });
        $[24] = id;
        $[25] = moreItem_0;
        $[26] = t2;
    } else t2 = $[26];
    return t2;
} : function MoreMenuItem({ id: id, items: items, onClick: onClick, openShortcutsInSameTab: openShortcutsInSameTab, shortcutItems: shortcutItems }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const setPeekMenuId = (0, $e462797418f11995$export$a90578dce3c14324)();
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const shortcutItem = shortcutItems?.[id];
    if (shortcutItem) {
        // Render custom components as-is, allowing for things like shortcuts opening modals to work
        // Note: We do not pass down the onClick here because that would close the More menu and thus cause such components to not work.
        if (shortcutItem.type === 'component') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d78cea80e1358a3$var$MoreShortcutItem, {
            id: id,
            shortcutItem: shortcutItem,
            l1DragAndDropEnabled: l1DragAndDropEnabled
        });
        const moreItem = $0d78cea80e1358a3$var$buildMoreShortcutItem({
            shortcutItem: shortcutItem,
            formatMessage: formatMessage,
            openShortcutsInSameTab: openShortcutsInSameTab
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbfe2ad3510eceba$export$2e2bcd8739ae039), {
            id: id,
            item: moreItem,
            isInMoreMenu: true,
            group: (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
        });
    }
    // Check if the item is in the items map
    const item = items[id];
    if (!item) throw new Error(`NavItem: No item found for id "${id}". Ensure the item is defined in appItems or globalItems.`);
    if ((0, $a0cb8887b022d0ae$export$8e525d5a1e55be8f)(item)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbfe2ad3510eceba$export$2e2bcd8739ae039), {
        id: id,
        item: item,
        isInMoreMenu: true,
        onPeek: ()=>setPeekMenuId(id),
        onClick: onClick
    });
    const moreItem_0 = $0d78cea80e1358a3$var$buildMoreItem({
        id: id,
        item: item,
        onClick: onClick,
        onPeek: setPeekMenuId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbfe2ad3510eceba$export$2e2bcd8739ae039), {
        id: id,
        item: moreItem_0,
        isInMoreMenu: true
    });
};
var $0d78cea80e1358a3$export$2e2bcd8739ae039 = $0d78cea80e1358a3$var$MoreMenuItem;
const $0d78cea80e1358a3$var$MoreShortcutItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MoreShortcutItem(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { id: id, shortcutItem: shortcutItem, l1DragAndDropEnabled: l1DragAndDropEnabled } = t0;
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    let t1;
    if ($[0] !== fireClickedSideNavItemEvent || $[1] !== id || $[2] !== shortcutItem) {
        t1 = ()=>{
            shortcutItem?.onClick?.();
            fireClickedSideNavItemEvent(id);
        };
        $[0] = fireClickedSideNavItemEvent;
        $[1] = id;
        $[2] = shortcutItem;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    if ((0, $a0cb8887b022d0ae$export$b3885daf9ee22eab)(shortcutItem) && l1DragAndDropEnabled) {
        let t2;
        if ($[4] !== handleClick || $[5] !== shortcutItem) {
            t2 = {
                ...shortcutItem,
                onClick: handleClick
            };
            $[4] = handleClick;
            $[5] = shortcutItem;
            $[6] = t2;
        } else t2 = $[6];
        let t3;
        if ($[7] !== l1DragAndDropEnabled || $[8] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
                shortcut: t2,
                dragAndDropEnabled: l1DragAndDropEnabled,
                isInMoreMenu: true
            });
            $[7] = l1DragAndDropEnabled;
            $[8] = t2;
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    if ((0, $a0cb8887b022d0ae$export$f4fba01b0340f4b5)(shortcutItem)) {
        const Component = shortcutItem.component;
        const ItemWrapper = shortcutItem.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
        let t2;
        if ($[10] !== Component || $[11] !== handleClick) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                onClick: handleClick,
                isInMoreMenu: true
            });
            $[10] = Component;
            $[11] = handleClick;
            $[12] = t2;
        } else t2 = $[12];
        let t3;
        if ($[13] !== ItemWrapper || $[14] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t2);
            $[13] = ItemWrapper;
            $[14] = t2;
            $[15] = t3;
        } else t3 = $[15];
        return t3;
    }
    return null;
} : function MoreShortcutItem({ id: id, shortcutItem: shortcutItem, l1DragAndDropEnabled: l1DragAndDropEnabled }) {
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        shortcutItem?.onClick?.();
        fireClickedSideNavItemEvent(id);
    }, [
        fireClickedSideNavItemEvent,
        id,
        shortcutItem
    ]);
    if ((0, $a0cb8887b022d0ae$export$b3885daf9ee22eab)(shortcutItem) && l1DragAndDropEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
        shortcut: {
            ...shortcutItem,
            onClick: handleClick
        },
        dragAndDropEnabled: l1DragAndDropEnabled,
        isInMoreMenu: true
    });
    if ((0, $a0cb8887b022d0ae$export$f4fba01b0340f4b5)(shortcutItem)) {
        const Component = shortcutItem.component;
        const ItemWrapper = shortcutItem.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            onClick: handleClick,
            isInMoreMenu: true
        }));
    }
    return null;
};
function $0d78cea80e1358a3$var$buildMoreShortcutItem({ formatMessage: formatMessage, openShortcutsInSameTab: openShortcutsInSameTab, shortcutItem: shortcutItem }) {
    const elemAfter = openShortcutsInSameTab ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
        size: "small",
        label: formatMessage((0, $f0704f881f8ef4d2$export$defe85febe8b728c).linkExternalIconLabel),
        spacing: "spacious"
    });
    return {
        type: 'link',
        elemAfter: elemAfter,
        elemBefore: shortcutItem.icon,
        label: shortcutItem.label,
        target: openShortcutsInSameTab ? '_self' : '_blank',
        href: (0, $6L2pn.getUrlMaybe)(shortcutItem) || '#'
    };
}
function $0d78cea80e1358a3$var$buildMoreItem({ id: id, item: item, onClick: onClick, onPeek: onPeek }) {
    if ((0, $a0cb8887b022d0ae$export$e5ec7109da4bc094)(item) || (0, $a0cb8887b022d0ae$export$ee29322ec7068717)(item) || (0, $a0cb8887b022d0ae$export$10dd63e15344d4ca)(item)) return $0d78cea80e1358a3$var$buildMoreItemFromExpandableOrFlyout({
        id: id,
        item: item,
        onClick: onClick,
        onPeek: onPeek
    });
    else if ((0, $a0cb8887b022d0ae$export$cd440346ca02126b)(item) || (0, $a0cb8887b022d0ae$export$4fdefbbdae1adf42)(item)) return $0d78cea80e1358a3$var$buildMoreItemFromButtonOrLink({
        item: item,
        onClick: onClick
    });
    // If the item is not a button, link, expandable, or flyout, return as is
    return item;
}
function $0d78cea80e1358a3$var$buildMoreItemFromExpandableOrFlyout({ id: id, item: item, onClick: onClick, onPeek: onPeek }) {
    const { elemBefore: elemBefore, label: label } = item;
    const onClickActual = $0d78cea80e1358a3$var$combineHandlerAndActions(// ExpandableItemConfig['onClick'] has a third parameter we're not currently providing
    item.onClick, onClick, onPeek && (()=>onPeek(id)));
    // If the item is in the more menu and is an expandable or flyout item, render as a button with peek
    return {
        type: 'button',
        elemBefore: elemBefore,
        label: label,
        onClick: onClickActual
    };
}
function $0d78cea80e1358a3$var$buildMoreItemFromButtonOrLink({ item: item, onClick: onClick }) {
    const onClickActual = $0d78cea80e1358a3$var$combineHandlerAndActions(item.onClick, onClick);
    return {
        ...item,
        // Remove props that are not appropriate for the more menu
        actions: undefined,
        actionsOnHover: undefined,
        elemAfter: undefined,
        labelElem: undefined,
        onClick: onClickActual
    };
}
const $0d78cea80e1358a3$var$combineHandlerAndActions = (handler, ...actions)=>(...args)=>{
        handler?.(...args);
        actions.forEach((action)=>{
            action?.();
        });
    };


const $975ba397feb1c334$var$MoreMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MoreMenu(t0) {
    const $ = (0, $bDgLe.c)(25);
    const { appLabel: appLabel, intlMode: intlMode, itemIds: itemIds, items: items, onClickCustomizeSidebarMenuItem: onClickCustomizeSidebarMenuItem, onClickMoreMenuTrigger: onClickMoreMenuTrigger, openShortcutsInSameTab: openShortcutsInSameTab, shortcutItemIds: shortcutItemIds, shortcutItems: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const shortcutItems = t2;
    const peekMenuId = (0, $e462797418f11995$export$5d097184c0f78e68)();
    let t3;
    if ($[2] !== items || $[3] !== openShortcutsInSameTab || $[4] !== shortcutItems) {
        t3 = (t4)=>{
            const { closeMenu: closeMenu, menuId: menuId } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0d78cea80e1358a3$export$2e2bcd8739ae039), {
                id: menuId,
                key: menuId,
                items: items,
                onClick: closeMenu,
                openShortcutsInSameTab: openShortcutsInSameTab,
                shortcutItems: shortcutItems
            });
        };
        $[2] = items;
        $[3] = openShortcutsInSameTab;
        $[4] = shortcutItems;
        $[5] = t3;
    } else t3 = $[5];
    const menuItemComponent = t3;
    let t4;
    if ($[6] !== itemIds) {
        t4 = itemIds.map($975ba397feb1c334$var$_temp);
        $[6] = itemIds;
        $[7] = t4;
    } else t4 = $[7];
    const productItemsData = t4;
    let t5;
    if ($[8] !== shortcutItemIds) {
        t5 = shortcutItemIds.map($975ba397feb1c334$var$_temp2);
        $[8] = shortcutItemIds;
        $[9] = t5;
    } else t5 = $[9];
    const appItemsData = t5;
    let t6;
    if ($[10] !== appLabel || $[11] !== items || $[12] !== onClickCustomizeSidebarMenuItem || $[13] !== shortcutItems) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf1761583d2338a$export$b7fa0daee00ba08b), {
            items: items,
            shortcuts: shortcutItems,
            testId: (0, $a3266033c74afcf2$export$60e3e06657245ab),
            appLabel: appLabel,
            onClick: onClickCustomizeSidebarMenuItem
        });
        $[10] = appLabel;
        $[11] = items;
        $[12] = onClickCustomizeSidebarMenuItem;
        $[13] = shortcutItems;
        $[14] = t6;
    } else t6 = $[14];
    const customizeSidebarMenuItem = t6;
    let t7;
    if ($[15] !== peekMenuId) {
        t7 = peekMenuId ? [
            peekMenuId
        ] : undefined;
        $[15] = peekMenuId;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== appItemsData || $[18] !== customizeSidebarMenuItem || $[19] !== intlMode || $[20] !== menuItemComponent || $[21] !== onClickMoreMenuTrigger || $[22] !== productItemsData || $[23] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $79e67fc33ee3bfb0$export$6741e824c68e9927), {
            appItemsData: appItemsData,
            customizeSidebarMenuItem: customizeSidebarMenuItem,
            intlMode: intlMode,
            menuItemComponent: menuItemComponent,
            onClickMoreMenuTrigger: onClickMoreMenuTrigger,
            peekingMenuIds: t7,
            productItemsData: productItemsData,
            testId: (0, $a3266033c74afcf2$export$9536180777e6913e)
        });
        $[17] = appItemsData;
        $[18] = customizeSidebarMenuItem;
        $[19] = intlMode;
        $[20] = menuItemComponent;
        $[21] = onClickMoreMenuTrigger;
        $[22] = productItemsData;
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : function MoreMenu({ appLabel: appLabel, intlMode: intlMode, itemIds: itemIds, items: items, onClickCustomizeSidebarMenuItem: onClickCustomizeSidebarMenuItem, onClickMoreMenuTrigger: onClickMoreMenuTrigger, openShortcutsInSameTab: openShortcutsInSameTab, shortcutItemIds: shortcutItemIds, shortcutItems: shortcutItems = {} }) {
    const peekMenuId = (0, $e462797418f11995$export$5d097184c0f78e68)();
    const menuItemComponent = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(({ closeMenu: closeMenu, menuId: menuId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0d78cea80e1358a3$export$2e2bcd8739ae039), {
            id: menuId,
            key: menuId,
            items: items,
            onClick: closeMenu,
            openShortcutsInSameTab: openShortcutsInSameTab,
            shortcutItems: shortcutItems
        });
    }, [
        items,
        shortcutItems,
        openShortcutsInSameTab
    ]);
    const productItemsData = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return itemIds.map((menuId_0)=>({
                menuId: menuId_0,
                visible: false
            }));
    }, [
        itemIds
    ]);
    const appItemsData = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return shortcutItemIds.map((menuId_1)=>({
                menuId: menuId_1,
                visible: false
            }));
    }, [
        shortcutItemIds
    ]);
    const customizeSidebarMenuItem = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cf1761583d2338a$export$b7fa0daee00ba08b), {
            items: items,
            shortcuts: shortcutItems,
            testId: (0, $a3266033c74afcf2$export$60e3e06657245ab),
            appLabel: appLabel,
            onClick: onClickCustomizeSidebarMenuItem
        });
    }, [
        items,
        shortcutItems,
        appLabel,
        onClickCustomizeSidebarMenuItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $79e67fc33ee3bfb0$export$6741e824c68e9927), {
        appItemsData: appItemsData,
        customizeSidebarMenuItem: customizeSidebarMenuItem,
        intlMode: intlMode,
        menuItemComponent: menuItemComponent,
        onClickMoreMenuTrigger: onClickMoreMenuTrigger,
        peekingMenuIds: peekMenuId ? [
            peekMenuId
        ] : undefined,
        productItemsData: productItemsData,
        testId: (0, $a3266033c74afcf2$export$9536180777e6913e)
    });
};
var $975ba397feb1c334$export$2e2bcd8739ae039 = $975ba397feb1c334$var$MoreMenu;
function $975ba397feb1c334$var$_temp2(menuId_1) {
    return {
        menuId: menuId_1,
        visible: false
    };
}
function $975ba397feb1c334$var$_temp(menuId_0) {
    return {
        menuId: menuId_0,
        visible: false
    };
}
















var $bsSbN = parcelRequire("bsSbN");














var $iY6Oi = parcelRequire("iY6Oi");










const $f3f896e601a7d6ef$export$b4c5199e460b5544 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMoreMenuDragAndDrop() {
    const $ = (0, $bDgLe.c)(8);
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    let t0;
    bb0: {
        if (l1DragAndDropEnabled) {
            let t1;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = {
                    dropTarget: {
                        getData: $f3f896e601a7d6ef$var$_temp,
                        getOperations: $f3f896e601a7d6ef$var$_temp2,
                        canDrop: $f3f896e601a7d6ef$var$_temp3
                    }
                };
                $[0] = t1;
            } else t1 = $[0];
            t0 = t1;
            break bb0;
        }
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {};
            $[1] = t1;
        } else t1 = $[1];
        t0 = t1;
    }
    const memoisedHookProps = t0;
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef } = (0, $iY6Oi.useMenuItemDragAndDrop)(memoisedHookProps);
    const registry = (0, $pl8ng.useElementRegistry)();
    const registrationRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[2] !== registry) {
        t1 = (element)=>{
            if (!element) {
                registrationRef.current?.();
                registrationRef.current = null;
                return;
            }
            if (registrationRef.current) registrationRef.current();
            registrationRef.current = registry.registerMoreMenuItem(element);
        };
        $[2] = registry;
        $[3] = t1;
    } else t1 = $[3];
    const moreButtonRef = t1;
    let t2;
    if ($[4] !== dropIndicator || $[5] !== dropTargetRef || $[6] !== moreButtonRef) {
        t2 = {
            dropIndicator: dropIndicator,
            dropTargetRef: dropTargetRef,
            moreButtonRef: moreButtonRef
        };
        $[4] = dropIndicator;
        $[5] = dropTargetRef;
        $[6] = moreButtonRef;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : function useMoreMenuDragAndDrop() {
    const { l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const memoisedHookProps = (0, $cozmU.useMemo)(()=>{
        if (l1DragAndDropEnabled) return {
            dropTarget: {
                getData: ()=>(0, $6ZNK7.getMoreMenuData)(),
                getOperations: ()=>({
                        combine: 'available'
                    }),
                canDrop: ({ source: source })=>{
                    return (0, $6ZNK7.isL1ItemData)(source.data) && (0, $6ZNK7.isL1ItemDataInGroup)(source.data, [
                        (0, $gq8Du.L1_MENU_GROUPS).MENU,
                        (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
                    ]) && source.data.isHideable;
                }
            }
        };
        return {};
    }, [
        l1DragAndDropEnabled
    ]);
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef } = (0, $iY6Oi.useMenuItemDragAndDrop)(memoisedHookProps);
    const registry = (0, $pl8ng.useElementRegistry)();
    const registrationRef = (0, $cozmU.useRef)(null);
    const moreButtonRef = (0, $cozmU.useCallback)((element)=>{
        if (!element) {
            registrationRef.current?.();
            registrationRef.current = null;
            return;
        }
        // Unregister previous element if exists
        if (registrationRef.current) registrationRef.current();
        // Register the new element with the registry
        registrationRef.current = registry.registerMoreMenuItem(element);
    }, [
        registrationRef,
        registry
    ]);
    return {
        dropIndicator: dropIndicator,
        dropTargetRef: dropTargetRef,
        moreButtonRef: moreButtonRef
    };
};
function $f3f896e601a7d6ef$var$_temp3(t0) {
    const { source: source } = t0;
    return (0, $6ZNK7.isL1ItemData)(source.data) && (0, $6ZNK7.isL1ItemDataInGroup)(source.data, [
        (0, $gq8Du.L1_MENU_GROUPS).MENU,
        (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
    ]) && source.data.isHideable;
}
function $f3f896e601a7d6ef$var$_temp2() {
    return {
        combine: "available"
    };
}
function $f3f896e601a7d6ef$var$_temp() {
    return (0, $6ZNK7.getMoreMenuData)();
}





const $a86797caa148475c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    hideFromSidebar: {
        id: "navigation.global-side-navigation.more-menu.hide-from-sidebar.label",
        defaultMessage: "Hide from sidebar"
    }
});


const $c377a797267ede83$export$48ac5b0d18731d0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function HideFromSidebarButton() {
    const $ = (0, $bDgLe.c)(8);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef, moreButtonRef: moreButtonRef } = (0, $f3f896e601a7d6ef$export$b4c5199e460b5544)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
            label: ""
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== formatMessage) {
        t1 = formatMessage((0, $a86797caa148475c$export$defe85febe8b728c).hideFromSidebar);
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== dropIndicator || $[4] !== dropTargetRef || $[5] !== moreButtonRef || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
            elemBefore: t0,
            ref: moreButtonRef,
            dropIndicator: dropIndicator,
            visualContentRef: dropTargetRef
        }, t1);
        $[3] = dropIndicator;
        $[4] = dropTargetRef;
        $[5] = moreButtonRef;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : function HideFromSidebarButton() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef, moreButtonRef: moreButtonRef } = (0, $f3f896e601a7d6ef$export$b4c5199e460b5544)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
            label: ""
        }),
        ref: moreButtonRef,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef
    }, formatMessage((0, $a86797caa148475c$export$defe85febe8b728c).hideFromSidebar));
};















var $a79Sy = parcelRequire("a79Sy");








const $76d1ec95a322684d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    showInSidebar: {
        id: "navigation.global-side-navigation.more-menu.show-in-sidebar.label",
        defaultMessage: "Show in sidebar"
    }
});


const $dd83686d76a75e11$export$df0ec698b216b297 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ShowInSidebarButton() {
    const $ = (0, $bDgLe.c)(8);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef, moreButtonRef: moreButtonRef } = (0, $f3f896e601a7d6ef$export$b4c5199e460b5544)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
            label: ""
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== formatMessage) {
        t1 = formatMessage((0, $76d1ec95a322684d$export$defe85febe8b728c).showInSidebar);
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== dropIndicator || $[4] !== dropTargetRef || $[5] !== moreButtonRef || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
            elemBefore: t0,
            ref: moreButtonRef,
            dropIndicator: dropIndicator,
            visualContentRef: dropTargetRef
        }, t1);
        $[3] = dropIndicator;
        $[4] = dropTargetRef;
        $[5] = moreButtonRef;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : function ShowInSidebarButton() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { dropIndicator: dropIndicator, dropTargetRef: dropTargetRef, moreButtonRef: moreButtonRef } = (0, $f3f896e601a7d6ef$export$b4c5199e460b5544)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
            label: ""
        }),
        ref: moreButtonRef,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef
    }, formatMessage((0, $76d1ec95a322684d$export$defe85febe8b728c).showInSidebar));
};





const $6654253c3ab994c6$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    primaryNavigationSectionScreenReader: {
        id: "navigation.global-side-navigation.primary-navigation-section-screen-reader",
        defaultMessage: "Dragging {item} over primary navigation group"
    },
    shortcutsSectionScreenReader: {
        id: "navigation.global-side-navigation.shortcuts-section-screen-reader",
        defaultMessage: "Dragging {item} over shortcuts group"
    },
    hideFromSidebarSectionScreenReader: {
        id: "navigation.global-side-navigation.hide-from-sidebar-section-screen-reader",
        defaultMessage: "Dragging {item} over \"Hide from navigation\" drop area"
    },
    showInSidebarSectionScreenReader: {
        id: "navigation.global-side-navigation.show-in-sidebar-section-screen-reader",
        defaultMessage: "Dragging {item} over \"Show in navigation\" drop area"
    }
});
const $6654253c3ab994c6$export$b61be8d5923fc7ed = (0, $kSwu1.defineMessages)({
    header: {
        id: "navigation.global-side-navigation.main-nav-item.error.header",
        defaultMessage: "We couldn\u2019t load the item {menuId}"
    },
    description: {
        id: "navigation.global-side-navigation.main-nav-item.error.description",
        defaultMessage: "Refresh the page and try again"
    }
});
const $6654253c3ab994c6$export$65be7b412c56ab9b = (0, $kSwu1.defineMessages)({
    header: {
        id: "navigation.global-side-navigation.error.header.default",
        defaultMessage: "We couldn\u2019t load this content"
    },
    description: {
        id: "navigation.global-side-navigation.error.description.default",
        defaultMessage: "Refresh the page and try again"
    }
});


const $f347f4d0a73fded0$export$b540acb5f181a91e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PostMainItems(t0) {
    const $ = (0, $bDgLe.c)(58);
    const { postItemsElem: postItemsElem, postMainElem: postMainElem, draggingL1Group: t1, openShortcutsInSameTab: openShortcutsInSameTab, viewAllAppsConfig: viewAllAppsConfig, ShortcutsSlot: ShortcutsSlot } = t0;
    const draggingL1Group = t1 === undefined ? null : t1;
    const { appLabel: appLabel, disableMenuCustomization: disableMenuCustomization, intlMode: intlMode, l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { allItems: allItems, growthItemShortcuts: growthItemShortcuts, shortcuts: shortcuts } = (0, $296fb2d582379b95$export$68ff8f5dbbf3b8af)();
    const peekMenuId = (0, $e462797418f11995$export$5d097184c0f78e68)();
    const { hiddenItemMenuIds: hiddenItemMenuIds, hiddenShortcutMenuIds: hiddenShortcutMenuIds, visibleShortcutMenuIds: visibleShortcutMenuIds, hiddenMenuIds: hiddenMenuIds } = (0, $b7c49387c5e9ce27$export$f340ebbec0629d31)();
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    let t2;
    if ($[0] !== growthItemShortcuts || $[1] !== shortcuts || $[2] !== visibleShortcutMenuIds) {
        t2 = {
            shortcutsConfig: shortcuts,
            visibleShortcuts: visibleShortcutMenuIds,
            growthShortcutsConfig: growthItemShortcuts
        };
        $[0] = growthItemShortcuts;
        $[1] = shortcuts;
        $[2] = visibleShortcutMenuIds;
        $[3] = t2;
    } else t2 = $[3];
    const { shortcutsWithMenuId: shortcutsWithMenuId } = (0, $f9c7833f93cdb3f1$export$9ef62ebfdd487c3d)(t2);
    let t3;
    if ($[4] !== l1DragAndDropEnabled) {
        t3 = {
            dragAndDropEnabled: l1DragAndDropEnabled,
            isItemData: (0, $6ZNK7.isL1ItemData)
        };
        $[4] = l1DragAndDropEnabled;
        $[5] = t3;
    } else t3 = $[5];
    const { groupDropIndicatorRef: groupDropIndicatorRef, dragSource: dragSource } = (0, $27df85f702a0a220$export$e782a36b4f98f6f5)(t3);
    let t4;
    if ($[6] !== fireClickedSideNavItemEvent) {
        t4 = ()=>{
            fireClickedSideNavItemEvent((0, $a3266033c74afcf2$export$d1f148bb46faf037).more, "postMain");
        };
        $[6] = fireClickedSideNavItemEvent;
        $[7] = t4;
    } else t4 = $[7];
    const handleClickMoreMenuItem = t4;
    let t5;
    if ($[8] !== fireClickedSideNavItemEvent) {
        t5 = ()=>{
            fireClickedSideNavItemEvent((0, $a3266033c74afcf2$export$d1f148bb46faf037).customize, "postMain");
        };
        $[8] = fireClickedSideNavItemEvent;
        $[9] = t5;
    } else t5 = $[9];
    const handleClickCustomizeItem = t5;
    let t6;
    if ($[10] !== allItems || $[11] !== hiddenItemMenuIds || $[12] !== peekMenuId) {
        t6 = !!peekMenuId && hiddenItemMenuIds.includes(peekMenuId) && allItems[peekMenuId];
        $[10] = allItems;
        $[11] = hiddenItemMenuIds;
        $[12] = peekMenuId;
        $[13] = t6;
    } else t6 = $[13];
    const peekItem = t6;
    let t7;
    if ($[14] !== dragSource || $[15] !== hiddenMenuIds) {
        t7 = dragSource && hiddenMenuIds.includes(dragSource);
        $[14] = dragSource;
        $[15] = hiddenMenuIds;
        $[16] = t7;
    } else t7 = $[16];
    const isDragSourceHidden = t7;
    const canMenuItemBeHidden = !!(draggingL1Group && dragSource && allItems[dragSource]?.isHideable !== false);
    let t8;
    if ($[17] !== allItems || $[18] !== appLabel || $[19] !== handleClickCustomizeItem || $[20] !== handleClickMoreMenuItem || $[21] !== hiddenItemMenuIds || $[22] !== hiddenShortcutMenuIds || $[23] !== intlMode || $[24] !== openShortcutsInSameTab || $[25] !== shortcuts) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $975ba397feb1c334$export$2e2bcd8739ae039), {
            appLabel: appLabel,
            intlMode: intlMode,
            items: allItems,
            itemIds: hiddenItemMenuIds,
            onClickCustomizeSidebarMenuItem: handleClickCustomizeItem,
            onClickMoreMenuTrigger: handleClickMoreMenuItem,
            openShortcutsInSameTab: openShortcutsInSameTab,
            shortcutItemIds: hiddenShortcutMenuIds,
            shortcutItems: shortcuts
        });
        $[17] = allItems;
        $[18] = appLabel;
        $[19] = handleClickCustomizeItem;
        $[20] = handleClickMoreMenuItem;
        $[21] = hiddenItemMenuIds;
        $[22] = hiddenShortcutMenuIds;
        $[23] = intlMode;
        $[24] = openShortcutsInSameTab;
        $[25] = shortcuts;
        $[26] = t8;
    } else t8 = $[26];
    const moreMenu = t8;
    let t9;
    if ($[27] !== ShortcutsSlot || $[28] !== openShortcutsInSameTab || $[29] !== shortcutsWithMenuId || $[30] !== viewAllAppsConfig) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f347f4d0a73fded0$var$GlobalAppShortcuts, {
            shortcutItems: shortcutsWithMenuId,
            openShortcutsInSameTab: openShortcutsInSameTab,
            viewAllAppsConfig: viewAllAppsConfig,
            ShortcutsSlot: ShortcutsSlot
        });
        $[27] = ShortcutsSlot;
        $[28] = openShortcutsInSameTab;
        $[29] = shortcutsWithMenuId;
        $[30] = viewAllAppsConfig;
        $[31] = t9;
    } else t9 = $[31];
    const globalAppShortcuts = t9;
    let t10;
    if ($[32] !== dragSource || $[33] !== draggingL1Group || $[34] !== formatMessage || $[35] !== globalAppShortcuts || $[36] !== groupDropIndicatorRef || $[37] !== l1DragAndDropEnabled || $[38] !== shortcutsWithMenuId.length) {
        t10 = !!shortcutsWithMenuId.length && (l1DragAndDropEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c62cc7a3e277239c$export$bd7361bd33ae3eff), {
            ref: groupDropIndicatorRef,
            isActive: draggingL1Group === (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS,
            ariaLabel: formatMessage((0, $6654253c3ab994c6$export$defe85febe8b728c).shortcutsSectionScreenReader, {
                item: dragSource
            })
        }, globalAppShortcuts) : globalAppShortcuts);
        $[32] = dragSource;
        $[33] = draggingL1Group;
        $[34] = formatMessage;
        $[35] = globalAppShortcuts;
        $[36] = groupDropIndicatorRef;
        $[37] = l1DragAndDropEnabled;
        $[38] = shortcutsWithMenuId.length;
        $[39] = t10;
    } else t10 = $[39];
    let t11;
    if ($[40] !== peekItem || $[41] !== peekMenuId) {
        t11 = peekItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), {
            testId: (0, $2d74423a888dfe57$export$88dd4a9e4ffa4ec2)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbfe2ad3510eceba$export$2e2bcd8739ae039), {
            key: peekMenuId,
            id: peekMenuId,
            item: peekItem,
            isInMoreMenu: true,
            peek: true
        }));
        $[40] = peekItem;
        $[41] = peekMenuId;
        $[42] = t11;
    } else t11 = $[42];
    let t12;
    if ($[43] !== canMenuItemBeHidden || $[44] !== disableMenuCustomization || $[45] !== dragSource || $[46] !== formatMessage || $[47] !== groupDropIndicatorRef || $[48] !== isDragSourceHidden || $[49] !== l1DragAndDropEnabled || $[50] !== moreMenu) {
        t12 = !disableMenuCustomization && (l1DragAndDropEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c62cc7a3e277239c$export$bd7361bd33ae3eff), {
            ref: groupDropIndicatorRef,
            isActive: canMenuItemBeHidden,
            ariaLabel: isDragSourceHidden ? formatMessage((0, $6654253c3ab994c6$export$defe85febe8b728c).showInSidebarSectionScreenReader, {
                item: dragSource
            }) : formatMessage((0, $6654253c3ab994c6$export$defe85febe8b728c).hideFromSidebarSectionScreenReader, {
                item: dragSource
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: (0, $w6R6I.cx)(canMenuItemBeHidden ? $f347f4d0a73fded0$var$styles.hidden : $f347f4d0a73fded0$var$styles.visible)
        }, moreMenu), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: (0, $w6R6I.cx)(canMenuItemBeHidden ? $f347f4d0a73fded0$var$styles.visible : $f347f4d0a73fded0$var$styles.hidden)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, isDragSourceHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dd83686d76a75e11$export$df0ec698b216b297), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c377a797267ede83$export$48ac5b0d18731d0f), null)))) : moreMenu);
        $[43] = canMenuItemBeHidden;
        $[44] = disableMenuCustomization;
        $[45] = dragSource;
        $[46] = formatMessage;
        $[47] = groupDropIndicatorRef;
        $[48] = isDragSourceHidden;
        $[49] = l1DragAndDropEnabled;
        $[50] = moreMenu;
        $[51] = t12;
    } else t12 = $[51];
    let t13;
    if ($[52] !== postItemsElem || $[53] !== postMainElem || $[54] !== t10 || $[55] !== t11 || $[56] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.100"
        }, postItemsElem, t10, t11, t12, postMainElem);
        $[52] = postItemsElem;
        $[53] = postMainElem;
        $[54] = t10;
        $[55] = t11;
        $[56] = t12;
        $[57] = t13;
    } else t13 = $[57];
    return t13;
} : function PostMainItems({ postItemsElem: postItemsElem, postMainElem: postMainElem, draggingL1Group: draggingL1Group = null, openShortcutsInSameTab: openShortcutsInSameTab, viewAllAppsConfig: viewAllAppsConfig, ShortcutsSlot: ShortcutsSlot }) {
    const { appLabel: appLabel, disableMenuCustomization: disableMenuCustomization, intlMode: intlMode, l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { allItems: allItems, growthItemShortcuts: growthItemShortcuts, shortcuts: shortcuts } = (0, $296fb2d582379b95$export$68ff8f5dbbf3b8af)();
    const peekMenuId = (0, $e462797418f11995$export$5d097184c0f78e68)();
    const { hiddenItemMenuIds: hiddenItemMenuIds, hiddenShortcutMenuIds: hiddenShortcutMenuIds, visibleShortcutMenuIds: visibleShortcutMenuIds, hiddenMenuIds: hiddenMenuIds } = (0, $b7c49387c5e9ce27$export$f340ebbec0629d31)();
    const { fireClickedSideNavItemEvent: fireClickedSideNavItemEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    const { shortcutsWithMenuId: shortcutsWithMenuId } = (0, $f9c7833f93cdb3f1$export$9ef62ebfdd487c3d)({
        shortcutsConfig: shortcuts,
        visibleShortcuts: visibleShortcutMenuIds,
        growthShortcutsConfig: growthItemShortcuts
    });
    const { groupDropIndicatorRef: groupDropIndicatorRef, dragSource: dragSource } = (0, $27df85f702a0a220$export$e782a36b4f98f6f5)({
        dragAndDropEnabled: l1DragAndDropEnabled,
        isItemData: (0, $6ZNK7.isL1ItemData)
    });
    const handleClickMoreMenuItem = (0, $cozmU.useCallback)(()=>{
        fireClickedSideNavItemEvent((0, $a3266033c74afcf2$export$d1f148bb46faf037).more, 'postMain');
    }, [
        fireClickedSideNavItemEvent
    ]);
    const handleClickCustomizeItem = (0, $cozmU.useCallback)(()=>{
        fireClickedSideNavItemEvent((0, $a3266033c74afcf2$export$d1f148bb46faf037).customize, 'postMain');
    }, [
        fireClickedSideNavItemEvent
    ]);
    const peekItem = !!peekMenuId && hiddenItemMenuIds.includes(peekMenuId) && allItems[peekMenuId];
    const isDragSourceHidden = dragSource && hiddenMenuIds.includes(dragSource);
    const canMenuItemBeHidden = (0, $cozmU.useMemo)(()=>{
        return !!(draggingL1Group && dragSource && allItems[dragSource]?.isHideable !== false);
    }, [
        allItems,
        dragSource,
        draggingL1Group
    ]);
    const moreMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $975ba397feb1c334$export$2e2bcd8739ae039), {
        appLabel: appLabel,
        intlMode: intlMode,
        items: allItems,
        itemIds: hiddenItemMenuIds,
        onClickCustomizeSidebarMenuItem: handleClickCustomizeItem,
        onClickMoreMenuTrigger: handleClickMoreMenuItem,
        openShortcutsInSameTab: openShortcutsInSameTab,
        shortcutItemIds: hiddenShortcutMenuIds,
        shortcutItems: shortcuts
    });
    const globalAppShortcuts = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f347f4d0a73fded0$var$GlobalAppShortcuts, {
        shortcutItems: shortcutsWithMenuId,
        openShortcutsInSameTab: openShortcutsInSameTab,
        viewAllAppsConfig: viewAllAppsConfig,
        ShortcutsSlot: ShortcutsSlot
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.100"
    }, postItemsElem, !!shortcutsWithMenuId.length && (l1DragAndDropEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c62cc7a3e277239c$export$bd7361bd33ae3eff), {
        ref: groupDropIndicatorRef,
        isActive: draggingL1Group === (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS,
        ariaLabel: formatMessage((0, $6654253c3ab994c6$export$defe85febe8b728c).shortcutsSectionScreenReader, {
            item: dragSource
        })
    }, globalAppShortcuts) : globalAppShortcuts), peekItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), {
        testId: (0, $2d74423a888dfe57$export$88dd4a9e4ffa4ec2)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbfe2ad3510eceba$export$2e2bcd8739ae039), {
        key: peekMenuId,
        id: peekMenuId,
        item: peekItem,
        isInMoreMenu: true,
        peek: true
    })), !disableMenuCustomization && (l1DragAndDropEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c62cc7a3e277239c$export$bd7361bd33ae3eff), {
        ref: groupDropIndicatorRef,
        isActive: canMenuItemBeHidden,
        ariaLabel: isDragSourceHidden ? formatMessage((0, $6654253c3ab994c6$export$defe85febe8b728c).showInSidebarSectionScreenReader, {
            item: dragSource
        }) : formatMessage((0, $6654253c3ab994c6$export$defe85febe8b728c).hideFromSidebarSectionScreenReader, {
            item: dragSource
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: (0, $w6R6I.cx)(canMenuItemBeHidden ? $f347f4d0a73fded0$var$styles.hidden : $f347f4d0a73fded0$var$styles.visible)
    }, moreMenu), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: (0, $w6R6I.cx)(canMenuItemBeHidden ? $f347f4d0a73fded0$var$styles.visible : $f347f4d0a73fded0$var$styles.hidden)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, isDragSourceHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dd83686d76a75e11$export$df0ec698b216b297), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c377a797267ede83$export$48ac5b0d18731d0f), null)))) : moreMenu), postMainElem);
};
const $f347f4d0a73fded0$var$styles = {
    visible: "_1e0c1ule",
    hidden: "_1e0cglyw"
};
const $f347f4d0a73fded0$var$GlobalAppShortcuts = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalAppShortcuts(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { openShortcutsInSameTab: openShortcutsInSameTab, shortcutItems: shortcutItems, viewAllAppsConfig: viewAllAppsConfig, ShortcutsSlot: ShortcutsSlot } = t0;
    const { app: app, intlMode: intlMode, l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { fireViewedShortcutsEvent: fireViewedShortcutsEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    const containerRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== fireViewedShortcutsEvent || $[1] !== shortcutItems) {
        t1 = ()=>fireViewedShortcutsEvent(shortcutItems);
        $[0] = fireViewedShortcutsEvent;
        $[1] = shortcutItems;
        $[2] = t1;
    } else t1 = $[2];
    const fireAnalytics = t1;
    let t2;
    if ($[3] !== fireAnalytics) {
        t2 = {
            ref: containerRef,
            onInViewport: fireAnalytics
        };
        $[3] = fireAnalytics;
        $[4] = t2;
    } else t2 = $[4];
    (0, $3e97dfd5d57e4a85$export$6215040b989f9b0f)(t2);
    let t3;
    if ($[5] !== app || $[6] !== intlMode || $[7] !== l1DragAndDropEnabled || $[8] !== openShortcutsInSameTab || $[9] !== shortcutItems || $[10] !== viewAllAppsConfig) {
        t3 = function BoundGlobalShortcutsMenu(overrides) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $czzzJ.GlobalShortcutsMenu), {
                shortcutItems: shortcutItems,
                testId: (0, $2d74423a888dfe57$export$ee2a9579670b9420),
                ...overrides,
                enableDragAndDrop: l1DragAndDropEnabled,
                intlMode: intlMode,
                openInSameTab: openShortcutsInSameTab,
                product: app,
                viewAllAppsConfig: viewAllAppsConfig
            });
        };
        $[5] = app;
        $[6] = intlMode;
        $[7] = l1DragAndDropEnabled;
        $[8] = openShortcutsInSameTab;
        $[9] = shortcutItems;
        $[10] = viewAllAppsConfig;
        $[11] = t3;
    } else t3 = $[11];
    const ShortcutsMenuComponent = t3;
    let t4;
    if ($[12] !== ShortcutsMenuComponent || $[13] !== ShortcutsSlot || $[14] !== shortcutItems) {
        const shortcutsMenu = ShortcutsSlot && (0, $ixfCV.fg)("navx-5236-add-shortcuts-slot-prop") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ShortcutsSlot, {
            Component: ShortcutsMenuComponent,
            shortcutItems: shortcutItems
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ShortcutsMenuComponent, null);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            ref: containerRef
        }, shortcutsMenu);
        $[12] = ShortcutsMenuComponent;
        $[13] = ShortcutsSlot;
        $[14] = shortcutItems;
        $[15] = t4;
    } else t4 = $[15];
    return t4;
} : function GlobalAppShortcuts({ openShortcutsInSameTab: openShortcutsInSameTab, shortcutItems: shortcutItems, viewAllAppsConfig: viewAllAppsConfig, ShortcutsSlot: ShortcutsSlot }) {
    const { app: app, intlMode: intlMode, l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { fireViewedShortcutsEvent: fireViewedShortcutsEvent } = (0, $aa2301cc5f6e0eef$export$8d6902e2f27b22d5)();
    const containerRef = (0, $cozmU.useRef)(null);
    const fireAnalytics = (0, $cozmU.useCallback)(()=>fireViewedShortcutsEvent(shortcutItems), [
        fireViewedShortcutsEvent,
        shortcutItems
    ]);
    (0, $3e97dfd5d57e4a85$export$6215040b989f9b0f)({
        ref: containerRef,
        onInViewport: fireAnalytics
    }); // A pre-bound shortcuts menu handed to the `ShortcutsSlot` render prop. The
    // host renders this wherever it wants; any props it passes override the
    // GSN-internal defaults. Memoised to keep a stable component identity so the
    // slot subtree is not remounted on every render (see the drag-and-drop
    // rationale in the sibling comment in `PostMainItems`).
    const ShortcutsMenuComponent = (0, $cozmU.useCallback)(function BoundGlobalShortcutsMenu(overrides) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $czzzJ.GlobalShortcutsMenu), {
            shortcutItems: shortcutItems,
            testId: (0, $2d74423a888dfe57$export$ee2a9579670b9420),
            ...overrides,
            enableDragAndDrop: l1DragAndDropEnabled,
            intlMode: intlMode,
            openInSameTab: openShortcutsInSameTab,
            product: app,
            viewAllAppsConfig: viewAllAppsConfig
        });
    }, [
        app,
        intlMode,
        l1DragAndDropEnabled,
        openShortcutsInSameTab,
        shortcutItems,
        viewAllAppsConfig
    ]); // Inline the gate (rather than calling `componentWithFG` inside the render
    // body) so the rendered tree's component identity is stable across
    // renders. See sibling comment in `PostMainItems` for the rationale.
    // Remove the gate branch entirely when cleaning up
    // navx-4866-migrate-messages-from-nav-error-boundary.
    const shortcutsMenu = ShortcutsSlot && (0, $ixfCV.fg)('navx-5236-add-shortcuts-slot-prop') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ShortcutsSlot, {
        Component: ShortcutsMenuComponent,
        shortcutItems: shortcutItems
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ShortcutsMenuComponent, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        ref: containerRef
    }, shortcutsMenu);
};



const $35b49ed676d1ee97$export$1a35787d6353cf6a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SideNav(props) {
    const $ = (0, $bDgLe.c)(71);
    const { postItemsElem: postItemsElem, postMainElem: postMainElem, openShortcutsInSameTab: openShortcutsInSameTab, viewAllAppsConfig: viewAllAppsConfig, ShortcutsSlot: ShortcutsSlot, experimental_onShortcutsMenuSettled: experimental_onShortcutsMenuSettled, onPeekEnd: onPeekEnd, onPeekStart: onPeekStart, onLeftNavCollapse: onLeftNavCollapse, onLeftNavExpand: onLeftNavExpand, onResizeEnd: onResizeEnd, onResizeStart: onResizeStart, sideNavContentRef: sideNavContentRef } = props;
    const { app: app, l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { allItems: allItems, shortcuts: shortcuts } = (0, $296fb2d582379b95$export$68ff8f5dbbf3b8af)();
    const userMenuDataShapes = (0, $b7c49387c5e9ce27$export$f340ebbec0629d31)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [elementRegistry] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState((0, $pl8ng.createElementRegistry));
    const { dragAndDropSave: dragAndDropSave } = (0, $706c0a2842c08c35$export$440b6dd66925f04d)(userMenuDataShapes, elementRegistry);
    const [draggingL1Group, setDraggingL1Group] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null);
    let t0;
    let t1;
    if ($[0] !== experimental_onShortcutsMenuSettled || $[1] !== shortcuts || $[2] !== userMenuDataShapes.visibleMenuIds) {
        t0 = ()=>{
            if (!experimental_onShortcutsMenuSettled) return;
            experimental_onShortcutsMenuSettled({
                shortcuts: shortcuts ?? {},
                visibleMenuIds: userMenuDataShapes.visibleMenuIds
            });
        };
        t1 = [
            shortcuts,
            userMenuDataShapes.visibleMenuIds,
            experimental_onShortcutsMenuSettled
        ];
        $[0] = experimental_onShortcutsMenuSettled;
        $[1] = shortcuts;
        $[2] = userMenuDataShapes.visibleMenuIds;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    let t2;
    if ($[5] !== dragAndDropSave || $[6] !== l1DragAndDropEnabled || $[7] !== userMenuDataShapes.hiddenMenuIds) {
        t2 = {
            l1DragAndDropEnabled: l1DragAndDropEnabled,
            dragAndDropSave: dragAndDropSave,
            setDraggingL1Group: setDraggingL1Group,
            hiddenMenuIds: userMenuDataShapes.hiddenMenuIds
        };
        $[5] = dragAndDropSave;
        $[6] = l1DragAndDropEnabled;
        $[7] = userMenuDataShapes.hiddenMenuIds;
        $[8] = t2;
    } else t2 = $[8];
    (0, $0ebfb3ac63800ecb$export$9e5b5542ce283d4c)(t2);
    let t3;
    if ($[9] !== l1DragAndDropEnabled) {
        t3 = {
            dragAndDropEnabled: l1DragAndDropEnabled,
            isItemData: (0, $6ZNK7.isL1ItemData)
        };
        $[9] = l1DragAndDropEnabled;
        $[10] = t3;
    } else t3 = $[10];
    const { groupDropIndicatorRef: groupDropIndicatorRef, dragSource: dragSource } = (0, $27df85f702a0a220$export$e782a36b4f98f6f5)(t3);
    let t4;
    if ($[11] !== allItems || $[12] !== app || $[13] !== userMenuDataShapes.visibleItemMenuIds) {
        let t5;
        if ($[15] !== allItems || $[16] !== app) {
            t5 = (id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
                    key: id,
                    errorMessages: (0, $6654253c3ab994c6$export$b61be8d5923fc7ed),
                    errorMessageValues: {
                        menuId: id
                    },
                    sentryConfig: {
                        product: app
                    },
                    showFlags: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbfe2ad3510eceba$export$2e2bcd8739ae039), {
                    key: id,
                    id: id,
                    item: allItems[id]
                }));
            $[15] = allItems;
            $[16] = app;
            $[17] = t5;
        } else t5 = $[17];
        t4 = userMenuDataShapes.visibleItemMenuIds.map(t5);
        $[11] = allItems;
        $[12] = app;
        $[13] = userMenuDataShapes.visibleItemMenuIds;
        $[14] = t4;
    } else t4 = $[14];
    const mainNavItems = t4;
    let t5;
    if ($[18] !== app || $[19] !== props.topElem) {
        t5 = props.topElem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $6654253c3ab994c6$export$65be7b412c56ab9b),
            sentryConfig: {
                product: app
            },
            showFlags: true
        }, props.topElem) : null;
        $[18] = app;
        $[19] = props.topElem;
        $[20] = t5;
    } else t5 = $[20];
    const topElem = t5;
    let t6;
    if ($[21] !== app || $[22] !== props.bottomElem) {
        t6 = props.bottomElem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $6654253c3ab994c6$export$65be7b412c56ab9b),
            sentryConfig: {
                product: app
            },
            showFlags: true
        }, props.bottomElem) : null;
        $[21] = app;
        $[22] = props.bottomElem;
        $[23] = t6;
    } else t6 = $[23];
    const bottomElem = t6;
    let t7;
    if ($[24] !== app || $[25] !== props.preMainElem) {
        t7 = props.preMainElem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $6654253c3ab994c6$export$65be7b412c56ab9b),
            sentryConfig: {
                product: app
            },
            showFlags: true
        }, props.preMainElem) : null;
        $[24] = app;
        $[25] = props.preMainElem;
        $[26] = t7;
    } else t7 = $[26];
    const preMainElem = t7;
    let t8;
    if ($[27] !== app) {
        t8 = {
            product: app
        };
        $[27] = app;
        $[28] = t8;
    } else t8 = $[28];
    let t9;
    if ($[29] !== ShortcutsSlot || $[30] !== draggingL1Group || $[31] !== openShortcutsInSameTab || $[32] !== postItemsElem || $[33] !== postMainElem || $[34] !== viewAllAppsConfig) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f347f4d0a73fded0$export$b540acb5f181a91e), {
            postItemsElem: postItemsElem,
            postMainElem: postMainElem,
            draggingL1Group: draggingL1Group,
            openShortcutsInSameTab: openShortcutsInSameTab,
            viewAllAppsConfig: viewAllAppsConfig,
            ShortcutsSlot: ShortcutsSlot
        });
        $[29] = ShortcutsSlot;
        $[30] = draggingL1Group;
        $[31] = openShortcutsInSameTab;
        $[32] = postItemsElem;
        $[33] = postMainElem;
        $[34] = viewAllAppsConfig;
        $[35] = t9;
    } else t9 = $[35];
    let t10;
    if ($[36] !== t8 || $[37] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $6654253c3ab994c6$export$65be7b412c56ab9b),
            sentryConfig: t8,
            showFlags: true
        }, t9);
        $[36] = t8;
        $[37] = t9;
        $[38] = t10;
    } else t10 = $[38];
    const memoizedPostMainElem = t10;
    let t11;
    if ($[39] !== ShortcutsSlot || $[40] !== app || $[41] !== draggingL1Group || $[42] !== memoizedPostMainElem || $[43] !== openShortcutsInSameTab || $[44] !== postItemsElem || $[45] !== postMainElem || $[46] !== viewAllAppsConfig) {
        t11 = (0, $ixfCV.fg)("navx-4728-jira-stability-fixes") ? memoizedPostMainElem : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $6654253c3ab994c6$export$65be7b412c56ab9b),
            sentryConfig: {
                product: app
            },
            showFlags: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f347f4d0a73fded0$export$b540acb5f181a91e), {
            postItemsElem: postItemsElem,
            postMainElem: postMainElem,
            draggingL1Group: draggingL1Group,
            openShortcutsInSameTab: openShortcutsInSameTab,
            viewAllAppsConfig: viewAllAppsConfig,
            ShortcutsSlot: ShortcutsSlot
        }));
        $[39] = ShortcutsSlot;
        $[40] = app;
        $[41] = draggingL1Group;
        $[42] = memoizedPostMainElem;
        $[43] = openShortcutsInSameTab;
        $[44] = postItemsElem;
        $[45] = postMainElem;
        $[46] = viewAllAppsConfig;
        $[47] = t11;
    } else t11 = $[47];
    const postMainElemForLayout = t11;
    const t12 = props.testId ?? (0, $2d74423a888dfe57$export$5678faf50a8e9276);
    let t13;
    if ($[48] !== dragSource || $[49] !== draggingL1Group || $[50] !== formatMessage || $[51] !== groupDropIndicatorRef || $[52] !== mainNavItems || $[53] !== preMainElem) {
        t13 = mainNavItems?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, preMainElem, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c62cc7a3e277239c$export$bd7361bd33ae3eff), {
            ref: groupDropIndicatorRef,
            isActive: draggingL1Group === (0, $gq8Du.L1_MENU_GROUPS).MENU,
            ariaLabel: formatMessage((0, $6654253c3ab994c6$export$defe85febe8b728c).primaryNavigationSectionScreenReader, {
                item: dragSource
            })
        }, mainNavItems)) : null;
        $[48] = dragSource;
        $[49] = draggingL1Group;
        $[50] = formatMessage;
        $[51] = groupDropIndicatorRef;
        $[52] = mainNavItems;
        $[53] = preMainElem;
        $[54] = t13;
    } else t13 = $[54];
    let t14;
    if ($[55] !== bottomElem || $[56] !== onLeftNavCollapse || $[57] !== onLeftNavExpand || $[58] !== onPeekEnd || $[59] !== onPeekStart || $[60] !== onResizeEnd || $[61] !== onResizeStart || $[62] !== postMainElemForLayout || $[63] !== sideNavContentRef || $[64] !== t12 || $[65] !== t13 || $[66] !== topElem) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $52d918d1c2e11cae$export$5c53281b43e13144), {
            testId: t12,
            preMainElem: topElem,
            onCollapse: onLeftNavCollapse,
            onExpand: onLeftNavExpand,
            onPeekEnd: onPeekEnd,
            onPeekStart: onPeekStart,
            onResizeEnd: onResizeEnd,
            onResizeStart: onResizeStart,
            sideNavContentRef: sideNavContentRef,
            postMainElem: postMainElemForLayout,
            bottomElem: bottomElem
        }, t13);
        $[55] = bottomElem;
        $[56] = onLeftNavCollapse;
        $[57] = onLeftNavExpand;
        $[58] = onPeekEnd;
        $[59] = onPeekStart;
        $[60] = onResizeEnd;
        $[61] = onResizeStart;
        $[62] = postMainElemForLayout;
        $[63] = sideNavContentRef;
        $[64] = t12;
        $[65] = t13;
        $[66] = topElem;
        $[67] = t14;
    } else t14 = $[67];
    let t15;
    if ($[68] !== elementRegistry || $[69] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $pl8ng.ElementRegistryProvider), {
            registry: elementRegistry
        }, t14);
        $[68] = elementRegistry;
        $[69] = t14;
        $[70] = t15;
    } else t15 = $[70];
    return t15;
} : function SideNav(props) {
    const { postItemsElem: postItemsElem, postMainElem: postMainElem, openShortcutsInSameTab: openShortcutsInSameTab, viewAllAppsConfig: viewAllAppsConfig, ShortcutsSlot: ShortcutsSlot, experimental_onShortcutsMenuSettled: experimental_onShortcutsMenuSettled, onPeekEnd: onPeekEnd, onPeekStart: onPeekStart, onLeftNavCollapse: onLeftNavCollapse, onLeftNavExpand: onLeftNavExpand, onResizeEnd: onResizeEnd, onResizeStart: onResizeStart, sideNavContentRef: sideNavContentRef } = props;
    const { app: app, l1DragAndDropEnabled: l1DragAndDropEnabled } = (0, $e121db91b5381e5a$export$b8ae39f344200a7d)();
    const { allItems: allItems, shortcuts: shortcuts } = (0, $296fb2d582379b95$export$68ff8f5dbbf3b8af)();
    const userMenuDataShapes = (0, $b7c49387c5e9ce27$export$f340ebbec0629d31)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // #region Drag and drop
    // Element registry for L1 items
    const [elementRegistry] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState((0, $pl8ng.createElementRegistry));
    const { dragAndDropSave: dragAndDropSave } = (0, $706c0a2842c08c35$export$440b6dd66925f04d)(userMenuDataShapes, elementRegistry);
    const [draggingL1Group, setDraggingL1Group] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!experimental_onShortcutsMenuSettled) return;
        experimental_onShortcutsMenuSettled({
            shortcuts: shortcuts ?? {},
            visibleMenuIds: userMenuDataShapes.visibleMenuIds
        });
    }, [
        shortcuts,
        userMenuDataShapes.visibleMenuIds,
        experimental_onShortcutsMenuSettled
    ]);
    (0, $0ebfb3ac63800ecb$export$9e5b5542ce283d4c)({
        l1DragAndDropEnabled: l1DragAndDropEnabled,
        dragAndDropSave: dragAndDropSave,
        setDraggingL1Group: setDraggingL1Group,
        hiddenMenuIds: userMenuDataShapes.hiddenMenuIds
    });
    const { groupDropIndicatorRef: groupDropIndicatorRef, dragSource: dragSource } = (0, $27df85f702a0a220$export$e782a36b4f98f6f5)({
        dragAndDropEnabled: l1DragAndDropEnabled,
        isItemData: (0, $6ZNK7.isL1ItemData)
    });
    // #endregion
    // #region Core rendering
    const mainNavItems = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>userMenuDataShapes.visibleItemMenuIds.map((id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
                key: id,
                errorMessages: (0, $6654253c3ab994c6$export$b61be8d5923fc7ed),
                errorMessageValues: {
                    menuId: id
                },
                sentryConfig: {
                    product: app
                },
                showFlags: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbfe2ad3510eceba$export$2e2bcd8739ae039), {
                key: id,
                id: id,
                item: allItems[id]
            }))), [
        userMenuDataShapes.visibleItemMenuIds,
        app,
        allItems
    ]);
    const topElem = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>props.topElem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $6654253c3ab994c6$export$65be7b412c56ab9b),
            sentryConfig: {
                product: app
            },
            showFlags: true
        }, props.topElem) : null, [
        app,
        props.topElem
    ]);
    const bottomElem = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>props.bottomElem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $6654253c3ab994c6$export$65be7b412c56ab9b),
            sentryConfig: {
                product: app
            },
            showFlags: true
        }, props.bottomElem) : null, [
        app,
        props.bottomElem
    ]);
    const preMainElem = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>props.preMainElem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $6654253c3ab994c6$export$65be7b412c56ab9b),
            sentryConfig: {
                product: app
            },
            showFlags: true
        }, props.preMainElem) : null, [
        app,
        props.preMainElem
    ]);
    // The post-main element passed to GSNSideNavigationLayout. Like topElem /
    // preMainElem / bottomElem above, this is memoised so a justified SideNav
    // re-render does not hand the layout a fresh element identity every time
    // (which cascades a wasted re-render down the navigation tree — observed in
    // Chippy as `postMainElem: ref-changed` with identical content).
    //
    // Gated behind `navx-4728-jira-stability-fixes`: gate ON returns the
    // memoised element; gate OFF falls back to the inline JSX, preserving
    // current behaviour byte-for-byte.
    const memoizedPostMainElem = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $6654253c3ab994c6$export$65be7b412c56ab9b),
            sentryConfig: {
                product: app
            },
            showFlags: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f347f4d0a73fded0$export$b540acb5f181a91e), {
            postItemsElem: postItemsElem,
            postMainElem: postMainElem,
            draggingL1Group: draggingL1Group,
            openShortcutsInSameTab: openShortcutsInSameTab,
            viewAllAppsConfig: viewAllAppsConfig,
            ShortcutsSlot: ShortcutsSlot
        })), [
        app,
        postItemsElem,
        postMainElem,
        draggingL1Group,
        openShortcutsInSameTab,
        viewAllAppsConfig,
        ShortcutsSlot
    ]);
    const postMainElemForLayout = (0, $ixfCV.fg)('navx-4728-jira-stability-fixes') ? memoizedPostMainElem : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
        errorMessages: (0, $6654253c3ab994c6$export$65be7b412c56ab9b),
        sentryConfig: {
            product: app
        },
        showFlags: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f347f4d0a73fded0$export$b540acb5f181a91e), {
        postItemsElem: postItemsElem,
        postMainElem: postMainElem,
        draggingL1Group: draggingL1Group,
        openShortcutsInSameTab: openShortcutsInSameTab,
        viewAllAppsConfig: viewAllAppsConfig,
        ShortcutsSlot: ShortcutsSlot
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $pl8ng.ElementRegistryProvider), {
        registry: elementRegistry
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $52d918d1c2e11cae$export$5c53281b43e13144), {
        testId: props.testId ?? (0, $2d74423a888dfe57$export$5678faf50a8e9276),
        preMainElem: topElem,
        onCollapse: onLeftNavCollapse,
        onExpand: onLeftNavExpand,
        onPeekEnd: onPeekEnd,
        onPeekStart: onPeekStart,
        onResizeEnd: onResizeEnd,
        onResizeStart: onResizeStart,
        sideNavContentRef: sideNavContentRef,
        postMainElem: postMainElemForLayout,
        bottomElem: bottomElem
    }, mainNavItems?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, preMainElem, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c62cc7a3e277239c$export$bd7361bd33ae3eff), {
        ref: groupDropIndicatorRef,
        isActive: draggingL1Group === (0, $gq8Du.L1_MENU_GROUPS).MENU,
        ariaLabel: formatMessage((0, $6654253c3ab994c6$export$defe85febe8b728c).primaryNavigationSectionScreenReader, {
            item: dragSource
        })
    }, mainNavItems)) : null));
// #endregion
};


// `RawGlobalSideNavigation` is not memoised by default, so when its parent
// (e.g. Jira's `GSNForContentSidebarInner`) legitimately re-renders — for
// example as preloaded Relay data settles on load — the entire side-nav
// subtree re-renders even though none of its props changed identity. The
// props crossing this boundary are already referentially stable (the callers
// memoise `items`, `shortcuts`, `forYou`, `networkStorageParams`, etc.), so a
// memo boundary here lets the justified parent re-render happen without
// cascading a wasted re-render down the whole navigation tree.
//
// Gated behind `navx-4728-jira-stability-fixes`: gate ON wraps the component in
// `React.memo`, which performs a shallow (referential) comparison of all props
// and bails out when they are all equal; gate OFF renders the plain
// (unmemoised) component, preserving current behaviour. The default `React.memo`
// shallow comparator is exactly what we want here (the callers already memoise
// `items`, `shortcuts`, `forYou`, `networkStorageParams`, etc.), so no custom
// comparator is needed.
const $a781193dda05864e$var$MemoizedRawGlobalSideNavigation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($a781193dda05864e$var$RawGlobalSideNavigation);
const $a781193dda05864e$var$GatedGlobalSideNavigation = (0, $rECdA.componentWithFG)('navx-4728-jira-stability-fixes', $a781193dda05864e$var$MemoizedRawGlobalSideNavigation, $a781193dda05864e$var$RawGlobalSideNavigation);
const $a781193dda05864e$export$e3822b656235cd34 = (0, $fa495778d00d6098$export$6d30b5ca07993d23)($a781193dda05864e$var$GatedGlobalSideNavigation);
var $a781193dda05864e$export$2e2bcd8739ae039 // This is only needed to support the Atlaskit docs. See https://hello.atlassian.net/wiki/spaces/navx/pages/5305993008/Platform+Guide#Atlaskit-%3CProps%3E-component-not-rendering
 = $a781193dda05864e$var$RawGlobalSideNavigation;
const $a781193dda05864e$var$isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $a781193dda05864e$var$RawGlobalSideNavigation_optimized(props) {
    const $ = (0, $bDgLe.c)(57);
    let app;
    let appLabel;
    let cloudId;
    let defaultMenuVisibility;
    let forYou;
    let growthItemShortcuts;
    let innerProps;
    let isShortcutsStatic;
    let items;
    let networkStorageParams;
    let peekMenuId;
    let shortcuts;
    let t0;
    let t1;
    let t2;
    let t3;
    let userId;
    if ($[0] !== props) {
        ({ app: app, appLabel: appLabel, cloudId: cloudId, customizationStore: t0, defaultMenuVisibility: defaultMenuVisibility, disableMenuCustomization: t1, forYou: forYou, growthItemShortcuts: growthItemShortcuts, intlMode: t2, isAnonymous: t3, isShortcutsStatic: isShortcutsStatic, items: items, networkStorageParams: networkStorageParams, peekMenuId: peekMenuId, shortcuts: shortcuts, userId: userId, ...innerProps } = props);
        $[0] = props;
        $[1] = app;
        $[2] = appLabel;
        $[3] = cloudId;
        $[4] = defaultMenuVisibility;
        $[5] = forYou;
        $[6] = growthItemShortcuts;
        $[7] = innerProps;
        $[8] = isShortcutsStatic;
        $[9] = items;
        $[10] = networkStorageParams;
        $[11] = peekMenuId;
        $[12] = shortcuts;
        $[13] = t0;
        $[14] = t1;
        $[15] = t2;
        $[16] = t3;
        $[17] = userId;
    } else {
        app = $[1];
        appLabel = $[2];
        cloudId = $[3];
        defaultMenuVisibility = $[4];
        forYou = $[5];
        growthItemShortcuts = $[6];
        innerProps = $[7];
        isShortcutsStatic = $[8];
        items = $[9];
        networkStorageParams = $[10];
        peekMenuId = $[11];
        shortcuts = $[12];
        t0 = $[13];
        t1 = $[14];
        t2 = $[15];
        t3 = $[16];
        userId = $[17];
    }
    const customizationStore = t0 === undefined ? "local" : t0;
    const disableMenuCustomization = t1 === undefined ? false : t1;
    const intlMode = t2 === undefined ? "async" : t2;
    const isAnonymous = t3 === undefined ? false : t3;
    const IntlWrapper = intlMode === "inherit" ? (0, $cozmU.Fragment) : (0, $1aad1f3f43cac6ae$export$2f688dfcc031530a);
    const effectiveDisableMenuCustomization = disableMenuCustomization || isAnonymous;
    const effectiveCustomizationStore = isAnonymous ? "local" : customizationStore;
    let t4;
    bb0: switch(effectiveCustomizationStore){
        case "local":
            t4 = (0, $e033176a4aad0701$export$9adaf932dcd02b00);
            break bb0;
        case "network-migration":
            t4 = (0, $cb000ff6e07567c3$export$c723d37fdda6e941);
            break bb0;
        default:
            t4 = (0, $a498df91df862359$export$711a2621397f25fc);
    }
    const Store = t4;
    let t5;
    if ($[18] !== app) {
        t5 = {
            product: app
        };
        $[18] = app;
        $[19] = t5;
    } else t5 = $[19];
    const t6 = !!innerProps?.bottomElem;
    const t7 = isShortcutsStatic || isAnonymous;
    const t8 = !effectiveDisableMenuCustomization;
    let t9;
    if ($[20] !== forYou || $[21] !== isAnonymous) {
        t9 = isAnonymous ? {} : forYou;
        $[20] = forYou;
        $[21] = isAnonymous;
        $[22] = t9;
    } else t9 = $[22];
    const t10 = isAnonymous && props.anonymousItems ? props.anonymousItems : items;
    let t11;
    if ($[23] !== innerProps) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35b49ed676d1ee97$export$1a35787d6353cf6a), innerProps);
        $[23] = innerProps;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== Store || $[26] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Store, null, t11);
        $[25] = Store;
        $[26] = t11;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== peekMenuId || $[29] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e462797418f11995$export$781f6b5709acd16f), {
            value: peekMenuId
        }, t12);
        $[28] = peekMenuId;
        $[29] = t12;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== growthItemShortcuts || $[32] !== shortcuts || $[33] !== t10 || $[34] !== t13 || $[35] !== t9) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $296fb2d582379b95$export$47df1b932a29bc63), {
            forYou: t9,
            growthItemShortcuts: growthItemShortcuts,
            items: t10,
            rawShortcuts: shortcuts
        }, t13);
        $[31] = growthItemShortcuts;
        $[32] = shortcuts;
        $[33] = t10;
        $[34] = t13;
        $[35] = t9;
        $[36] = t14;
    } else t14 = $[36];
    let t15;
    if ($[37] !== app || $[38] !== appLabel || $[39] !== cloudId || $[40] !== defaultMenuVisibility || $[41] !== effectiveCustomizationStore || $[42] !== effectiveDisableMenuCustomization || $[43] !== intlMode || $[44] !== networkStorageParams || $[45] !== t14 || $[46] !== t6 || $[47] !== t7 || $[48] !== t8 || $[49] !== userId) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iBJls.BFFProvider), {
            consumer: (0, $3ePvn.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e121db91b5381e5a$export$1238f6fc6d9e005a), {
            app: app,
            appLabel: appLabel,
            cloudId: cloudId,
            customizationStore: effectiveCustomizationStore,
            defaultMenuVisibility: defaultMenuVisibility,
            disableMenuCustomization: effectiveDisableMenuCustomization,
            hasBottomElement: t6,
            intlMode: intlMode,
            isShortcutsStatic: t7,
            l1DragAndDropEnabled: t8,
            networkStorageParams: networkStorageParams,
            userId: userId
        }, t14));
        $[37] = app;
        $[38] = appLabel;
        $[39] = cloudId;
        $[40] = defaultMenuVisibility;
        $[41] = effectiveCustomizationStore;
        $[42] = effectiveDisableMenuCustomization;
        $[43] = intlMode;
        $[44] = networkStorageParams;
        $[45] = t14;
        $[46] = t6;
        $[47] = t7;
        $[48] = t8;
        $[49] = userId;
        $[50] = t15;
    } else t15 = $[50];
    let t16;
    if ($[51] !== t15 || $[52] !== t5) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33LwY.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorFallbackUI: $a781193dda05864e$var$_temp,
            errorMessages: (0, $cab7c374856f434c$export$defe85febe8b728c),
            location: "global-side-navigation",
            sentryConfig: t5,
            ufoInteractionName: (0, $2d74423a888dfe57$export$74a97a85614272ea)
        }, t15));
        $[51] = t15;
        $[52] = t5;
        $[53] = t16;
    } else t16 = $[53];
    let t17;
    if ($[54] !== IntlWrapper || $[55] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: (0, $2d74423a888dfe57$export$74a97a85614272ea)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IntlWrapper, null, t16));
        $[54] = IntlWrapper;
        $[55] = t16;
        $[56] = t17;
    } else t17 = $[56];
    return t17;
}
function $a781193dda05864e$var$RawGlobalSideNavigation_unoptimized(props) {
    const { app: app, appLabel: appLabel, cloudId: cloudId, customizationStore: customizationStore = 'local', defaultMenuVisibility: defaultMenuVisibility, disableMenuCustomization: disableMenuCustomization = false, forYou: forYou, growthItemShortcuts: growthItemShortcuts, intlMode: intlMode = 'async', isAnonymous: isAnonymous = false, isShortcutsStatic: isShortcutsStatic, items: items, networkStorageParams: networkStorageParams, peekMenuId: peekMenuId, shortcuts: shortcuts, userId: userId, ...innerProps } = props;
    const IntlWrapper = intlMode === 'inherit' ? (0, $cozmU.Fragment) : (0, $1aad1f3f43cac6ae$export$2f688dfcc031530a);
    // If user is anon, disable menu customization and use local store
    const effectiveDisableMenuCustomization = disableMenuCustomization || isAnonymous;
    const effectiveCustomizationStore = isAnonymous ? 'local' : customizationStore;
    const Store = (0, $cozmU.useMemo)(()=>{
        switch(effectiveCustomizationStore){
            case 'local':
                return 0, $e033176a4aad0701$export$9adaf932dcd02b00;
            case 'network-migration':
                return 0, $cb000ff6e07567c3$export$c723d37fdda6e941;
            default:
                return 0, $a498df91df862359$export$711a2621397f25fc;
        }
    }, [
        effectiveCustomizationStore
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: (0, $2d74423a888dfe57$export$74a97a85614272ea)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IntlWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33LwY.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
        errorFallbackUI: ({ header: header, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $409e78b28aeb95f3$export$610d5f09b69fac71), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuuxi.NavEmptyState), {
                header: header,
                description: description
            })),
        errorMessages: (0, $cab7c374856f434c$export$defe85febe8b728c),
        // `location` is no longer used for error-message lookup; it is retained
        // purely to tag the nav-boundary context for Sentry/analytics so errors
        // caught at the top of the side nav remain attributable to this surface.
        location: "global-side-navigation",
        sentryConfig: {
            product: app
        },
        ufoInteractionName: (0, $2d74423a888dfe57$export$74a97a85614272ea)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iBJls.BFFProvider), {
        consumer: (0, $3ePvn.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e121db91b5381e5a$export$1238f6fc6d9e005a), {
        app: app,
        appLabel: appLabel,
        cloudId: cloudId,
        customizationStore: effectiveCustomizationStore,
        defaultMenuVisibility: defaultMenuVisibility,
        disableMenuCustomization: effectiveDisableMenuCustomization,
        hasBottomElement: !!innerProps?.bottomElem,
        intlMode: intlMode,
        isShortcutsStatic: isShortcutsStatic || isAnonymous,
        l1DragAndDropEnabled: !effectiveDisableMenuCustomization,
        networkStorageParams: networkStorageParams,
        userId: userId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $296fb2d582379b95$export$47df1b932a29bc63), {
        forYou: isAnonymous ? {} : forYou,
        growthItemShortcuts: growthItemShortcuts,
        items: isAnonymous && props.anonymousItems ? props.anonymousItems : items,
        rawShortcuts: shortcuts
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e462797418f11995$export$781f6b5709acd16f), {
        value: peekMenuId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Store, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35b49ed676d1ee97$export$1a35787d6353cf6a), innerProps))))))))));
}
function $a781193dda05864e$var$RawGlobalSideNavigation(arg0) {
    if ($a781193dda05864e$var$isReactCompilerActivePlatform_result) return $a781193dda05864e$var$RawGlobalSideNavigation_optimized(arg0);
    else return $a781193dda05864e$var$RawGlobalSideNavigation_unoptimized(arg0);
}
function $a781193dda05864e$var$_temp(t0) {
    const { header: header, description: description } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $409e78b28aeb95f3$export$610d5f09b69fac71), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuuxi.NavEmptyState), {
        header: header,
        description: description
    }));
}
module.exports["GlobalSideNavigation"] = $a781193dda05864e$export$e3822b656235cd34;

});

parcelRegister("8z22l", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");

const $3e353c2b3e999bb0$export$8209b3c2d1620841 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { handler: handler, children: children } = t0;
    const wrapperRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== handler) {
        t1 = ()=>{
            if (!wrapperRef.current || !handler) return;
            const handleMouseDown = (e)=>{
                const isLink = e.target.closest("a");
                if (isLink && e.button !== 0) handler(true);
            };
            const unbind = (0, $cbY7C.bind)(wrapperRef.current, {
                type: "mousedown",
                listener: handleMouseDown
            });
            return unbind;
        };
        t2 = [
            handler
        ];
        $[0] = handler;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ref: wrapperRef
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ handler: handler, children: children })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!wrapperRef.current || !handler) return;
        const handleMouseDown = (e)=>{
            const isLink = e.target.closest('a');
            if (isLink && e.button !== 0) handler(true);
        };
        const unbind = (0, $cbY7C.bind)(wrapperRef.current, {
            type: 'mousedown',
            listener: handleMouseDown
        });
        return unbind;
    }, [
        handler
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: wrapperRef
    }, children);
};
const $3e353c2b3e999bb0$var$ElementEventListenerContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $3e353c2b3e999bb0$export$306d19af1753a03e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ElementEventListenerProvider(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, handler: handler } = t0;
    let t1;
    if ($[0] !== children || $[1] !== handler) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3e353c2b3e999bb0$var$ElementEventListenerContext.Provider, {
            value: handler
        }, children);
        $[0] = children;
        $[1] = handler;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function ElementEventListenerProvider({ children: children, handler: handler }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3e353c2b3e999bb0$var$ElementEventListenerContext.Provider, {
        value: handler
    }, children);
};
const $3e353c2b3e999bb0$export$33f666f474b46fc2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useElementEventListenerHandler() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($3e353c2b3e999bb0$var$ElementEventListenerContext);
    return context;
} : function useElementEventListenerHandler() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($3e353c2b3e999bb0$var$ElementEventListenerContext);
    return context;
};
module.exports["ElementEventListener"] = $3e353c2b3e999bb0$export$8209b3c2d1620841;
module.exports["ElementEventListenerProvider"] = $3e353c2b3e999bb0$export$306d19af1753a03e;
module.exports["useElementEventListenerHandler"] = $3e353c2b3e999bb0$export$33f666f474b46fc2;

});

parcelRegister("7RpV7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2fc89ca90390ccac$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $0d6505890485832b$export$2e2bcd8739ae039 = {
    'navigation-global-side-navigation.object-list-flyout.empty-state.description': "Once you visit, edit, or create projects, issues, boards, filters, and dashboards, they\u2019ll show up here.",
    'navigation-global-side-navigation.object-list-flyout.empty-state.header': 'Nothing to see here!',
    'navigation-global-side-navigation.object-list-flyout.error-state.description': 'Refresh the page and try again.',
    'navigation-global-side-navigation.object-list-flyout.error-state.header': "We couldn't fetch your items",
    'navigation-global-side-navigation.object-list-flyout.loading-state.accessible-name': 'Content is loading',
    'navigation-global-side-navigation.object-list-flyout.no-results-state.description': "We couldn\u2019t find what you\u2019re looking for.",
    'navigation-global-side-navigation.object-list-flyout.no-results-state.header': 'No results',
    'navigation-global-side-navigation.object-list-flyout.starred-empty-state.description': "Mark items that are important to you with a star to quickly access them. You\u2019ll see those items here.",
    'navigation-global-side-navigation.object-list-flyout.starred-empty-state.header': "You haven't starred anything yet.",
    'navigation.global-side-navigation.customization-modal.actions-icon-button-label': 'Actions for {menuName} item',
    'navigation.global-side-navigation.customization-modal.app-items-list-description': 'The following Atlassian apps are available for your organization.',
    'navigation.global-side-navigation.customization-modal.app-items-list-label': 'App shortcuts',
    'navigation.global-side-navigation.customization-modal.app-items-list-title': 'App shortcuts',
    'navigation.global-side-navigation.customization-modal.close-button-label': 'Cancel changes to your sidebar',
    'navigation.global-side-navigation.customization-modal.close-button-text': 'Cancel',
    'navigation.global-side-navigation.customization-modal.heading-body.heading-body-text': 'Selected items will always be visible in the sidebar. You can still access unselected items from the <b>More</b> menu in the sidebar.',
    'navigation.global-side-navigation.customization-modal.heading-body.heading-body-text-info': 'The changes you make here only affect you and not anyone else on your site.',
    'navigation.global-side-navigation.customization-modal.heading-text': 'Customize your sidebar',
    'navigation.global-side-navigation.customization-modal.hide-item-action-label': 'Hide {menuName} from sidebar',
    'navigation.global-side-navigation.customization-modal.hide-item-action-text': 'Hide item from sidebar',
    'navigation.global-side-navigation.customization-modal.item-checkbox-label': '{menuName} item in sidebar',
    'navigation.global-side-navigation.customization-modal.move-item-actions-label': 'Move {menuName}',
    'navigation.global-side-navigation.customization-modal.move-item-actions-text': 'Move item within sidebar',
    'navigation.global-side-navigation.customization-modal.move-item-bottom-label': 'Move {menuName} to bottom',
    'navigation.global-side-navigation.customization-modal.move-item-bottom-text': 'Move {menuName} to bottom',
    'navigation.global-side-navigation.customization-modal.move-item-down-label': 'Move {menuName} down',
    'navigation.global-side-navigation.customization-modal.move-item-down-text': 'Move down',
    'navigation.global-side-navigation.customization-modal.move-item-top-label': 'Move {menuName} to top',
    'navigation.global-side-navigation.customization-modal.move-item-top-text': 'Move {menuName} to top',
    'navigation.global-side-navigation.customization-modal.move-item-up-label': 'Move {menuName} up',
    'navigation.global-side-navigation.customization-modal.move-item-up-text': 'Move up',
    'navigation.global-side-navigation.customization-modal.on-reorder-item-label': "You've moved {menuName} from position {fromIndex} to position {toIndex} of {numberOfItems} items.",
    'navigation.global-side-navigation.customization-modal.product-items-list-description': 'The following navigation items are available in {app}.',
    'navigation.global-side-navigation.customization-modal.product-items-list-label': 'Customize {app} navigation',
    'navigation.global-side-navigation.customization-modal.product-items-list-title': '{app} navigation',
    'navigation.global-side-navigation.customization-modal.save-button-label': 'Save customization to your sidebar',
    'navigation.global-side-navigation.customization-modal.save-button-text': 'Save changes',
    'navigation.global-side-navigation.customization-modal.show-item-action-label': 'Show {menuName} in sidebar',
    'navigation.global-side-navigation.customization-modal.show-item-action-text': 'Show item in sidebar',
    'navigation.global-side-navigation.customize-sidebar-menu-item.label': 'Customize sidebar',
    'navigation.global-side-navigation.error.description': 'Refresh the page and try again',
    'navigation.global-side-navigation.error.description.default': 'Refresh the page and try again',
    'navigation.global-side-navigation.error.header': "We couldn\u2019t load the sidebar",
    'navigation.global-side-navigation.error.header.default': "We couldn\u2019t load this content",
    'navigation.global-side-navigation.for-you.label': 'For you',
    'navigation.global-side-navigation.hide-from-sidebar-section-screen-reader': 'Dragging {item} over "Hide from navigation" drop area',
    'navigation.global-side-navigation.main-nav-item.error.description': 'Refresh the page and try again',
    'navigation.global-side-navigation.main-nav-item.error.header': "We couldn\u2019t load the item {menuId}",
    'navigation.global-side-navigation.more-menu-item.link-external-item-label': 'Open external link icon',
    'navigation.global-side-navigation.more-menu.hide-from-sidebar.label': 'Hide from sidebar',
    'navigation.global-side-navigation.more-menu.show-in-sidebar.label': 'Show in sidebar',
    'navigation.global-side-navigation.object-list-flyout.clearSearchIconLabel': 'Clear search',
    'navigation.global-side-navigation.object-list-flyout.close-button': 'Close menu',
    'navigation.global-side-navigation.object-list-flyout.filterIconLabel': 'Filters',
    'navigation.global-side-navigation.object-list-flyout.removeFilterIconLabel': 'Remove',
    'navigation.global-side-navigation.object-list-flyout.searchPlaceholder': 'Search...',
    'navigation.global-side-navigation.object-list-flyout.selectedFilters': 'Selected filters',
    'navigation.global-side-navigation.panel-splitter.label': 'Resize panel',
    'navigation.global-side-navigation.panel-splitter.tooltip-content': 'Double click to collapse',
    'navigation.global-side-navigation.primary-navigation-section-screen-reader': 'Dragging {item} over primary navigation group',
    'navigation.global-side-navigation.recents.label': 'Recent',
    'navigation.global-side-navigation.recents.viewAllRecentsLabel': 'View all recent items',
    'navigation.global-side-navigation.recentsSearchPlaceholder': 'Search recent items',
    'navigation.global-side-navigation.shortcuts-section-screen-reader': 'Dragging {item} over shortcuts group',
    'navigation.global-side-navigation.show-in-sidebar-section-screen-reader': 'Dragging {item} over "Show in navigation" drop area',
    'navigation.global-side-navigation.starred.label': 'Starred',
    'navigation.global-side-navigation.starred.viewAllStarredLabel': 'View all starred items',
    'navigation.global-side-navigation.starredSearchPlaceholder': 'Search starred items',
    'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-hidden': 'The top level menu item {label} has been hidden and moved to the More menu.',
    'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-reordered': 'The top level menu item {label} has been moved from position {startIndex} to {finishIndex}.',
    'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-unhidden': 'The top level menu item {label} has been unhidden and moved from the more menu to position {finishIndex}.',
    'navigation.global-side-navigation.use-drag-and-drop-save.a11y-announcement.item-visible': 'The top level menu item {label} has been moved from the More menu to the visible items.'
};


var $2fc89ca90390ccac$export$2e2bcd8739ae039 = (0, $0d6505890485832b$export$2e2bcd8739ae039);

});

parcelRegister("7Z7k5", function(module, exports) {

let $5d03e9144c1ef57f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5d03e9144c1ef57f$var$load("6iyAO").then(()=>parcelRequire('iqBVz'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("69CuO", function(module, exports) {

let $47b171dbf82ff4a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47b171dbf82ff4a4$var$load("dqt1s").then(()=>parcelRequire('48H8z'));

});

parcelRegister("ajKj1", function(module, exports) {

let $782f991acab02e1f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $782f991acab02e1f$var$load("eAWmj").then(()=>parcelRequire('hg70f'));

});

parcelRegister("ayPd0", function(module, exports) {

let $7b04cd5655860c28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7b04cd5655860c28$var$load("9w3DZ").then(()=>parcelRequire('238Ks'));

});

parcelRegister("63GWl", function(module, exports) {

let $469454dd6170b6e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $469454dd6170b6e9$var$load("4JqxA").then(()=>parcelRequire('dvSkS'));

});

parcelRegister("541WP", function(module, exports) {

let $3afed64b56e49dd7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3afed64b56e49dd7$var$load("kMI8I").then(()=>parcelRequire('dQpaX'));

});

parcelRegister("9WGpY", function(module, exports) {

let $73da6f2c9d0072c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73da6f2c9d0072c9$var$load("2XKEO").then(()=>parcelRequire('6jU7v'));

});

parcelRegister("v95ts", function(module, exports) {

let $05d9f1e96f92dd0f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $05d9f1e96f92dd0f$var$load("7cB8t").then(()=>parcelRequire('mZ23p'));

});

parcelRegister("iYi5G", function(module, exports) {

let $dcfbdd0a14439f95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dcfbdd0a14439f95$var$load("66vmK").then(()=>parcelRequire('4TU26'));

});

parcelRegister("4dYNh", function(module, exports) {

let $313788b0245575d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $313788b0245575d9$var$load("itu75").then(()=>parcelRequire('4vTXn'));

});

parcelRegister("7fQTc", function(module, exports) {

let $5482f5d496f0d76c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5482f5d496f0d76c$var$load("7y35H").then(()=>parcelRequire('fIDQo'));

});

parcelRegister("vVwWG", function(module, exports) {

let $05ff85b343356871$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $05ff85b343356871$var$load("jihwq").then(()=>parcelRequire('1byHu'));

});

parcelRegister("jp0z7", function(module, exports) {

let $e200ca6aedf8b047$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e200ca6aedf8b047$var$load("3uxx5").then(()=>parcelRequire('aSnqk'));

});

parcelRegister("kaPew", function(module, exports) {

let $eafc7baab9bb9f54$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eafc7baab9bb9f54$var$load("a9lw3").then(()=>parcelRequire('PY4zj'));

});

parcelRegister("jpJaH", function(module, exports) {

let $e223643ff52d5339$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e223643ff52d5339$var$load("2n84g").then(()=>parcelRequire('fr3Rk'));

});

parcelRegister("kCQFw", function(module, exports) {

let $f040362d1b4740ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f040362d1b4740ab$var$load("6xAZ0").then(()=>parcelRequire('eEUPI'));

});

parcelRegister("i6Xwr", function(module, exports) {

let $d2f6f5667f6e2e33$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d2f6f5667f6e2e33$var$load("2Y6Zu").then(()=>parcelRequire('kHlnI'));

});

parcelRegister("5PcFo", function(module, exports) {

let $43db8a7f6e26a255$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $43db8a7f6e26a255$var$load("8JQH2").then(()=>parcelRequire('1gQhQ'));

});

parcelRegister("l8tyG", function(module, exports) {

let $f631460161cca700$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f631460161cca700$var$load("jzdbf").then(()=>parcelRequire('9n6Tu'));

});

parcelRegister("ctTTt", function(module, exports) {

let $91638cc9251b0a6a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91638cc9251b0a6a$var$load("4T727").then(()=>parcelRequire('7vN8W'));

});

parcelRegister("gb0OB", function(module, exports) {

let $030a09856ce2b0d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $030a09856ce2b0d5$var$load("awyqC").then(()=>parcelRequire('2rAMO'));

});

parcelRegister("dYI8D", function(module, exports) {

let $a2d31deceea09caa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2d31deceea09caa$var$load("7NV3z").then(()=>parcelRequire('bSdxH'));

});

parcelRegister("dAVB5", function(module, exports) {

let $9e5b50bf739ef92c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e5b50bf739ef92c$var$load("g5vuL").then(()=>parcelRequire('1i8x1'));

});

parcelRegister("g8YNc", function(module, exports) {

let $bc0c8cd13c7149b5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc0c8cd13c7149b5$var$load("4Wvcm").then(()=>parcelRequire('3tXQ5'));

});

parcelRegister("gLwiW", function(module, exports) {

let $c34a1823ece66bc3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c34a1823ece66bc3$var$load("jU5zk").then(()=>parcelRequire('bOgKT'));

});

parcelRegister("bKJwb", function(module, exports) {

let $88e74c871266ec71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $88e74c871266ec71$var$load("892TL").then(()=>parcelRequire('1K7Ub'));

});

parcelRegister("7OEgn", function(module, exports) {

let $5b0c6f56fa587a49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b0c6f56fa587a49$var$load("8S0IJ").then(()=>parcelRequire('9bnSC'));

});

parcelRegister("bvtsH", function(module, exports) {

let $8609717b7a10db0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8609717b7a10db0e$var$load("diBU7").then(()=>parcelRequire('eVkwQ'));

});

parcelRegister("2VcXd", function(module, exports) {

var $30Qx8 = parcelRequire("30Qx8");

const $ddf130cca25d4aaf$var$MENU_DATA_KEY = 'nav-plat-l1-menu-data';
const $ddf130cca25d4aaf$var$SIDE_BAR_DATA_KEY = 'nav-plat-sidebar-data';
function $ddf130cca25d4aaf$export$edcad403b9bac010(params) {
    return $ddf130cca25d4aaf$var$buildNavigationAri({
        ...params,
        settingId: $ddf130cca25d4aaf$var$MENU_DATA_KEY
    });
}
function $ddf130cca25d4aaf$export$370c1cceae722446(params) {
    return $ddf130cca25d4aaf$var$buildNavigationAri({
        ...params,
        settingId: $ddf130cca25d4aaf$var$SIDE_BAR_DATA_KEY
    });
}
function $ddf130cca25d4aaf$var$buildNavigationAri(params) {
    return $ddf130cca25d4aaf$var$homeOverride((0, $30Qx8.NavigationSettingAri).create($ddf130cca25d4aaf$var$adjustParams(params)).toString());
}
// For the time being (Sept 2025), Home will be the only townsquare app that stores network settings.
// The other apps (Goals, Teams &Projects) are in the process of being individually commissioned
// (meaning they will have their own siteId and/or activationId). In the meantime, they will NOT
// be using the settings service, so we don't need an override for them.
function $ddf130cca25d4aaf$var$adjustParams(params) {
    if (params.firstPartyApp === 'home') return {
        ...params,
        settingId: `${params.settingId}-${params.firstPartyApp}`
    };
    return params;
}
function $ddf130cca25d4aaf$var$homeOverride(ari) {
    return ari.replace('/home/', '/townsquare/');
}
module.exports["buildNavigationAriForMenuData"] = $ddf130cca25d4aaf$export$edcad403b9bac010;
module.exports["buildNavigationAriForSidebarData"] = $ddf130cca25d4aaf$export$370c1cceae722446;

});

parcelRegister("7EBfr", function(module, exports) {

let $5929298695214853$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5929298695214853$var$load("eRhBr"),
    $5929298695214853$var$load("lgIhe"),
    $5929298695214853$var$load("7EorR"),
    $5929298695214853$var$load("Wowvf"),
    $5929298695214853$var$load("kofza")
]).then(()=>parcelRequire('cvy4b'));

});

parcelRegister("1K9mF", function(module, exports) {
const $8944909d55cd81a0$export$3a4f595511a311c = 'globalMoreMenuLoad';
const $8944909d55cd81a0$export$442bdbffe3dfb793 = 'global-more-menu-load';
module.exports["GLOBAL_MORE_MENU_INTERACTION_ID"] = $8944909d55cd81a0$export$3a4f595511a311c;
module.exports["GLOBAL_MORE_MENU_INTERACTION_NAME"] = $8944909d55cd81a0$export$442bdbffe3dfb793;

});

parcelRegister("fZMfl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $15d6505d7a084c03$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $64a2d3197171f730$export$2e2bcd8739ae039 = {
    'navigation.global-more-menu.error.description': 'Refresh the page and try again',
    'navigation.global-more-menu.error.global-more-menu-item.error.description': 'Refresh the page and try again',
    'navigation.global-more-menu.error.header': "We couldn\u2019t load more sidebar options",
    'navigation.global-more-menu.global-more-menu-item.error.header': "We couldn\u2019t load {menuId} in more options",
    'navigation.global-more-menu.trigger-label': 'More'
};


var $15d6505d7a084c03$export$2e2bcd8739ae039 = (0, $64a2d3197171f730$export$2e2bcd8739ae039);

});

parcelRegister("ldUti", function(module, exports) {

let $f7369de9dea63e06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7369de9dea63e06$var$load("cTJ6a").then(()=>parcelRequire('42Jlm'));

});

parcelRegister("55rcS", function(module, exports) {

let $3b42860d1f2eb7fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b42860d1f2eb7fa$var$load("9f0rd").then(()=>parcelRequire('daFyv'));

});

parcelRegister("8uv6r", function(module, exports) {

let $62e94073584ce116$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62e94073584ce116$var$load("glTuI").then(()=>parcelRequire('4xesC'));

});

parcelRegister("k5Rvi", function(module, exports) {

let $ea0dc6fcda7b8d41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ea0dc6fcda7b8d41$var$load("fv8xw").then(()=>parcelRequire('2Vh9m'));

});

parcelRegister("bInGL", function(module, exports) {

let $88762de144276e75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $88762de144276e75$var$load("aOl3i").then(()=>parcelRequire('bdAVD'));

});

parcelRegister("2JfQu", function(module, exports) {

let $1fcc1359f7006fa7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1fcc1359f7006fa7$var$load("elQeg").then(()=>parcelRequire('1JtUT'));

});

parcelRegister("dZAP2", function(module, exports) {

let $a2fd88fe64bf7660$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2fd88fe64bf7660$var$load("1MuC6").then(()=>parcelRequire('5KvvK'));

});

parcelRegister("hJsAN", function(module, exports) {

let $ce8cd186c240cb25$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce8cd186c240cb25$var$load("16h60").then(()=>parcelRequire('kicUM'));

});

parcelRegister("5I5ax", function(module, exports) {

let $42851244be6aabed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42851244be6aabed$var$load("lz93S").then(()=>parcelRequire('cytr8'));

});

parcelRegister("hxfIm", function(module, exports) {

let $cc41b54811f4b0c8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cc41b54811f4b0c8$var$load("aQbl2").then(()=>parcelRequire('1ZmS4'));

});

parcelRegister("eAVG3", function(module, exports) {

let $aa012afd24bde76c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa012afd24bde76c$var$load("ijyX1").then(()=>parcelRequire('2cZOg'));

});

parcelRegister("8lMto", function(module, exports) {

let $6145e2a18506aa9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6145e2a18506aa9b$var$load("7UoWC").then(()=>parcelRequire('kXmka'));

});

parcelRegister("k0AEC", function(module, exports) {

let $e9103d783d90db71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9103d783d90db71$var$load("c779a").then(()=>parcelRequire('91Fcb'));

});

parcelRegister("kgzep", function(module, exports) {

let $ec10a17951282ac9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec10a17951282ac9$var$load("aFEgG").then(()=>parcelRequire('hCDDD'));

});

parcelRegister("3KWD2", function(module, exports) {

let $2bc3256573242d8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2bc3256573242d8b$var$load("5IVcq").then(()=>parcelRequire('8lOvA'));

});

parcelRegister("9unjC", function(module, exports) {

let $6e89005a6d062aba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e89005a6d062aba$var$load("g3IAU").then(()=>parcelRequire('24h91'));

});

parcelRegister("7pbJK", function(module, exports) {

let $5643f8ea789cab06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5643f8ea789cab06$var$load("84h5v").then(()=>parcelRequire('5VKkJ'));

});

parcelRegister("ct4lI", function(module, exports) {

let $913b91210d60eab1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $913b91210d60eab1$var$load("9AjJR").then(()=>parcelRequire('LwSSb'));

});

parcelRegister("16IXY", function(module, exports) {

let $0ce93b554c3f5fcc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0ce93b554c3f5fcc$var$load("HJfe7").then(()=>parcelRequire('5Pxsl'));

});

parcelRegister("jecWh", function(module, exports) {

let $dff95c86dc545502$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dff95c86dc545502$var$load("ATWna").then(()=>parcelRequire('4pFdV'));

});

parcelRegister("5u5UZ", function(module, exports) {

let $3fe4585738e0df59$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3fe4585738e0df59$var$load("dAccR").then(()=>parcelRequire('lO31Q'));

});

parcelRegister("hiyXn", function(module, exports) {

let $c97f3bc386a20b45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c97f3bc386a20b45$var$load("jdkvK").then(()=>parcelRequire('dTUbJ'));

});

parcelRegister("2SxF3", function(module, exports) {

let $218abc4d4fd7dd9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $218abc4d4fd7dd9f$var$load("1gQM2").then(()=>parcelRequire('lsuRD'));

});

parcelRegister("cLunN", function(module, exports) {

let $94b1713cd08aaea0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $94b1713cd08aaea0$var$load("fgECB").then(()=>parcelRequire('3p3x8'));

});

parcelRegister("fIOP1", function(module, exports) {

let $b7226344d7fd20f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b7226344d7fd20f1$var$load("dLwEq").then(()=>parcelRequire('66V7d'));

});

parcelRegister("4iUgC", function(module, exports) {

let $32247d55f1ed424f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32247d55f1ed424f$var$load("kM8DZ").then(()=>parcelRequire('lEkD9'));

});

parcelRegister("e3JnQ", function(module, exports) {

let $a3c48cc0bab4ca7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3c48cc0bab4ca7f$var$load("lyD3x").then(()=>parcelRequire('BG23o'));

});

parcelRegister("9rgB5", function(module, exports) {

let $6df3828504c5a591$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6df3828504c5a591$var$load("90GNq").then(()=>parcelRequire('hIG3R'));

});

parcelRegister("2BWHC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

const $c1472e8714e56c9a$var$initialValue = {
    appItemsData: [],
    productItemsData: []
};
const $c1472e8714e56c9a$export$84a8bfdb704f8dd7 = /*#__PURE__*/ (0, $cozmU.createContext)($c1472e8714e56c9a$var$initialValue);
function $c1472e8714e56c9a$export$d8b714c1cef53925(props) {
    const { appItemsData: appItemsData, children: children, productItemsData: productItemsData } = props;
    const previousValue = (0, $cozmU.useRef)($c1472e8714e56c9a$var$initialValue);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previousValue.current.appItemsData, appItemsData) || !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previousValue.current.productItemsData, productItemsData)) previousValue.current = {
        appItemsData: appItemsData,
        productItemsData: productItemsData
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c1472e8714e56c9a$export$84a8bfdb704f8dd7.Provider, {
        value: previousValue.current
    }, children);
}
const $c1472e8714e56c9a$export$6c1aeecd45a1d0f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function usePopupData() {
    return (0, $cozmU.useContext)($c1472e8714e56c9a$export$84a8bfdb704f8dd7);
} : function usePopupData() {
    return (0, $cozmU.useContext)($c1472e8714e56c9a$export$84a8bfdb704f8dd7);
};
module.exports["PopupDataProvider"] = $c1472e8714e56c9a$export$d8b714c1cef53925;
module.exports["usePopupData"] = $c1472e8714e56c9a$export$6c1aeecd45a1d0f2;

});

parcelRegister("kJwFk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $9f24f169d68e9427$export$9143519b12af0141({ item: item, otherProps: otherProps = {} }) {
    const listItemRef = (0, $cozmU.useRef)(null);
    const itemWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(item) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(item, {
        ...otherProps,
        listItemRef: listItemRef
    }) : item;
    (0, $cozmU.useEffect)(()=>{
        listItemRef?.current?.removeAttribute('role');
    }, []);
    return itemWithRef;
}
module.exports["useStandaloneButtonMenuItem"] = $9f24f169d68e9427$export$9143519b12af0141;

});

parcelRegister("13HE4", function(module, exports) {

let $0c57ed51de9cc3c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0c57ed51de9cc3c6$var$load("7EorR"),
    $0c57ed51de9cc3c6$var$load("8SF4r")
]).then(()=>parcelRequire('dlqcL'));

});

parcelRegister("6Kz1B", function(module, exports) {

let $4ea23527b7d57a0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4ea23527b7d57a0c$var$load("6wr18"),
    $4ea23527b7d57a0c$var$load("ffEVr"),
    $4ea23527b7d57a0c$var$load("5BxeZ"),
    $4ea23527b7d57a0c$var$load("7EorR"),
    $4ea23527b7d57a0c$var$load("kHXvF"),
    $4ea23527b7d57a0c$var$load("gub2x")
]).then(()=>parcelRequire('igbE9'));

});


//# sourceMappingURL=ConversationAssistant.e454c096.js.map
